/* =========================================================
   BORBA theme — interactions (vanilla JS, no dependencies)
   ========================================================= */
(function () {
  'use strict';

  var B = window.BORBA || {};
  var routes = B.routes || {};
  var strings = B.strings || {};
  var root = document.documentElement;
  /* width of the page scrollbar (0 when hidden or an overlay scrollbar) — for photos that span the whole window */
  function setSbw() { root.style.setProperty('--sbw', Math.max(0, window.innerWidth - root.offsetWidth) + 'px'); }
  setSbw(); window.addEventListener('resize', setSbw);

  /* ---------- Utilities ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }
  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      if (value === null) localStorage.removeItem(key); else localStorage.setItem(key, value);
    } catch (e) { return null; }
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
  var canHover = function () { return window.matchMedia('(hover: hover)').matches; };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || B.moneyFormat || '€{{amount_with_comma_separator}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var toastTimer;
  function toast(msg) {
    var el = qs('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- Day / night mode ---------- */
  // Modes: light (day), dark (night) and funky. Funky uses the night colours plus data-funky="on".
  function currentMode() {
    return root.getAttribute('data-funky') === 'on' ? 'funky' : (root.getAttribute('data-mode') || 'light');
  }
  function setMode(mode) {
    if (mode === 'funky' && root.getAttribute('data-funky-enabled') !== 'on') mode = 'dark';
    root.classList.add('mode-switching');
    root.setAttribute('data-mode', mode === 'funky' ? 'dark' : mode);
    if (mode === 'funky') root.setAttribute('data-funky', 'on'); else root.removeAttribute('data-funky');
    try {
      var mem = root.getAttribute('data-mode-memory') === 'always' ? localStorage : sessionStorage;
      mem.setItem('borba-mode', mode);
    } catch (e) {}
    setTimeout(function () { root.classList.remove('mode-switching'); }, 500);
    document.dispatchEvent(new CustomEvent('borba:mode', { detail: { mode: mode } }));
  }
  function closeModePops(except) {
    qsa('[data-mode-picker].is-open').forEach(function (p) {
      if (p === except) return;
      p.classList.remove('is-open');
      var b = qs('[data-mode-toggle]', p);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function initMode() {
    qsa('[data-mode-toggle]').forEach(function (btn) {
      if (btn._bound) return; btn._bound = true;
      var picker = btn.closest('[data-mode-picker]');
      var pop = picker && qs('[data-mode-pop]', picker);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!pop) { setMode(currentMode() === 'light' ? 'dark' : 'light'); return; }
        var open = !picker.classList.contains('is-open');
        closeModePops(picker);
        picker.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (pop) {
        qsa('[data-mode-set]', pop).forEach(function (opt) {
          opt.addEventListener('click', function (e) {
            e.stopPropagation();
            setMode(opt.getAttribute('data-mode-set'));
            closeModePops();
            btn.focus({ preventScroll: true });
          });
        });
      }
    });
    if (!root._modeDocBound) {
      root._modeDocBound = true;
      document.addEventListener('click', function (e) { if (!e.target.closest('[data-mode-picker]')) closeModePops(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModePops(); });
      window.addEventListener('scroll', function () { closeModePops(); }, { passive: true });
    }
  }

  /* ---------- Feed / grid view ---------- */
  function initViewToggle() {
    qsa('[data-view-toggle]').forEach(function (btn) {
      if (btn._bound) return; btn._bound = true;
      btn.addEventListener('click', function () {
        /* just switch the view: no jumping. If you were looking at products, the same product stays in view;
           if you were at the banner (or anywhere else), the page stays where it is. */
        var vh = window.innerHeight, anchor = null;
        qsa('.slide').some(function (s) {
          var r = s.getBoundingClientRect();
          if (r.bottom > vh * 0.35 && r.top < vh * 0.65) { anchor = s; return true; }
          return false;
        });
        var anchorTop = anchor ? anchor.getBoundingClientRect().top : 0;
        var y = window.scrollY, wasFree = root.classList.contains('snap-free');
        root.classList.add('snap-free');
        var grid = root.classList.toggle('view-grid');
        store('borba-view', grid ? 'grid' : 'feed');
        if (!grid) qsa('[data-feed-root]').forEach(measureFeedInfo);
        if (anchor) window.scrollBy(0, anchor.getBoundingClientRect().top - anchorTop);
        else window.scrollTo(0, y);
        requestAnimationFrame(function () {
          refitAll();
          if (!grid) updateAllGaps();
          if (!wasFree) root.classList.remove('snap-free');
        });
      });
    });
  }

  /* ---------- Drawers (cart, menu, search) ---------- */
  var openDrawerEl = null;
  function scrim(show) {
    var s = qs('[data-scrim]');
    if (!s) return;
    if (show) {
      s.hidden = false;
      requestAnimationFrame(function () { s.classList.add('is-visible'); });
    } else {
      s.classList.remove('is-visible');
      setTimeout(function () { if (!s.classList.contains('is-visible')) s.hidden = true; }, 350);
    }
  }
  /* "You may also like" slides up only after the chosen delay (Thema-instellingen → Winkelwagen) */
  function upsellReveal(scope) {
    qsa('[data-upsell-reveal]', scope).forEach(function (w) {
      var d = parseFloat(w.getAttribute('data-delay')) || 0;
      clearTimeout(w._ur);
      if (d <= 0) { w.classList.remove('is-waiting'); return; }
      w.classList.add('no-anim', 'is-waiting'); void w.offsetHeight; w.classList.remove('no-anim');
      w._ur = setTimeout(function () {
        w.classList.remove('is-waiting');
        var b = qs('[data-upsell]', w); if (b && b._car) b._car.measure();
      }, d * 1000);
    });
  }
  function openDrawer(id) {
    if (id === 'CartDrawer' || (id && id.id === 'CartDrawer')) {
      /* the "You may also like" row always opens up again (unless it should start closed) */
      qsa('[data-upsell].is-closed').forEach(function (box) {
        if (box.hasAttribute('data-upsell-remember') || box.getAttribute('data-upsell-start') === 'closed') return;
        box.classList.remove('is-closed');
        qsa('.upsell__chev', box).forEach(function (c) { c.setAttribute('aria-expanded', 'true'); });
      });
    }
    var el = document.getElementById(id);
    if (!el) return false;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(true);
    closeFacets();
    if (el.id === 'CartDrawer' && !el.classList.contains('is-open')) upsellReveal(el);
    el.classList.add('is-open');
    root.classList.toggle('menu-open', el.id === 'MenuDrawer');
    el.setAttribute('aria-hidden', 'false');
    openDrawerEl = el;
    scrim(true);
    root.classList.add('is-locked');
    var focusTarget = qs('[data-predictive-input]', el) || el;
    setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 60);
    return true;
  }
  function closeDrawer(keepScrim) {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open');
    openDrawerEl.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    root.classList.remove('menu-open');
    if (!keepScrim) { scrim(false); root.classList.remove('is-locked'); }
  }

  /* menu button: one-shot click animations (wave / spin) */
  document.addEventListener('click', function (e) {
    var mt = e.target.closest('.menu-toggle');
    if (!mt) return;
    var a = mt.getAttribute('data-menu-anim');
    if (a !== 'wave' && a !== 'spin') return;
    mt.classList.remove('mt-play'); void mt.offsetWidth; mt.classList.add('mt-play');
    clearTimeout(mt._mt);
    mt._mt = setTimeout(function () { mt.classList.remove('mt-play'); }, (parseFloat(getComputedStyle(mt).getPropertyValue('--mt-dur')) || 450) * 1.6 + 50);
  });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var targetId = opener.getAttribute('data-drawer-open');
      if (openDrawerEl && openDrawerEl.id === targetId) { e.preventDefault(); closeDrawer(); return; }
      if (openDrawer(targetId)) e.preventDefault();
      return;
    }
    // FAQ item: on the same page, close the menu and glide to the FAQ
    var faq = e.target.closest('[data-menu-faq]');
    if (faq) {
      var u = new URL(faq.href, location.href);
      var tgt = u.hash && u.pathname === location.pathname ? document.getElementById(u.hash.slice(1)) : null;
      if (tgt) { e.preventDefault(); closeDrawer(); setTimeout(function () { tgt.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80); return; }
    }
    // Clicking a link inside the menu panel closes it (for same-page anchors)
    if (openDrawerEl && openDrawerEl.id === 'MenuDrawer' && !e.target.closest('[data-menu-panel]') && !e.target.closest('[data-header]')) {
      closeDrawer();
    }
    if (e.target.closest('[data-drawer-close]')) {
      var link = e.target.closest('a[data-drawer-close]');
      if (!link || link.getAttribute('href') === '#') e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.target.closest('[data-scrim]')) { closeDrawer(); closeFacets(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeFacets();
    qsa('.modal.is-open').forEach(closeModal);
    qsa('.zoom-overlay.is-open, .lightbox.is-open').forEach(function (o) { o.classList.remove('is-open'); root.classList.remove('is-locked'); });
  });

  /* ---------- Smart back ---------- */
  function initBack() {
    // Remember the previous page inside the shop, so "back" never lands on an outside or broken page
    var prev = null;
    try {
      prev = sessionStorage.getItem('borba-cur');
      if (prev === location.href) prev = sessionStorage.getItem('borba-prev');
      else { sessionStorage.setItem('borba-prev', prev || ''); sessionStorage.setItem('borba-cur', location.href); }
    } catch (e) {}
    qsa('[data-smart-back]').forEach(function (btn) {
      if (btn._bound) return; btn._bound = true;
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-fallback') || routes.root || '/';
        try {
          if (prev && !B.designMode && new URL(prev).host === location.host && prev !== location.href) target = prev;
        } catch (e) {}
        try { sessionStorage.setItem('borba-skip-enter', '1'); } catch (e) {}
        location.href = target;
      });
    });
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement() {
    qsa('[data-announcement-rotator]').forEach(function (el) {
      if (el._bound) return; el._bound = true;
      var items = qsa('.announcement__item', el);
      if (items.length < 2) return;
      var bar = el.closest('[data-announcement]');
      var wait = ((bar && parseInt(bar.getAttribute('data-interval'), 10)) || 4) * 1000;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, wait);
    });
  }

  /* ---------- Image carousels inside slides ---------- */
  function initCarousels(ctx) {
    qsa('[data-carousel]', ctx).forEach(function (car) {
      if (car._bound) return; car._bound = true;
      var track = qs('[data-carousel-track]', car);
      if (!track) return;
      var dots = qsa('.dots__dot', car);
      var frames = track.children;
      var update = function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      };
      track.addEventListener('scroll', debounce(update, 40), { passive: true });
      var go = function (dir) {
        var i = Math.round(track.scrollLeft / track.clientWidth) + dir;
        if (i < 0) i = frames.length - 1;
        if (i >= frames.length) i = 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      };
      var prev = qs('[data-carousel-prev]', car), next = qs('[data-carousel-next]', car);
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    });
  }

  /* ---------- Horizontal rails (content sections) ---------- */
  function initRails(ctx) {
    fitCards(ctx);
    qsa('[data-rail]', ctx).forEach(function (wrap) {
      if (wrap._bound) return; wrap._bound = true;
      var track = qs('[data-rail-track]', wrap);
      var prev = qs('[data-rail-prev]', wrap), next = qs('[data-rail-next]', wrap);
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var nav = qs('.rail__nav', wrap);
        if (nav) nav.hidden = max <= 0;
        wrap.classList.toggle('has-nav', max > 0);
        /* fewer products than fit in a row: mark it so the row can sit centred instead of leaving an empty gap on the right */
        track.classList.toggle('is-fit', max <= 0);
        var media = qs('.pcard__media, img', track);
        if (media && media.offsetHeight) { var mr = media.getBoundingClientRect(), wr = wrap.getBoundingClientRect(); wrap.style.setProperty('--rail-arrow-top', Math.round(mr.top - wr.top + mr.height / 2) + 'px'); }
      }
      function step(dir) {
        var item = qs('.rail__item', track);
        var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', debounce(update, 60), { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      window.addEventListener('load', update);
      update();
    });
  }

  /* ---------- Auto-fit product photos ----------
     Finds the garment inside each photo (ignores transparent/white borders) and scales/places it so every
     product fills its box the same way and sits on the same line. Falls back to the plain photo if anything fails. */
  var FIT_KEY = 'borba-fit-v2', fitCache = {};
  try { fitCache = JSON.parse(localStorage.getItem(FIT_KEY) || '{}') || {}; } catch (e) { fitCache = {}; }
  var fitSave = debounce(function () {
    try {
      var keys = Object.keys(fitCache);
      if (keys.length > 400) keys.slice(0, keys.length - 400).forEach(function (k) { delete fitCache[k]; });
      localStorage.setItem(FIT_KEY, JSON.stringify(fitCache));
    } catch (e) {}
  }, 500);
  function fitKey(src) {
    try { var u = new URL(src, location.href); return u.host + u.pathname; } catch (e) { return src; }
  }
  function analyseImage(src, cb) {
    var key = fitKey(src);
    if (fitCache[key] !== undefined) return cb(fitCache[key]);
    var url;
    try { url = new URL(src, location.href); url.searchParams.set('width', '200'); url.searchParams.delete('height'); url.searchParams.delete('crop'); url = url.href; } catch (e) { return cb(null); }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.decoding = 'async';
    im.onload = function () {
      var box = null;
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h) throw 0;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h).data;
        /* background = the corners */
        var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
        var transparent = corners.every(function (o) { return d[o + 3] < 16; });
        var br = 0, bg = 0, bb = 0;
        corners.forEach(function (o) { br += d[o]; bg += d[o + 1]; bb += d[o + 2]; });
        br /= 4; bg /= 4; bb /= 4;
        var x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var o = (y * w + x) * 4, on;
            if (transparent) on = d[o + 3] > 24;
            else on = d[o + 3] > 24 && (Math.abs(d[o] - br) + Math.abs(d[o + 1] - bg) + Math.abs(d[o + 2] - bb)) > 42;
            if (on) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
        }
        if (x1 > x0 && y1 > y0) {
          box = { l: x0 / w, t: y0 / h, r: (x1 + 1) / w, b: (y1 + 1) / h, a: w / h, op: !transparent };
          if (box.r - box.l < 0.08 || box.b - box.t < 0.08) box = null; /* almost empty: leave alone */
        }
      } catch (e) { box = null; }
      fitCache[key] = box; fitSave();
      cb(box);
    };
    im.onerror = function () { cb(null); };
    im.src = url;
  }
  function placeFit(img) {
    var box = img._fitBox, frame = img.parentElement;
    if (!box || !frame) return;
    var grid = root.classList.contains('view-grid');
    if (grid && root.getAttribute('data-grid-ratio') === 'natural') { unFit(img); return; }
    /* the frame can have extra (empty) room left and right for the glow: place inside the real photo box */
    var fcs = getComputedStyle(frame), pl = parseFloat(fcs.paddingLeft) || 0, pr = parseFloat(fcs.paddingRight) || 0;
    var W = frame.clientWidth - pl - pr, H = frame.clientHeight;
    if (W < 10 || H < 10) return;
    var fill = (parseFloat(root.getAttribute(grid ? 'data-grid-fill' : 'data-img-fill')) || parseFloat(root.getAttribute('data-img-fill')) || 90) / 100;
    var cw = (box.r - box.l) * box.a, ch = box.b - box.t;           /* garment size in units of image height */
    var k = Math.min(W * fill / cw, H * fill / ch);                 /* px per image-height unit */
    var iw = box.a * k, ih = k;
    var left = pl + W / 2 - ((box.l + box.r) / 2) * iw;
    var align = grid ? (root.getAttribute('data-grid-align') || 'center') : 'center';
    var pad = H * (1 - fill) / 2, top;
    if (align === 'bottom') top = H - pad - box.b * ih;
    else if (align === 'top') top = pad - box.t * ih;
    else top = H / 2 - ((box.t + box.b) / 2) * ih;
    img.classList.add('is-fit');
    img.style.width = iw + 'px'; img.style.height = ih + 'px';
    img.style.left = left + 'px'; img.style.top = top + 'px';
    img.style.transformOrigin = (((box.l + box.r) / 2) * 100) + '% ' + (((box.t + box.b) / 2) * 100) + '%';
    /* a photo bigger than the box is still cut at the photo box (not at the extra glow room) */
    img.style.clipPath = (pl || pr) ? 'inset(' + Math.max(0, -top).toFixed(1) + 'px ' + Math.max(0, left + iw - (pl + W)).toFixed(1) + 'px ' + Math.max(0, top + ih - H).toFixed(1) + 'px ' + Math.max(0, pl - left).toFixed(1) + 'px)' : '';
    frame.classList.toggle('is-opaque', !!box.op);
    img._softBox = box; featherImg(img, box);
    updateSlideGap(img.closest('.slide'));
  }
  function unFit(img) {
    img.classList.remove('is-fit');
    ['width', 'height', 'left', 'top', 'transformOrigin', 'clipPath'].forEach(function (p) { img.style[p] = ''; });
    if (img._softBox !== undefined) featherImg(img, img._softBox);
  }
  var fitObserver = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) { qsa('img.slide__img', en.target).forEach(placeFit); });
  }) : null;
  /* Name + price sit a fixed distance under the garment itself (not under the empty edge of its photo box),
     so "Ruimte tussen foto en naam" is the real distance. On phones the whole product (garment + name + price)
     is centred on the screen. */
  function updateSlideGap(slide) {
    if (!slide || root.classList.contains('view-grid')) return;
    var media = qs('.slide__media', slide);
    if (!media) return;
    var H = media.clientHeight, W = media.clientWidth;
    if (H < 10) return;
    var ext = null;
    qsa('img.slide__img', slide).forEach(function (img) {
      var t, b;
      if (img.classList.contains('is-fit') && img._fitBox) {
        var ih = parseFloat(img.style.height), top = parseFloat(img.style.top);
        if (!ih) return;
        t = top + img._fitBox.t * ih; b = top + img._fitBox.b * ih;
        var iw = parseFloat(img.style.width), lf = (parseFloat(img.style.left) || 0) - (parseFloat(getComputedStyle(img.parentElement).paddingLeft) || 0);
        var L = lf + img._fitBox.l * iw, R = lf + img._fitBox.r * iw;
      } else if (img._fitInit && !img._fitDone) {
        return; /* auto-fit still measuring this photo: placeFit() calls back when it is placed */
      } else if (img.naturalWidth && img.naturalHeight) {
        var fr = img.parentElement, frs = fr ? getComputedStyle(fr) : null;
        var fw = (fr && (fr.clientWidth - (parseFloat(frs.paddingLeft) || 0) - (parseFloat(frs.paddingRight) || 0))) || W, fh = (fr && fr.clientHeight) || H;
        var rh = Math.min(fh, fw * img.naturalHeight / img.naturalWidth), rw = Math.min(fw, fh * img.naturalWidth / img.naturalHeight);
        t = (fh - rh) / 2; b = t + rh;
        var L = (fw - rw) / 2, R = L + rw;
      } else return;
      if (!ext) ext = { t: t, b: b, r: R }; else { ext.t = Math.min(ext.t, t); ext.b = Math.max(ext.b, b); ext.r = Math.max(ext.r, R); }
    });
    if (!ext) return;
    ext.t = Math.max(0, ext.t); ext.b = Math.min(H, ext.b);
    slide.style.setProperty('--fit-gap', (H - ext.b).toFixed(1) + 'px');
    slide.style.setProperty('--fit-side', Math.max(0, W - Math.min(W, ext.r)).toFixed(1) + 'px');
    var info = qs('.slide__info', slide);
    var gap = parseFloat(getComputedStyle(slide).getPropertyValue('--feed-info-gap')) || 0;
    var groupMid = (ext.t + ext.b + gap + 8 + (info ? info.offsetHeight : 0)) / 2;
    slide.style.setProperty('--grp-shift', (H / 2 - groupMid).toFixed(1) + 'px');
  }
  function updateAllGaps(ctx) { qsa('.slide', ctx || document).forEach(updateSlideGap); }
  function initSlideGaps(ctx) {
    qsa('img.slide__img', ctx).forEach(function (img) {
      if (img._gapInit) return; img._gapInit = true;
      if (img.complete) updateSlideGap(img.closest('.slide'));
      else img.addEventListener('load', function () { updateSlideGap(img.closest('.slide')); });
    });
  }
  window.addEventListener('resize', debounce(function () { updateAllGaps(); }, 150));

  /* ---------- Soft edges for photos with their own background (model shots …) ----------
     The photo's empty border melts softly into the page on all four sides, so you never see where the photo
     ends; the soft part stays in the empty border (never on the model or the garment). Cut-out photos (PNG with
     a transparent background) are left alone. Everywhere: feed, grid, product cards, product page, cart. */
  var SOFT_SEL = 'img.slide__img, img.pcard__img, img.product__img, .upsell__img img';
  function softPct() { return parseFloat(root.getAttribute('data-soft-edge')) || 0; }
  function featherImg(img, box) {
    var pct = softPct();
    if (!box || !box.op || !pct) { if (img._soft) { img.style.webkitMaskImage = img.style.maskImage = ''; img.style.webkitMaskComposite = img.style.maskComposite = ''; img._soft = false; } return; }
    var w = img.offsetWidth, h = img.offsetHeight;
    if (!w || !h) return;
    var x0 = 0, y0 = 0, pw = w, ph = h;
    if (!img.classList.contains('is-fit')) {
      /* where the picture is drawn inside the image box (padding + object-fit: contain + object-position) */
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) { if (!img._softWait) { img._softWait = true; img.addEventListener('load', function () { img._softWait = false; featherImg(img, box); }, { once: true }); } return; }
      var cs = getComputedStyle(img);
      var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0, pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
      var cw = w - pl - pr, ch = h - pt - pb; if (cw <= 0 || ch <= 0) return;
      var fit = cs.objectFit, k = fit === 'cover' ? Math.max(cw / nw, ch / nh) : (fit === 'fill' ? 0 : Math.min(cw / nw, ch / nh));
      pw = k ? nw * k : cw; ph = k ? nh * k : ch;
      var pos = (cs.objectPosition || '50% 50%').split(' ');
      function off(v, free) { v = v || '50%'; return v.indexOf('%') > -1 ? free * parseFloat(v) / 100 : (parseFloat(v) || 0); }
      x0 = pl + off(pos[0], cw - pw); y0 = pt + off(pos[1], ch - ph);
    }
    /* the part you actually see: the picture, cut by the box it sits in (a big photo is cut by its photo box) */
    var vx0 = x0, vx1 = x0 + pw, vy0 = y0, vy1 = y0 + ph;
    var clip = img.closest('.slide__frame, .pcard__media, .zoom-frame, .upsell__img');
    if (clip) {
      var ir = img.getBoundingClientRect(), cr = clip.getBoundingClientRect(), ccs = getComputedStyle(clip);
      var sx = w / (ir.width || w), sy = h / (ir.height || h);
      var cl = cr.left + (parseFloat(ccs.paddingLeft) || 0), crr = cr.right - (parseFloat(ccs.paddingRight) || 0);
      vx0 = Math.max(vx0, (cl - ir.left) * sx); vx1 = Math.min(vx1, (crr - ir.left) * sx);
      vy0 = Math.max(vy0, (cr.top - ir.top) * sy); vy1 = Math.min(vy1, (cr.bottom - ir.top) * sy);
      if (vx1 - vx0 < 10 || vy1 - vy0 < 10) { vx0 = x0; vx1 = x0 + pw; vy0 = y0; vy1 = y0 + ph; }
    }
    /* the model / garment itself: the soft part never reaches it */
    var gx0 = x0 + box.l * pw, gx1 = x0 + box.r * pw, gy0 = y0 + box.t * ph, gy1 = y0 + box.b * ph;
    var F = Math.min(vx1 - vx0, vy1 - vy0) * pct / 100;
    var fl = Math.max(0, Math.min(F, (gx0 - vx0) * 0.9)), fr = Math.max(0, Math.min(F, (vx1 - gx1) * 0.9));
    var ft = Math.max(0, Math.min(F, (gy0 - vy0) * 0.9)), fb = Math.max(0, Math.min(F, (vy1 - gy1) * 0.9));
    function P(v, of) { return (v / of * 100).toFixed(2) + '%'; }
    var gx = 'linear-gradient(to right, transparent ' + P(vx0, w) + ', #000 ' + P(vx0 + fl, w) + ', #000 ' + P(vx1 - fr, w) + ', transparent ' + P(vx1, w) + ')';
    var gy = 'linear-gradient(to bottom, transparent ' + P(vy0, h) + ', #000 ' + P(vy0 + ft, h) + ', #000 ' + P(vy1 - fb, h) + ', transparent ' + P(vy1, h) + ')';
    img.style.webkitMaskImage = img.style.maskImage = gx + ', ' + gy;
    img.style.webkitMaskComposite = 'source-in'; img.style.maskComposite = 'intersect';
    img._soft = true;
  }
  function initFeather(ctx) {
    if (!softPct()) return;
    qsa(SOFT_SEL, ctx).forEach(function (img) {
      if (img._softBox !== undefined) { featherImg(img, img._softBox); return; }
      var src = img.currentSrc || img.getAttribute('src');
      if (!src || src.indexOf('data:') === 0) return;
      if (img._softAsk) return; img._softAsk = true;
      analyseImage(src, function (box) { img._softBox = box; featherImg(img, box); });
    });
  }
  function initAutoFit(ctx) {
    initFeather(ctx);
    if (root.getAttribute('data-img-fit') !== 'on') return;
    qsa('img.slide__img', ctx).forEach(function (img) {
      if (img._fitInit) return; img._fitInit = true;
      var src = img.currentSrc || img.getAttribute('src');
      if (!src || src.indexOf('data:') === 0) return;
      analyseImage(src, function (box) {
        img._fitDone = true;
        if (!box) { updateSlideGap(img.closest('.slide')); return; }
        /* nothing to trim: the photo already fills its box edge to edge */
        img._fitBox = box;
        placeFit(img);
        if (fitObserver && img.parentElement) fitObserver.observe(img.parentElement);
      });
    });
  }
  function refitAll() { qsa('img.slide__img.is-fit').forEach(placeFit); }

  /* ---------- Product panel: smooth uitklapblokken ----------
     Desktop (sideways / carousel photos): the panel sits at a fixed spot and simply grows downwards; the page
     makes room and follows smoothly. All closed again -> back to the top. Mobile: the same smooth open/close. */
  function initPanelGrow(ctx) {
    var mq = window.matchMedia('(min-width: 990px)');
    qsa('.product__panel', ctx).forEach(function (panel) {
      if (panel._growBound) return; panel._growBound = true;
      var product = panel.closest('.product');
      var stickyMode = product && product.classList.contains('product--desk-v');
      function room(extra) {
        /* make the page tall enough for the panel (desktop, non-sticky layouts) */
        if (!product) return;
        if (!mq.matches || stickyMode) { product.style.minHeight = ''; return; }
        /* the panel's own place (its top margin), not where it is stuck while scrolling */
        var need = (parseFloat(getComputedStyle(panel).marginTop) || 0) + panel.offsetHeight + (extra || 0) + 60;
        product.style.minHeight = need + 'px';
      }
      function headerBottom() {
        var h = qs('.site-header');
        return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
      }
      function follow(sum, bodyH) {
        var top = sum.getBoundingClientRect().top;
        var bottom = sum.getBoundingClientRect().bottom + bodyH;
        var over = bottom - (window.innerHeight - 24);
        var space = top - headerBottom() - 16;
        var by = Math.min(over, space);
        if (by > 4) window.scrollBy({ top: by, behavior: 'smooth' });
      }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function ease(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
      /* one animation loop moves the text height AND the page together: no fighting, no hiccups */
      function run(d, body, from, to, scrollFrom, scrollTo, dur, end) {
        root.classList.add('is-busy');
        body.style.overflow = 'hidden';
        var pad = parseFloat(getComputedStyle(body).paddingBottom) || 0, full = Math.max(from, to) || 1;
        body.style.height = from + 'px';
        body.style.paddingBottom = (pad * from / full) + 'px';
        body.style.willChange = 'height';
        var start = null;
        d._anim = true;
        function step(now) {
          if (start === null) start = now;
          var p = Math.min(1, (now - start) / dur), k = ease(p);
          var hh = from + (to - from) * k;
          body.style.height = hh + 'px';
          body.style.paddingBottom = (pad * hh / full) + 'px';
          body.style.opacity = String(to > from ? Math.min(1, k * 1.4) : 1 - k);
          if (scrollTo !== scrollFrom) window.scrollTo(0, scrollFrom + (scrollTo - scrollFrom) * k);
          if (p < 1) { requestAnimationFrame(step); return; }
          body.style.height = ''; body.style.paddingBottom = ''; body.style.overflow = ''; body.style.opacity = ''; body.style.willChange = '';
          d._anim = null;
          root.classList.remove('is-busy');
          end && end();
        }
        requestAnimationFrame(step);
      }
      qsa('details', panel).forEach(function (d) {
        var sum = qs('summary', d), body = qs('.accordion__body', d);
        if (!sum || !body) return;
        sum.addEventListener('click', function (e) {
          e.preventDefault();
          if (d._anim) return;
          var y = window.scrollY;
          if (!d.open) {
            d.open = true;
            var h = body.scrollHeight;
            room(h);
            /* how far the page should follow so the opened text is readable */
            var r = sum.getBoundingClientRect();
            var over = r.bottom + h - (window.innerHeight - 24);
            var space = r.top - headerBottom() - 16;
            var by = Math.max(0, Math.min(over, space));
            if (reduce) { room(); if (by > 4) window.scrollTo(0, y + by); return; }
            run(d, body, 0, h, y, y + (by > 4 ? by : 0), 480, function () { room(); });
          } else {
            /* closing: just fold up smoothly, the page stays where it is */
            if (reduce) { d.open = false; room(); return; }
            run(d, body, body.offsetHeight, 0, y, y, 380, function () { d.open = false; room(); });
          }
        });
      });
      window.addEventListener('resize', debounce(function () { room(); }, 150));
      room();
    });
  }

  /* ---------- Light hint on the mode button: only the little icon lights up ----------
     Password page and the rest of the shop each have their own moment, so logging in doesn't trigger it again. */
  function initModeHint() {
    var style = root.getAttribute('data-mode-hint');
    if (!style || style === 'off' || root._modeHint) return;
    root._modeHint = true;
    var isPw = /\btemplate-password\b/.test(document.body.className);
    var delay = parseFloat(root.getAttribute(isPw ? 'data-mh-delay-pw' : 'data-mh-delay-home')) || 0;
    var times = Math.max(1, Math.min(10, parseInt(root.getAttribute('data-mh-repeat'), 10) || 1));
    var every = isPw ? 0 : (parseFloat(root.getAttribute('data-mh-every')) || 0);
    var once = isPw && root.getAttribute('data-mh-once') === 'on';
    var key = 'borba-mh-pw';
    try { if (once && !B.designMode && sessionStorage.getItem(key)) return; } catch (e) {}
    var used = false;
    document.addEventListener('click', function (e) { if (e.target.closest('[data-mode-toggle], [data-mode-set]')) used = true; }, true);
    function visibleIcon(b) {
      return qsa('.icon, .mode-swatch', b).filter(function (s) { return s.getBoundingClientRect().width > 0 && !s.closest('.mh-fx'); })[0];
    }
    function round() {
      if (used && isPw && !B.designMode) return;
      if (document.hidden) return;
      var btns = qsa('.mode-toggle').filter(function (b) { return b.offsetParent !== null; });
      if (!btns.length) return;
      try { if (once && !B.designMode) sessionStorage.setItem(key, '1'); } catch (e) {}
      var n = 0, fstyle = root.getAttribute('data-mode-hint-funky') || 'shine', dur = 900;
      (function play() {
        btns.forEach(function (b) {
          var old = qs('.mh-fx', b); if (old) old.remove();
          var ic = visibleIcon(b);
          var isSwatch = !!(ic && ic.classList.contains('mode-swatch'));
          var st = isSwatch ? fstyle : style;
          b.classList.toggle('mh-funky', isSwatch);
          b._mhStyle = st;
          dur = Math.max(dur, (parseFloat(getComputedStyle(b).getPropertyValue('--mh-dur')) || .9) * 1000);
          if (ic && (st === 'shine' || st === 'ring')) {
            /* a light copy of exactly the icon that is showing, laid over it */
            var fx = document.createElement('span'); fx.className = 'mh-fx'; fx.setAttribute('aria-hidden', 'true');
            var r = ic.getBoundingClientRect(), c;
            if (ic.classList.contains('mode-swatch')) {
              /* funky mode shows a colour swatch instead of a line icon: light up that round swatch */
              c = document.createElement('span'); c.className = 'mh-swatch';
            } else c = ic.cloneNode(true);
            c.style.width = r.width + 'px'; c.style.height = r.height + 'px';
            fx.appendChild(c); b.appendChild(fx);
          }
          b.classList.remove('mh-' + st); void b.offsetWidth;
          b.classList.add('mh-' + st);
        });
        setTimeout(function () {
          btns.forEach(function (b) { b.classList.remove('mh-' + (b._mhStyle || style), 'mh-funky'); var fx = qs('.mh-fx', b); if (fx) fx.remove(); });
          n++;
          if (n < times) setTimeout(play, 300);
        }, dur + 60);
      })();
    }
    setTimeout(function () {
      round();
      if (every > 0) setInterval(round, every * 1000);
    }, delay * 1000);
  }

  /* ---------- Vertical feed ---------- */
  /* the active product is the one in the middle of the screen (also right when products sit close together) */
  function pickActiveSlide(feedRoot) {
    var mid = window.innerHeight / 2, best = null, bd = Infinity;
    qsa('[data-slide]', feedRoot).forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (!r.height || r.bottom < mid - 2 || r.top > mid + 2) return;
      var d = Math.abs((r.top + r.bottom) / 2 - mid);
      if (d < bd) { bd = d; best = s; }
    });
    if (!best || best.classList.contains('is-active')) return;
    qsa('.slide.is-active', feedRoot).forEach(function (s) { s.classList.remove('is-active'); });
    best.classList.add('is-active');
    updateCounter(feedRoot, parseInt(best.getAttribute('data-index'), 10) || 1);
  }
  var slideObserver = new IntersectionObserver(function (entries) {
    var roots = [];
    entries.forEach(function (e) { var fr = e.target.closest('[data-feed-root]'); if (fr && roots.indexOf(fr) < 0) roots.push(fr); });
    roots.forEach(pickActiveSlide);
  }, { rootMargin: '-49% 0px -49% 0px', threshold: 0 });

  var sectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('is-in-view', entry.isIntersecting);
    });
  }, { threshold: 0, rootMargin: '-45% 0px -45% 0px' });

  function totalFor(feedRoot) {
    var t = qs('[data-results-total]', feedRoot);
    if (t) return parseInt(t.getAttribute('data-results-total'), 10);
    var totalEl = qs('[data-feed-total]', feedRoot);
    return totalEl ? parseInt(totalEl.textContent, 10) : qsa('[data-slide]', feedRoot).length;
  }
  function updateCounter(feedRoot, index) {
    var counter = qs('[data-feed-counter]', feedRoot);
    if (!counter) return;
    var total = totalFor(feedRoot) || 1;
    qs('[data-feed-current]', counter).textContent = pad(index);
    qs('[data-feed-total]', counter).textContent = pad(total);
    var prog = qs('[data-feed-progress]', counter);
    if (prog) prog.style.setProperty('--p', Math.min(100, (index / total) * 100) + '%');
  }

  var moreObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) loadMore(entry.target);
    });
  }, { rootMargin: '0px 0px 120% 0px' });

  function loadMore(moreEl) {
    if (moreEl._loading) return;
    var url = moreEl.getAttribute('data-next-url');
    var feedRoot = moreEl.closest('[data-feed-root]');
    if (!url || !feedRoot) return;
    moreEl._loading = true;
    var sectionId = feedRoot.getAttribute('data-section-id');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var feed = qs('[data-feed]', feedRoot);
        qsa('[data-feed] [data-slide]', doc).forEach(function (slide) {
          var node = document.importNode(slide, true);
          feed.appendChild(node);
          slideObserver.observe(node);
        });
        initCarousels(feed);
        initAutoFit(feed);
        initSlideGaps(feed);
        var nextMore = qs('[data-feed-more]', doc);
        moreObserver.unobserve(moreEl);
        if (nextMore) {
          moreEl.setAttribute('data-next-url', nextMore.getAttribute('data-next-url'));
          moreEl._loading = false;
          moreObserver.observe(moreEl);
        } else {
          moreEl.remove();
        }
      })
      .catch(function () { moreEl._loading = false; });
  }

  /* reserve exactly the room the name/price/sizes need, so the photo-size slider can use the rest of the screen */
  function measureFeedInfo(feedRoot) {
    if (root.classList.contains('view-grid')) return;
    var feed = qs('[data-feed]', feedRoot);
    if (!feed) return;
    var h = 0;
    qsa('.slide__info', feed).slice(0, 6).forEach(function (info) { h = Math.max(h, info.offsetHeight); });
    if (h > 0) feed.style.setProperty('--feed-info-h', Math.ceil(h + 22) + 'px');
  }
  window.addEventListener('resize', debounce(function () { qsa('[data-feed-root]').forEach(measureFeedInfo); }, 200));

  /* banner opacity follows the scroll (no timed fades): 1 while it is mostly in view, 0 once only the last sliver is left */
  var heroes = [], heroTick = false;
  function heroFade() {
    heroTick = false;
    var vh = window.innerHeight;
    heroes.forEach(function (h) {
      if (!h.isConnected) return;
      var r = h.getBoundingClientRect(), v = 1;
      if (r.top < 0 && r.height > 0) {
        var seen = Math.max(0, Math.min(r.bottom, vh)) / r.height; /* share of the banner still on screen */
        v = Math.max(0, Math.min(1, (seen - 0.2) / 0.25));
      }
      v = Math.round(v * 1000) / 1000;
      if (h._vis !== v) { h._vis = v; h.style.setProperty('--hero-vis', v); h.classList.toggle('is-past', v < 0.5); }
    });
  }
  function heroQueue() { if (!heroTick) { heroTick = true; requestAnimationFrame(heroFade); } }
  window.addEventListener('scroll', heroQueue, { passive: true });
  window.addEventListener('resize', heroQueue);
  function initFeeds(ctx) {
    qsa('.hero', ctx).forEach(function (h) { if (heroes.indexOf(h) < 0) heroes.push(h); });
    heroQueue();
    qsa('[data-feed-root]', ctx).forEach(function (feedRoot) {
      measureFeedInfo(feedRoot);
      initSlideGaps(feedRoot);
      sectionObserver.observe(feedRoot);
      qsa('[data-slide]', feedRoot).forEach(function (s) { slideObserver.observe(s); });
      qsa('[data-feed-more]', feedRoot).forEach(function (m) { moreObserver.observe(m); });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('page-feed') || root.classList.contains('view-grid')) return;
    if (e.target.closest('input, textarea, select, [contenteditable]')) return;
    if (openDrawerEl || qs('.modal.is-open')) return;
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var snaps = qsa('.hero, .slide, .snap-section').filter(function (el) { return el.offsetParent !== null; });
    var y = window.scrollY + 4;
    var target;
    if (e.key === 'ArrowDown') target = snaps.find(function (el) { return el.getBoundingClientRect().top + window.scrollY > y + 10; });
    else target = snaps.slice().reverse().find(function (el) { return el.getBoundingClientRect().top + window.scrollY < y - 10; });
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* ---------- Cart ---------- */
  var cartDrawerEnabled = function () {
    var t = qs('.cart-toggle');
    return !!(t && t.hasAttribute('data-drawer-open') && document.getElementById('CartDrawer'));
  };

  function renderCartSection(html) {
    if (!html) return;
    var doc = parseHTML(html);
    var fresh = qs('[data-cart-drawer-inner]', doc);
    var current = qs('[data-cart-drawer-inner]');
    qsa('[data-upsell]').forEach(function (b) { if (b._car) b._car.stop(); });
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    if (typeof timerTick === 'function') timerTick();
    if (typeof initUpsell === 'function') { initUpsell(); liftCards(); }
  }
  function setCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      if (count > 0) el.classList.add('is-bump');
    });
  }
  function refreshCount() {
    return fetch(routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  /* ---------- Discount code in the cart ---------- */
  function discountCodes(box) {
    return qsa('[data-discount-code]', box).map(function (li) { return li.getAttribute('data-discount-code'); });
  }
  function discountMsg(box, text) {
    var m = qs('[data-cart-discount-msg]', box);
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }
  function updateDiscounts(box, codes, tried) {
    box.classList.add('is-loading');
    var onCartPage = !!box.closest('.cart-page') || !qs('[data-cart-drawer-inner]');
    var body = { discount: codes.join(',') };
    if (!onCartPage) { body.sections = 'cart-drawer'; body.sections_url = location.pathname; }
    return fetch(routes.cart + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || cart.message);
        var bad = tried && (cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === tried.toUpperCase() && !d.applicable; });
        if (bad) {
          /* take the invalid code off again and tell the customer */
          return updateDiscounts(box, codes.filter(function (c) { return c.toUpperCase() !== tried.toUpperCase(); })).then(function () {
            var fresh = qs('[data-cart-discount]') || box;
            discountMsg(fresh, box.getAttribute('data-error'));
            var inp = qs('[data-cart-discount-input]', fresh); if (inp) { inp.value = tried; inp.focus(); }
          });
        }
        var won = tried && (cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === tried.toUpperCase() && d.applicable; });
        if (onCartPage) { if (won) { try { sessionStorage.setItem('borba-discount-win', tried); } catch (e) {} } location.reload(); return; }
        if (cart.sections) renderCartSection(cart.sections['cart-drawer']);
        if (won) discountWin(tried);
      })
      .catch(function (err) { box.classList.remove('is-loading'); discountMsg(box, err.message || strings.error); });
  }
  function discountWin(code) {
    qsa('button[name="checkout"].btn').forEach(function (btn) {
      btn.classList.remove('is-discounted'); void btn.offsetWidth; btn.classList.add('is-discounted');
      setTimeout(function () { btn.classList.remove('is-discounted'); }, 2000);
    });
    qsa('[data-discount-code]').forEach(function (li) {
      if (li.getAttribute('data-discount-code').toUpperCase() === String(code).toUpperCase()) li.classList.add('is-new');
    });
  }
  try {
    var pendingWin = sessionStorage.getItem('borba-discount-win');
    if (pendingWin) { sessionStorage.removeItem('borba-discount-win'); setTimeout(function () { discountWin(pendingWin); }, 300); }
  } catch (e) {}
  function applyDiscount(box) {
    var input = qs('[data-cart-discount-input]', box);
    var code = input ? input.value.trim() : '';
    if (!code) { if (input) input.focus(); return; }
    var codes = discountCodes(box);
    if (codes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); })) { input.value = ''; return; }
    discountMsg(box, '');
    updateDiscounts(box, codes.concat(code), code);
  }
  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-cart-discount-apply]');
    if (apply) { e.preventDefault(); applyDiscount(apply.closest('[data-cart-discount]')); return; }
    var rm = e.target.closest('[data-discount-remove]');
    if (rm) {
      e.preventDefault();
      var box = rm.closest('[data-cart-discount]');
      var code = rm.closest('[data-discount-code]').getAttribute('data-discount-code');
      updateDiscounts(box, discountCodes(box).filter(function (c) { return c !== code; }));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-cart-discount-input]')) return;
    e.preventDefault();
    applyDiscount(e.target.closest('[data-cart-discount]'));
  });

  function addToCart(items) {
    var body = {
      items: items,
      sections: 'cart-drawer',
      sections_url: location.pathname
    };
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || strings.error);
        if (res.data.sections) renderCartSection(res.data.sections['cart-drawer']);
        return refreshCount();
      })
      .then(function () {
        if (cartDrawerEnabled()) openDrawer('CartDrawer');
        else toast(strings.added);
      });
  }

  function changeLine(key, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-loading');
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || cart.message);
        if (cart.sections) renderCartSection(cart.sections['cart-drawer']);
        setCount(cart.item_count);
      })
      .catch(function (err) {
        if (lineEl) lineEl.classList.remove('is-loading');
        toast(err.message || strings.error);
      });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn.getAttribute('data-key'), parseInt(qtyBtn.getAttribute('data-cart-qty'), 10), qtyBtn.closest('.cart-item'));
      return;
    }
    var quick = e.target.closest('[data-quick-add-variant]');
    if (quick) {
      e.preventDefault();
      if (quick.disabled) return;
      quick.classList.add('is-loading');
      addToCart([{ id: parseInt(quick.getAttribute('data-quick-add-variant'), 10), quantity: 1 }])
        .then(function () {
          quick.classList.remove('is-loading');
          quick.classList.add('is-done');
          setTimeout(function () { quick.classList.remove('is-done'); }, 1600);
        })
        .catch(function (err) {
          quick.classList.remove('is-loading');
          toast(err.message || strings.error);
        });
    }
  });

  /* ---------- Quick add: plus button on the photo -> short popup with the sizes ----------
     Phones: slides up from the bottom (swipe down / tap outside to close). Desktop: small popup next to the product.
     Theme settings → Productkaart en snel toevoegen. */
  var qa = null, QA_HINTS = ['shine', 'glow', 'ring', 'wiggle', 'pop'];
  function qaDesktop() { return window.matchMedia('(min-width: 750px)').matches; }
  function qaEls() {
    if (qa) return qa;
    var sheet = document.getElementById('QuickAddSheet');
    if (!sheet) return null;
    qa = {
      sheet: sheet, panel: qs('.qa-sheet__panel', sheet), title: qs('.qa-sheet__title', sheet),
      opts: qs('[data-qa-options]', sheet), add: qs('[data-qa-add]', sheet), label: qs('[data-qa-add-label]', sheet),
      price: qs('[data-qa-price]', sheet), details: qs('[data-qa-details]', sheet),
      data: null, sel: [], btn: null, timers: []
    };
    qaBind();
    return qa;
  }
  function qaVariant() {
    var d = qa.data;
    if (!d) return null;
    if (d.single || !d.options.length) return d.variants[0] || null;
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i], ok = true;
      for (var k = 0; k < d.options.length; k++) if (v.o[k] !== qa.sel[k]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function qaInStock(k, val) {
    return qa.data.variants.some(function (v) {
      if (!v.a || v.o[k] !== val) return false;
      for (var j = 0; j < qa.data.options.length; j++) if (j !== k && qa.sel[j] != null && v.o[j] !== qa.sel[j]) return false;
      return true;
    });
  }
  function qaRender() {
    var d = qa.data, html = '';
    if (!d.single) d.options.forEach(function (o, k) {
      html += '<div class="qa-sheet__group" data-k="' + k + '"><p class="qa-sheet__label">' + escapeHTML(o.name) + '</p><div class="qa-sheet__values" role="radiogroup" aria-label="' + escapeHTML(o.name) + '">';
      o.values.forEach(function (val) {
        var on = qa.sel[k] === val, sold = !qaInStock(k, val);
        /* same pill as the size buttons on the product page */
        html += '<button type="button" class="pill qa-sheet__val' + (on ? ' is-active' : '') + (sold ? ' is-unavailable' : '') + '" role="radio" aria-checked="' + on + '" data-k="' + k + '" data-v="' + escapeHTML(val) + '"><span>' + escapeHTML(val) + '</span></button>';
      });
      html += '</div></div>';
    });
    qa.opts.innerHTML = html;
    qaButton();
  }
  function qaButton() {
    var d = qa.data, v = qaVariant(), sizeOnly = d.options.length === 1;
    var names = (B.sizeOptionNames || []).map(function (n) { return String(n).trim(); });
    var isSize = sizeOnly && names.indexOf(String(d.options[0].name).toLowerCase().trim()) > -1;
    qa.add.classList.remove('is-ready');
    qa.add.disabled = false;
    if (v && v.a) { qa.label.textContent = strings.addToCart || 'Add to cart'; qa.price.textContent = v.p; qa.add.classList.add('is-ready'); }
    else if (v) { qa.label.textContent = strings.soldOut || 'Sold out'; qa.price.textContent = v.p; qa.add.disabled = true; }
    else { qa.label.textContent = (isSize ? strings.selectSize : strings.chooseOptions) || 'Select options'; qa.price.textContent = d.price; }
  }
  function qaHint() {
    qa.timers.forEach(clearTimeout); qa.timers = [];
    var el = qa.details, st = root.getAttribute('data-qa-hint') || 'off';
    QA_HINTS.forEach(function (h) { el.classList.remove('qa-hint-' + h); });
    if (QA_HINTS.indexOf(st) < 0) return;
    var times = Math.max(1, Math.min(5, parseInt(root.getAttribute('data-qa-hint-repeat'), 10) || 1));
    var delay = (parseFloat(root.getAttribute('data-qa-hint-delay')) || 0) * 1000;
    var dur = (parseFloat(getComputedStyle(el).getPropertyValue('--qh-dur')) || 1.4) * 1000, n = 0;
    function play() {
      if (!qa.sheet.classList.contains('is-open')) return;
      el.classList.remove('qa-hint-' + st); void el.offsetWidth;
      el.classList.add('qa-hint-' + st);
      qa.timers.push(setTimeout(function () {
        el.classList.remove('qa-hint-' + st);
        if (++n < times) qa.timers.push(setTimeout(play, 260));
      }, dur + 40));
    }
    /* starts once the popup has slid in */
    qa.timers.push(setTimeout(play, 380 + delay));
  }
  function qaPlace(slide, btn) {
    if (!qaDesktop()) return;
    var m = (qs('.slide__media', slide) || btn).getBoundingClientRect(), pw = qa.panel.offsetWidth || 340, ph = qa.panel.offsetHeight || 260;
    /* next to the garment itself (the photo box can be much wider in the swipe feed) */
    var side = root.classList.contains('view-grid') ? 0 : (parseFloat(slide.style.getPropertyValue('--fit-side')) || 0);
    var r = { left: m.left + side, right: m.right - side, top: m.top, height: m.height, width: m.width - 2 * side };
    var W = window.innerWidth, H = window.innerHeight, x, y;
    if (r.right + 14 + pw <= W - 16) x = r.right + 14;
    else if (r.left - 14 - pw >= 16) x = r.left - 14 - pw;
    else x = Math.max(16, Math.min(W - pw - 16, r.left + r.width / 2 - pw / 2));
    y = Math.max(16, Math.min(H - ph - 16, r.top + r.height / 2 - ph / 2));
    qa.sheet.style.setProperty('--qa-x', Math.round(x) + 'px');
    qa.sheet.style.setProperty('--qa-y', Math.round(y) + 'px');
  }
  function qaOpen(btn) {
    if (!qaEls()) return;
    var slide = btn.closest('.slide, .pcard'), json = slide && qs('[data-qa-json]', slide);
    if (!json) return;
    try { qa.data = JSON.parse(json.textContent); } catch (e) { return; }
    qa.sel = qa.data.options.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });
    qa.title.textContent = qa.data.title;
    qa.details.setAttribute('href', qa.data.url);
    qaRender();
    if (qa.btn && qa.btn !== btn) qa.btn.classList.remove('is-open');
    qa.btn = btn; btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
    qa.sheet.style.removeProperty('--qa-drag');
    qaPlace(slide, btn);
    qa.sheet.classList.add('is-open');
    qa.sheet.setAttribute('aria-hidden', 'false');
    if (!qaDesktop()) root.classList.add('is-locked');
    setTimeout(function () { qa.panel.focus({ preventScroll: true }); }, 60);
    qaHint();
  }
  function qaClose(restoreFocus) {
    if (!qa || !qa.sheet.classList.contains('is-open')) return;
    qa.sheet.classList.remove('is-open', 'is-dragging');
    qa.sheet.setAttribute('aria-hidden', 'true');
    qa.timers.forEach(clearTimeout); qa.timers = [];
    QA_HINTS.forEach(function (h) { qa.details.classList.remove('qa-hint-' + h); });
    if (!openDrawerEl && !qs('.modal.is-open')) root.classList.remove('is-locked');
    if (qa.btn) {
      qa.btn.classList.remove('is-open'); qa.btn.setAttribute('aria-expanded', 'false');
      if (restoreFocus) qa.btn.focus({ preventScroll: true });
    }
  }
  function qaBind() {
    qa.sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) { qaClose(true); return; }
      var val = e.target.closest('.qa-sheet__val');
      if (val) {
        var k = parseInt(val.getAttribute('data-k'), 10);
        qa.sel[k] = val.getAttribute('data-v');
        qaRender();
        var again = qs('.qa-sheet__val[data-k="' + k + '"].is-active', qa.opts);
        if (again) again.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-qa-add]')) {
        var v = qaVariant();
        if (!v) {
          /* a choice is still missing: point at it */
          var miss = qsa('.qa-sheet__group', qa.opts).filter(function (g) { return qa.sel[parseInt(g.getAttribute('data-k'), 10)] == null; })[0];
          if (miss) { miss.classList.remove('is-missing'); void miss.offsetWidth; miss.classList.add('is-missing'); }
          return;
        }
        if (!v.a || qa.add.classList.contains('is-loading')) return;
        qa.add.classList.add('is-loading');
        addToCart([{ id: v.id, quantity: 1 }])
          .then(function () { qa.add.classList.remove('is-loading'); qaClose(false); })
          .catch(function (err) { qa.add.classList.remove('is-loading'); toast(err.message || strings.error); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qa.sheet.classList.contains('is-open')) qaClose(true); });
    window.addEventListener('resize', debounce(function () { if (qa.sheet.classList.contains('is-open') && qa.btn) qaPlace(qa.btn.closest('.slide, .pcard'), qa.btn); }, 120));
    /* phones: drag the popup down to close it */
    var drag = null;
    qa.panel.addEventListener('touchstart', function (e) {
      if (qaDesktop() || e.touches.length !== 1 || qa.panel.scrollTop > 0) { drag = null; return; }
      drag = { y: e.touches[0].clientY, t: e.timeStamp, dy: 0 };
    }, { passive: true });
    qa.panel.addEventListener('touchmove', function (e) {
      if (!drag) return;
      drag.dy = Math.max(0, e.touches[0].clientY - drag.y);
      if (drag.dy > 4) { qa.sheet.classList.add('is-dragging'); qa.sheet.style.setProperty('--qa-drag', drag.dy + 'px'); }
    }, { passive: true });
    function end(e) {
      if (!drag) return;
      var d = drag; drag = null;
      qa.sheet.classList.remove('is-dragging');
      var speed = d.dy / Math.max(1, e.timeStamp - d.t);
      if (d.dy > 90 || (d.dy > 24 && speed > 0.5)) qaClose(false);
      qa.sheet.style.removeProperty('--qa-drag');
    }
    qa.panel.addEventListener('touchend', end, { passive: true });
    qa.panel.addEventListener('touchcancel', end, { passive: true });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qa-open]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (qa && qa.btn === btn && qa.sheet.classList.contains('is-open')) { qaClose(false); return; }
    qaOpen(btn);
  }, true);

  /* ---------- Modals ---------- */
  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    root.classList.add('is-locked');
    setTimeout(function () { modal.focus({ preventScroll: true }); }, 50);
    modal.dispatchEvent(new CustomEvent('modal:open'));
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!openDrawerEl) root.classList.remove('is-locked');
    modal.dispatchEvent(new CustomEvent('modal:close'));
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) { e.preventDefault(); openModal(document.getElementById(opener.getAttribute('data-modal-open'))); return; }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) { closeModal(closer.closest('.modal')); return; }
    if (e.target.classList && e.target.classList.contains('modal')) closeModal(e.target);
  });

  /* ---------- Size chart ---------- */
  function readChartRows(source) {
    var holder = document.createElement('div');
    holder.appendChild(source.content.cloneNode(true));
    var table = qs('table', holder);
    if (table) {
      return qsa('tr', table).map(function (tr) {
        return qsa('th, td', tr).map(function (c) { return c.textContent.trim(); });
      }).filter(function (r) { return r.length; });
    }
    qsa('br', holder).forEach(function (br) { br.replaceWith('\n'); });
    var text = '';
    qsa('p, div, li, h1, h2, h3, h4, h5, h6', holder).forEach(function (el) {
      if (!el.querySelector('p, div, li')) text += el.textContent + '\n';
    });
    if (!text.trim()) text = holder.textContent;
    return text.split('\n')
      .map(function (l) { return l.trim(); })
      .filter(Boolean)
      .map(function (line) {
        var sep = line.indexOf('|') > -1 ? '|' : line.indexOf('\t') > -1 ? '\t' : line.indexOf(';') > -1 ? ';' : null;
        return sep ? line.split(sep).map(function (c) { return c.trim(); }) : line.split(/\s{2,}/).map(function (c) { return c.trim(); });
      })
      .filter(function (r) { return r.length > 1; });
  }
  // column kind from its heading: weight columns (kg) become lbs, the size column stays, the rest is cm → inches
  function columnKind(heading, index) {
    var h = (heading || '').toLowerCase();
    if (index === 0) return 'none';
    if (/\bkg\b|weight|gewicht|poids/.test(h)) return 'kg';
    if (/height|lichaamslengte|body length|größe/.test(h)) return 'height';
    if (/\(-\)|\bfit\b/.test(h)) return 'none';
    return 'cm';
  }
  /* Size charts are always shown in EU units (cm / kg). Tables pasted from suppliers in jin (Chinese half-kilos),
     pounds or inches are converted automatically. */
  function toEU(rows) {
    if (!rows.length) return rows;
    var head = rows[0];
    head.forEach(function (h, i) {
      if (!i) return;
      var l = (h || '').toLowerCase(), f = null, label = null;
      if (/jin|斤|catty/.test(l)) { f = function (n) { return n / 2; }; label = h.replace(/\(?\s*(jin|斤|catty)\s*\)?/i, '').trim() + ' (KG)'; }
      else if (/\blbs?\b|pound/.test(l)) { f = function (n) { return n / 2.20462; }; label = h.replace(/\(?\s*(lbs?|pounds?)\s*\)?/i, '').trim() + ' (KG)'; }
      else if (/\(\s*(in|inch|inches)\s*\)/.test(l)) { f = function (n) { return n * 2.54; }; label = h.replace(/\(\s*(in|inch|inches)\s*\)/i, '(CM)'); }
      if (!f) return;
      head[i] = label;
      for (var r = 1; r < rows.length; r++) {
        if (rows[r][i] == null) continue;
        rows[r][i] = String(rows[r][i]).replace(/(\d+(?:[.,]\d+)?)/g, function (m) {
          var v = f(parseFloat(m.replace(',', '.')));
          return String(Math.round(v * 2) / 2).replace(/\.0$/, '');
        });
      }
    });
    return rows;
  }
  function convertHeading(heading, kind, unit) {
    if (unit === 'cm') return heading;
    if (kind === 'kg') return heading.replace(/\(\s*kg\s*\)/i, '(LBS)').replace(/\bkg\b/i, 'LBS');
    if (kind === 'height') return heading.replace(/\(\s*cm\s*\)/i, '(FT)');
    if (kind === 'cm') return heading.replace(/\(\s*cm\s*\)/i, '(IN)').replace(/\bcm\b/i, 'IN');
    return heading;
  }
  function convertCell(value, unit, kind) {
    if (unit === 'cm' || kind === 'none') return value;
    if (kind === 'height') {
      return value.replace(/(\d+(?:[.,]\d+)?)\s*(cm)?/gi, function (m, num) {
        var inch = Math.round(parseFloat(num.replace(',', '.')) / 2.54);
        return Math.floor(inch / 12) + "'" + (inch % 12) + '"';
      });
    }
    if (kind === 'kg') {
      return value.replace(/(\d+(?:[.,]\d+)?)\s*(kg)?/gi, function (m, num) {
        return Math.round(parseFloat(num.replace(',', '.')) * 2.20462).toString() + (/kg/i.test(m) ? ' lbs' : '');
      });
    }
    return value.replace(/(\d+(?:[.,]\d+)?)\s*(cm)?/gi, function (m, num) {
      var n = parseFloat(num.replace(',', '.')) / 2.54;
      return (Math.round(n * 10) / 10).toString() + (m.toLowerCase().indexOf('cm') > -1 ? ' in' : '');
    });
  }
  function initSizeCharts(ctx) {
    qsa('[data-size-chart]', ctx).forEach(function (modal) {
      if (modal._bound) return; modal._bound = true;
      var source = qs('[data-size-chart-source]', modal);
      var wrap = qs('[data-size-chart-table]', modal);
      if (!source || !wrap) return;
      var rows = toEU(readChartRows(source));
      if (!rows.length) return;
      var unit = store('borba-unit') || wrap.getAttribute('data-default-unit') || 'cm';
      var section = modal.closest('[data-product-section]');

      function selectedSize() {
        if (!section) return null;
        var fs = qs('[data-size-option]', section);
        if (!fs) return null;
        var r = qs('input:checked', fs);
        var s = qs('select', fs);
        return (r && r.value) || (s && s.value) || null;
      }
      function render() {
        var head = rows[0];
        var body = rows.slice(1);
        var sel = (selectedSize() || '').toLowerCase();
        var kinds = head.map(function (h, i) { return columnKind(h, i); });
        var html = '<table class="size-table"><thead><tr>' +
          head.map(function (h, i) { return '<th>' + escapeHTML(convertHeading(h, kinds[i], unit)) + '</th>'; }).join('') +
          '</tr></thead><tbody>' +
          body.map(function (r) {
            var size = r[0] || '';
            return '<tr data-size="' + escapeHTML(size) + '"' + (size.toLowerCase() === sel ? ' class="is-selected"' : '') + '>' +
              r.map(function (c, i) { return '<td>' + escapeHTML(i === 0 ? c : convertCell(c, unit, kinds[i] || 'cm')) + '</td>'; }).join('') +
              '</tr>';
          }).join('') + '</tbody></table>';
        wrap.innerHTML = html;
        qsa('.unit-switch__btn', modal).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-unit') === unit); });
      }
      render();
      qsa('.unit-switch__btn', modal).forEach(function (b) {
        b.addEventListener('click', function () { unit = b.getAttribute('data-unit'); store('borba-unit', unit); render(); });
      });
      modal.addEventListener('modal:open', render);
      wrap.addEventListener('click', function (e) {
        var tr = e.target.closest('tr[data-size]');
        if (!tr || !section) return;
        var size = tr.getAttribute('data-size').toLowerCase();
        var fs = qs('[data-size-option]', section);
        if (!fs) return;
        var radio = qsa('input[type="radio"]', fs).find(function (r) { return r.value.toLowerCase() === size; });
        var select = qs('select', fs);
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        else if (select) {
          var opt = qsa('option', select).find(function (o) { return o.value.toLowerCase() === size; });
          if (opt) { select.value = opt.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        render();
      });
    });
  }
  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Product page ---------- */
  /* ---------- Logo: lift off a see-through background layer baked into the logo file ----------
     Some logo PNGs carry an almost invisible full-size background; the drop shadow then shows it as a dark box
     behind the logo. The picture is cleaned once (same artwork, true transparent background) in every mode. */
  function dehazeLogo(img) {
    /* Logo PNGs exported with a see-through (dark or light) box behind them: remove that box.
       The box = every pixel that looks like the picture's border (colour + see-through level). */
    if (img._dehaze) return;
    if (!img.complete || !img.naturalWidth) { img.addEventListener('load', function () { dehazeLogo(img); }, { once: true }); return; }
    img._dehaze = true;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0) return;
    if (/\.svg(\?|#|$)/i.test(src)) return; /* vector logo: already truly see-through */
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var k = Math.min(1, 900 / im.naturalWidth), W = Math.max(1, Math.round(im.naturalWidth * k)), H = Math.max(1, Math.round(im.naturalHeight * k));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(im, 0, 0, W, H);
        var id = x.getImageData(0, 0, W, H), d = id.data, N = W * H, p, i;
        /* reference = median colour + alpha of the border pixels */
        var border = [];
        for (i = 0; i < W; i++) border.push(i, (H - 1) * W + i);
        for (i = 0; i < H; i++) border.push(i * W, i * W + W - 1);
        function med(ch) { var v = border.map(function (q) { return d[q * 4 + ch]; }).sort(function (m, n) { return m - n; }); return v[v.length >> 1]; }
        var rA = med(3), rR = med(0), rG = med(1), rB = med(2);
        if (rA < 12) return; /* border already see-through: nothing to remove */
        function dist(q) {
          var o = q * 4, a = d[o + 3];
          if (a < 12) return 0;
          var dr = d[o] - rR, dg = d[o + 1] - rG, db = d[o + 2] - rB, da = (a - rA) * .6;
          return Math.sqrt(dr * dr + dg * dg + db * db + da * da);
        }
        /* box pixels = look like the border (also the holes inside letters), half-mixed edge pixels fade below */
        var T = 46, mask = new Uint8Array(N);
        for (p = 0; p < N; p++) if (dist(p) < T) mask[p] = 1;
        var removed = 0;
        for (p = 0; p < N; p++) if (mask[p]) { d[p * 4 + 3] = 0; removed++; }
        if (removed < N * 0.02) return; /* no box found: leave the original */
        /* soften the 2px rim around the box: half-mixed pixels fade by how much they look like the box */
        for (var pass = 0; pass < 2; pass++) {
          var rim = [];
          for (p = 0; p < N; p++) {
            if (mask[p]) continue;
            var cx = p % W, cy = (p - cx) / W;
            if ((cx > 0 && mask[p - 1]) || (cx < W - 1 && mask[p + 1]) || (cy > 0 && mask[p - W]) || (cy < H - 1 && mask[p + W])) rim.push(p);
          }
          rim.forEach(function (q) {
            /* un-mix: how much of this pixel is logo and how much is box (colour-to-alpha against the box colour) */
            var o = q * 4, ref = [rR, rG, rB], t = 0, ch;
            for (ch = 0; ch < 3; ch++) {
              var h = ref[ch], v = d[o + ch], span = v >= h ? 255 - h : h;
              if (span > 0) t = Math.max(t, Math.abs(v - h) / span);
            }
            t = Math.min(1, t);
            if (t < 0.04) { d[o + 3] = 0; }
            else {
              for (ch = 0; ch < 3; ch++) d[o + ch] = Math.max(0, Math.min(255, Math.round(ref[ch] + (d[o + ch] - ref[ch]) / t)));
              d[o + 3] = Math.round(d[o + 3] * t);
            }
            mask[q] = 2;
          });
        }
        x.putImageData(id, 0, 0);
        var url = c.toDataURL('image/png');
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = url;
      } catch (err) { /* picture not readable: keep it as it is */ }
    };
    /* own URL, so Safari never reuses the cached copy that was loaded without permission to read it */
    im.src = src + (src.indexOf('?') < 0 ? '?' : '&') + 'dehaze=1';
  }

  /* ---------- Sold out: red glow + browser bar colour (Theme settings → Uitverkocht) ---------- */
  var soMeta = null, soMetaOrig = null;
  function soMode() { return root.getAttribute('data-funky') === 'on' ? 'f' : (root.getAttribute('data-mode') === 'light' ? 'l' : 'd'); }
  var soBarsOn = false;
  function soBars(on) {
    soBarsOn = on;
    if (!soMeta) {
      soMeta = qs('meta[name="theme-color"]');
      if (!soMeta) { soMeta = document.createElement('meta'); soMeta.name = 'theme-color'; document.head.appendChild(soMeta); }
      soMetaOrig = soMeta.getAttribute('content') || '';
    }
    var m = soMode(), use = on && root.getAttribute('data-so-bars-' + m) === 'on';
    soMeta.setAttribute('content', use ? (root.getAttribute('data-so-color-' + m) || '#c8102e') : soMetaOrig);
  }
  /* switching day / night / funky while the glow is on: the browser bar follows that mode's choice */
  new MutationObserver(function () { if (soBarsOn) soBars(true); }).observe(root, { attributes: true, attributeFilter: ['data-mode', 'data-funky'] });
  var soT = [];
  function soGlow(on, why) {
    if (root.getAttribute('data-so-glow') !== 'on') return;
    var g = qs('.so-glow');
    if (!g) { g = document.createElement('div'); g.className = 'so-glow'; g.setAttribute('aria-hidden', 'true'); document.body.appendChild(g); }
    soT.forEach(clearTimeout); soT = [];
    if (!on) { g.classList.remove('is-flash', 'is-rest'); soBars(false); return; }
    var m = soMode();
    function opt(k, def) { var v = parseFloat(root.getAttribute('data-so-' + k + '-' + m)); return isNaN(v) ? def : v; }
    if (why === 'size' && root.getAttribute('data-so-size-' + m) === 'off') return;
    var delay = why === 'size' ? 0 : opt('delay', 0) * 1000;
    var reps = Math.max(1, Math.min(5, Math.round(opt('repeat', 1))));
    var hold = opt('hold', 0) * 1000;
    soT.push(setTimeout(function () {
      var dur = (parseFloat(getComputedStyle(g).getPropertyValue('--so-dur')) || 1.6) * 1000, n = 0;
      g.classList.add('is-rest');
      soBars(true);
      (function flash() {
        g.classList.remove('is-flash'); void g.offsetWidth; g.classList.add('is-flash');
        soT.push(setTimeout(function () {
          g.classList.remove('is-flash');
          if (++n < reps) { soT.push(setTimeout(flash, 250)); return; }
          /* the edge glow fades away after its time (0 = it stays) */
          if (hold > 0) soT.push(setTimeout(function () { g.classList.remove('is-rest'); soBars(false); }, hold));
        }, dur));
      })();
    }, delay));
  }

  function initProducts(ctx) {
    qsa('[data-product-section]', ctx).forEach(function (section) {
      if (section._bound) return; section._bound = true;
      var jsonEl = qs('[data-product-json]', section);
      var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
      var form = qs('[data-product-form]', section);
      var idInput = qs('[data-variant-input]', section);
      var picker = qs('[data-variant-picker]', section);
      var atc = qs('[data-atc]', section);
      var stack = qs('[data-media-stack]', section);
      var thumbs = qsa('[data-thumb]', section);
      var dots = qsa('[data-stack-dots] .dots__dot', section);
      var sticky = qs('[data-sticky-atc]', section);

      function currentOptions() {
        if (!picker) return null;
        return qsa('.variants__option', picker).map(function (fs) {
          var r = qs('input:checked', fs);
          var s = qs('select', fs);
          return r ? r.value : s ? s.value : null;
        });
      }
      function findVariant(opts) {
        return data.variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === o; });
        });
      }
      function updateAvailability(opts) {
        qsa('.variants__option', picker).forEach(function (fs, index) {
          qsa('.pill', fs).forEach(function (pill) {
            var input = qs('input', pill);
            var test = opts.slice();
            test[index] = input.value;
            var match = data.variants.find(function (v) {
              return v.options.every(function (o, i) { return test[i] === o; });
            });
            pill.classList.toggle('is-unavailable', !match || !match.available);
            pill.classList.toggle('is-active', input.checked);
          });
          var selLabel = qs('[data-option-selected]', fs);
          if (selLabel) selLabel.textContent = opts[index] || '';
        });
      }
      var car = null;
      function isCarousel() { return !!car && car.active; }
      function isRow() {
        return !isCarousel() && !!stack && getComputedStyle(stack).flexDirection === 'row';
      }
      function scrollToMedia(mediaId, smooth) {
        if (!stack || !mediaId) return;
        var item = qs('[data-media-id="' + mediaId + '"]', stack);
        if (!item) return;
        if (isCarousel()) { if (car.items.indexOf(item) > -1) car.go(car.items.indexOf(item), !smooth); return; }
        var behavior = smooth ? 'smooth' : 'auto';
        if (isRow()) {
          stack.scrollTo({ left: item.offsetLeft - stack.offsetLeft, behavior: behavior });
        } else if (isDesktop()) {
          window.scrollTo({ top: item.getBoundingClientRect().top + window.scrollY, behavior: behavior });
        } else {
          var top = item.getBoundingClientRect().top + window.scrollY - (qs('[data-header]') ? 80 : 0);
          window.scrollTo({ top: top, behavior: behavior });
        }
      }
      function setVariant(variant) {
        var label = atc && qs('[data-atc-label]', atc);
        if (!variant) {
          if (atc) { atc.disabled = true; if (label) label.textContent = strings.unavailable; }
          syncSticky(null);
          return;
        }
        if (idInput) idInput.value = variant.id;
        var priceWrap = qs('[data-price-wrap]', section);
        if (priceWrap && !data.comingSoon) {
          var sale = variant.compare_at_price > variant.price;
          priceWrap.innerHTML = '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now">' +
            formatMoney(variant.price) + '</span>' + (sale ? '<s class="price__was">' + formatMoney(variant.compare_at_price) + '</s>' : '') + '</div>';
        }
        if (atc && !data.comingSoon) {
          var p = qs('[data-atc-price]', atc);
          if (p) p.textContent = formatMoney(variant.price);
        }
        soldState(variant, false);
        syncSticky(variant);
        if (variant.media_id && (isCarousel() || isRow() || isDesktop())) scrollToMedia(variant.media_id, true);
        var url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url.toString());
        section.dispatchEvent(new CustomEvent('variant:change', { detail: variant }));
      }
      function syncSticky(variant) {
        if (!sticky) return;
        var btn = qs('[data-sticky-add]', sticky);
        var lbl = qs('[data-sticky-label]', sticky);
        var price = qs('[data-sticky-price]', sticky);
        var vt = qs('[data-sticky-variant]', sticky);
        if (!variant) { btn.disabled = true; lbl.textContent = strings.unavailable; return; }
        var nt = notifyOn && !variant.available;
        btn.disabled = !variant.available && !nt;
        btn.classList.toggle('is-notify', nt);
        sticky.classList.toggle('is-so', nt);
        lbl.textContent = variant.available ? strings.addToCart : (nt ? strings.notifyMe : strings.soldOut);
        price.textContent = formatMoney(variant.price);
        if (vt && variant.title !== 'Default Title') vt.textContent = variant.title;
      }

      /* sold out: "Sold out – notify me" button, e-mail field and the red glow */
      var notifyEl = qs('[data-notify]', section);
      var notifyOn = !!notifyEl && root.getAttribute('data-so-notify') === 'on' && !data.comingSoon;
      var lastAvail = null, curVariant = null;
      function soldState(variant, first) {
        curVariant = variant;
        if (!atc || data.comingSoon) return;
        var label = qs('[data-atc-label]', atc);
        var nt = notifyOn && !variant.available;
        atc.disabled = !variant.available && !nt;
        atc.classList.toggle('is-notify', nt);
        if (label) label.textContent = variant.available ? strings.addToCart : (nt ? strings.notifyMe : strings.soldOut);
        /* sold out: the info blocks (shipping, care, product info) are hidden until a size is in stock */
        section.classList.toggle('is-variant-sold-out', !variant.available);
        if (variant.available) closeNotify();
        requestAnimationFrame(fitNotifyLabel);
        if (nt && (first || lastAvail !== false)) {
          var d = (parseFloat(root.getAttribute('data-so-win-delay')) || 0) * 1000;
          var reps = Math.max(1, Math.min(5, parseInt(root.getAttribute('data-so-win-repeat'), 10) || 1));
          setTimeout(function () { soWin(reps); }, first ? d : 300);
        }
        if (!variant.available && (first || lastAvail !== false)) soGlow(true, first ? 'open' : 'size');
        if (variant.available && lastAvail === false) soGlow(false);
        lastAvail = variant.available;
      }
      /* green glow on the notify button */
      var winT = [];
      function soWin(times) {
        if (!atc || root.getAttribute('data-so-win') !== 'on') return;
        winT.forEach(clearTimeout); winT = [];
        var n = 0, dur = (parseFloat(getComputedStyle(atc).getPropertyValue('--sow-dur')) || 1.8) * 1000;
        (function play() {
          if (!atc.classList.contains('is-notify')) return;
          /* the glow plays on the big button and on the phone's sticky NOTIFY ME bar (whichever is in view) */
          var sBtn = sticky ? qs('[data-sticky-add]', sticky) : null;
          var tgts = [atc]; if (sBtn && sBtn.classList.contains('is-notify')) tgts.push(sBtn);
          tgts.forEach(function (t) { t.classList.remove('so-win'); void t.offsetWidth; t.classList.add('so-win'); });
          winT.push(setTimeout(function () { tgts.forEach(function (t) { t.classList.remove('so-win'); }); if (++n < times) winT.push(setTimeout(play, 220)); }, dur + 30));
        })();
      }
      /* keep "Sold out – notify me…" on one line: shrink the text a little when the button is narrow */
      function fitNotifyLabel() {
        if (!atc) return;
        fitOne(qs('[data-atc-label]', atc), atc);
        /* the phone's sticky NOTIFY bar carries the same full text: keep it on one line too */
        if (sticky) { var sb = qs('[data-sticky-add]', sticky); if (sb) fitOne(qs('[data-sticky-label]', sticky), sb); }
      }
      function fitOne(label, btnEl) {
        if (!label || !btnEl) return;
        label.style.fontSize = ''; label.style.letterSpacing = '';
        if (!btnEl.classList.contains('is-notify') || !label.offsetParent) return;
        var cs = getComputedStyle(label), fs = parseFloat(cs.fontSize) || 11;
        var ls = (parseFloat(cs.letterSpacing) || 0) / fs; /* in em */
        /* first a little less letter spacing, then a slightly smaller size */
        while (label.scrollWidth > label.clientWidth + 1 && (ls > .02 || fs > 8)) {
          if (ls > .02) { ls = Math.max(.02, ls - .01); label.style.letterSpacing = ls + 'em'; }
          else { fs -= .25; label.style.fontSize = fs + 'px'; }
        }
      }
      window.addEventListener('resize', debounce(fitNotifyLabel, 120));
      function openNotify() {
        if (!notifyEl) return;
        notifyEl.hidden = false;
        requestAnimationFrame(function () { notifyEl.classList.add('is-open'); });
        var r = atc.getBoundingClientRect();
        if (r.top < 90 || r.bottom > window.innerHeight - 90) atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var inp = qs('[data-notify-email]', notifyEl);
        if (inp && !notifyEl.classList.contains('is-done')) setTimeout(function () { inp.focus({ preventScroll: true }); }, 380);
      }
      function closeNotify() {
        if (!notifyEl || notifyEl.hidden) return;
        notifyEl.classList.remove('is-open', 'is-done');
        notifyEl.hidden = true;
        var m = qs('[data-notify-msg]', notifyEl); if (m) { m.textContent = ''; m.classList.remove('is-error'); }
      }
      if (notifyEl) {
        var nInput = qs('[data-notify-email]', notifyEl), nBtn = qs('[data-notify-send]', notifyEl), nMsg = qs('[data-notify-msg]', notifyEl);
        var nForm = qs('[data-notify-form]', section);
        var send = function () {
          var email = (nInput.value || '').trim();
          nMsg.classList.remove('is-error');
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { nMsg.textContent = nMsg.getAttribute('data-error'); nMsg.classList.add('is-error'); nInput.focus(); return; }
          if (!nForm || nBtn.classList.contains('is-loading')) return;
          var vt = curVariant && curVariant.title !== 'Default Title' ? curVariant.title : '';
          qs('[data-nf-email]', nForm).value = email;
          qs('[data-nf-variant]', nForm).value = vt;
          qs('[data-nf-body]', nForm).value = 'Back in stock request: ' + (qs('.product__title', section) ? qs('.product__title', section).textContent.trim() : '') + (vt ? ' — ' + vt : '');
          nBtn.classList.add('is-loading');
          fetch(nForm.action, { method: 'POST', body: new FormData(nForm), headers: { Accept: 'text/html' } })
            .then(function (r) {
              /* Shopify's spam check wants a real page visit: send the form the normal way */
              if (/challenge/.test(r.url)) { nForm.submit(); return; }
              if (!r.ok) throw new Error('x');
              nBtn.classList.remove('is-loading');
              notifyEl.classList.add('is-done');
              nMsg.textContent = nMsg.getAttribute('data-done');
              soWin(1);
            })
            .catch(function () { nForm.submit(); });
        };
        nBtn.addEventListener('click', send);
        nInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send(); } });
      }
      (function () {
        var start = idInput && data.variants.find(function (v) { return String(v.id) === String(idInput.value); });
        if (start) { soldState(start, true); syncSticky(start); }
      })();

      if (picker) {
        picker.addEventListener('change', function () {
          var opts = currentOptions();
          updateAvailability(opts);
          setVariant(findVariant(opts));
        });
        updateAvailability(currentOptions());
      }

      // Quantity steppers
      qsa('[data-qty-step]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = qs('input[name="quantity"]', section);
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
          input.value = v;
        });
      });

      // Add to cart
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc && atc.classList.contains('is-notify')) { openNotify(); return; }
          if (!atc || atc.disabled) return;
          var errorEl = qs('[data-form-error]', section);
          if (errorEl) errorEl.hidden = true;
          var label = qs('[data-atc-label]', atc);
          var original = label ? label.textContent : '';
          atc.classList.add('is-loading');
          if (label) label.textContent = strings.adding;
          var fd = new FormData(form);
          var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
          var props = {};
          fd.forEach(function (val, key) {
            var m = key.match(/^properties\[(.+)\]$/);
            if (m && val) props[m[1]] = val;
          });
          if (Object.keys(props).length) item.properties = props;
          addToCart([item])
            .then(function () {
              atc.classList.remove('is-loading');
              atc.classList.add('is-done');
              if (label) label.textContent = strings.added + ' ✓';
              setTimeout(function () { atc.classList.remove('is-done'); if (label) label.textContent = original; }, 1800);
            })
            .catch(function (err) {
              atc.classList.remove('is-loading');
              if (label) label.textContent = original;
              if (errorEl) { errorEl.textContent = err.message || strings.error; errorEl.hidden = false; }
            });
        });
      }

      // Sticky ATC
      if (sticky && atc) {
        /* Only one way to buy on screen: on phones the bar is there from the moment the page opens and whenever
           the big button is out of view (above or below), and steps aside as soon as the big button,
           "You may also like" / "Recently viewed" (own buttons) or the footer comes in. */
        var satc = { gone: false, block: {} };
        var satcSet = function () {
          /* the page was swapped (music player keeps playing): this bar is gone */
          if (!sticky.isConnected) { root.classList.remove('satc-on'); return; }
          var blocked = Object.keys(satc.block).some(function (k) { return satc.block[k]; });
          var show = satc.gone && !blocked;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          root.classList.toggle('satc-on', show);
          if (show) root.style.setProperty('--satc-h', sticky.offsetHeight + 'px');
        };
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          satc.gone = !entry.isIntersecting;
          satcSet();
        }, { threshold: 0 }).observe(atc);
        var satcIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { satc.block[e.target._satcId] = e.isIntersecting; });
          satcSet();
        }, { threshold: 0 });
        qsa('.product-recs, .site-footer').forEach(function (el, i) { el._satcId = 'b' + i; satcIO.observe(el); });
        qs('[data-sticky-add]', sticky).addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }

      // Thumbs + dots follow the media
      var mediaItems = stack ? qsa('[data-media-id]', stack) : [];
      var activeIndex = 0;
      var prevBtn = qs('[data-stack-prev]', section);
      var nextBtn = qs('[data-stack-next]', section);
      function markActive(id) {
        mediaItems.forEach(function (m, i) { if (m.getAttribute('data-media-id') === id) activeIndex = i; });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
        mediaItems.forEach(function (m, i) { if (dots[i]) dots[i].classList.toggle('is-active', i === activeIndex); });
        if (prevBtn) prevBtn.disabled = !isCarousel() && activeIndex === 0;
        if (nextBtn) nextBtn.disabled = !isCarousel() && activeIndex === mediaItems.length - 1;
      }
      function goTo(index) {
        if (isCarousel()) { car.go(index); return; }
        index = Math.max(0, Math.min(mediaItems.length - 1, index));
        if (mediaItems[index]) scrollToMedia(mediaItems[index].getAttribute('data-media-id'), true);
      }
      if (mediaItems.length) {
        var mediaObserver = new IntersectionObserver(function (entries) {
          if (isCarousel()) return;
          entries.forEach(function (en) { if (en.isIntersecting) markActive(en.target.getAttribute('data-media-id')); });
        }, { threshold: 0.6, root: null });
        mediaItems.forEach(function (m) { mediaObserver.observe(m); });
        stack.addEventListener('scroll', debounce(function () {
          if (!isRow()) return;
          var i = Math.round(stack.scrollLeft / Math.max(stack.clientWidth, 1));
          if (mediaItems[i]) markActive(mediaItems[i].getAttribute('data-media-id'));
        }, 40), { passive: true });
        markActive(mediaItems[0].getAttribute('data-media-id'));
        car = initCarousel(section, stack, mediaItems, markActive);
        if (car.active) markActive(mediaItems[activeIndex].getAttribute('data-media-id'));

        if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex + 1); });

        // Horizontal gallery on desktop: the mouse wheel moves sideways, one photo per notch
        var wheelLock = false;
        stack.addEventListener('wheel', function (e) {
          // The mouse wheel only steps through photos in the horizontal gallery; in the 3D carousel it scrolls the page.
          if (!isRow() || !isDesktop()) return;
          var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
          if (Math.abs(d) < 4) return;
          var dir = d > 0 ? 1 : -1;
          var atEnd = !isCarousel() && (dir > 0 && activeIndex >= mediaItems.length - 1) || (dir < 0 && activeIndex <= 0);
          if (atEnd) return;
          e.preventDefault();
          if (wheelLock) return;
          wheelLock = true;
          goTo(activeIndex + dir);
          setTimeout(function () { wheelLock = false; }, 650);
        }, { passive: false });

        document.addEventListener('keydown', function (e) {
          if (!(isRow() || isCarousel()) || e.target.closest('input, textarea, select') || qs('.modal.is-open')) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeIndex + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(activeIndex - 1); }
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { scrollToMedia(t.getAttribute('data-thumb'), true); });
      });

      // Zoom: magnifier on desktop, full-screen pinch zoom on touch
      if (section.getAttribute('data-zoom') === 'true') {
        var overlay = qs('[data-zoom-overlay]', section);
        var zImg = overlay && qs('[data-zoom-img]', overlay);
        qsa('[data-zoom-frame]', section).forEach(function (frame) {
          frame.addEventListener('click', function (e) {
            if (canHover() && isDesktop()) {
              frame.classList.toggle('is-zooming');
              setOrigin(e);
            } else if (overlay && zImg) {
              zImg.src = frame.getAttribute('data-zoom-src');
              overlay.classList.add('is-open');
              overlay.setAttribute('aria-hidden', 'false');
              root.classList.add('is-locked');
              var sc = qs('[data-zoom-scroller]', overlay);
              zImg.onload = function () {
                sc.scrollLeft = (zImg.scrollWidth - sc.clientWidth) / 2;
                sc.scrollTop = (zImg.scrollHeight - sc.clientHeight) / 2;
              };
            }
          });
          frame.addEventListener('mousemove', setOrigin);
          frame.addEventListener('mouseleave', function () { frame.classList.remove('is-zooming'); });
          function setOrigin(e) {
            var r = frame.getBoundingClientRect();
            frame.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%');
            frame.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%');
          }
        });
        if (overlay) {
          qs('[data-zoom-close]', overlay).addEventListener('click', function () {
            overlay.classList.remove('is-open');
            overlay.setAttribute('aria-hidden', 'true');
            root.classList.remove('is-locked');
          });
        }
      }

      // Start on the selected variant's image when the URL has ?variant=
      if (/[?&]variant=/.test(location.search)) {
        var v = data.variants.find(function (x) { return String(x.id) === (idInput && idInput.value); });
        if (v && v.media_id) setTimeout(function () { scrollToMedia(v.media_id, false); }, 50);
      }
    });
  }

  /* ---------- 3D carousel for the product gallery ---------- */
  // The photos sit on a ring: the current one in front, the others behind it,
  // blurred. Swiping, arrows, dots, thumbnails and the wheel turn the ring.
  function initCarousel(section, stack, items, onChange) {
    var n = items.length;
    var car = { active: false, pos: 0, items: items };
    function wrap(d) { d = ((d % n) + n) % n; if (d > n / 2) d -= n; return d; }
    function num(name, fb) { var v = parseFloat(getComputedStyle(section).getPropertyValue(name)); return isNaN(v) ? fb : v; }
    function wanted() {
      return n > 1 && section.classList.contains(isDesktop() ? 'product--desk-c' : 'product--mob-c');
    }
    function current() { return ((Math.round(car.pos) % n) + n) % n; }
    /* the ring settings are read once per swipe, not on every finger movement */
    var P = null;
    function params() {
      return { spread: num('--car-spread', 46), depth: num('--car-depth', 320), tilt: num('--car-tilt', 30), blur: num('--car-blur', 6), side: num('--car-side', .7) };
    }
    function render() {
      if (!dragging || !P) P = params();
      var spread = P.spread, depth = P.depth, tilt = P.tilt, blur = P.blur, side = P.side;
      var step = 2 * Math.PI / n, ref = Math.min(step, Math.PI / 2);
      var sx = 1 / Math.sin(ref), sz = 1 / (1 - Math.cos(ref));
      items.forEach(function (m, i) {
        var d = wrap(i - car.pos), th = d * step, near = Math.min(1, Math.abs(d));
        var v = m._cv || (m._cv = {});
        /* only what really changed is written (every write makes the browser work out the photo again) */
        function put(k, val) { if (v[k] !== val) { v[k] = val; m.style.setProperty(k, val); } }
        put('--x', (Math.sin(th) * sx * spread).toFixed(2));
        put('--z', ((Math.cos(th) - 1) * sz * depth).toFixed(1));
        put('--ry', (Math.max(-1.5, Math.min(1.5, Math.sin(th) * sx)) * tilt).toFixed(2));
        put('--b', (blur * near).toFixed(2) + 'px');
        put('--o', (1 - (1 - side) * near).toFixed(3));
        var zi = String(Math.round((Math.cos(th) + 1) * 50));
        if (v.z !== zi) { v.z = zi; m.style.zIndex = zi; }
        var isCur = Math.abs(d) < .5;
        if (v.cur !== isCur) {
          v.cur = isCur;
          m.classList.toggle('is-current', isCur);
          m.setAttribute('aria-hidden', isCur ? 'false' : 'true');
        }
      });
    }
    function clear() {
      items.forEach(function (m) {
        ['--x', '--z', '--ry', '--b', '--o'].forEach(function (p) { m.style.removeProperty(p); });
        m._cv = null;
        m.style.zIndex = '';
        m.classList.remove('is-current');
        m.removeAttribute('aria-hidden');
      });
    }
    function instant(fn) {
      stack.classList.add('is-dragging');
      fn();
      void stack.offsetWidth;
      stack.classList.remove('is-dragging');
    }
    car.go = function (index, now) {
      if (!car.active || index == null || isNaN(index)) return;
      index = ((index % n) + n) % n;
      car.pos = Math.round(car.pos) + wrap(index - Math.round(car.pos));
      qsa('.zoom-frame.is-zooming', stack).forEach(function (f) { f.classList.remove('is-zooming'); });
      holdBg(900);
      if (now) instant(render); else render();
      onChange(items[current()].getAttribute('data-media-id'));
    };
    function activate() {
      var on = wanted();
      if (on === car.active) { if (on) render(); return; }
      car.active = on;
      stack.classList.toggle('is-carousel', on);
      if (on) {
        // start on whatever photo was in view
        var idx = Math.max(0, items.findIndex(function (m) { return m.classList.contains('is-current'); }));
        car.pos = idx;
        instant(render);
        stack.scrollLeft = 0;
        onChange(items[current()].getAttribute('data-media-id'));
      } else {
        clear();
      }
    }

    // Swipe / drag
    var startX = 0, startY = 0, startPos = 0, down = false, dragging = false, suppress = false, rq = 0;
    /* the photos are redrawn at most once per screen frame while the finger moves */
    function renderSoon() { if (!rq) rq = requestAnimationFrame(function () { rq = 0; render(); }); }
    stack.addEventListener('pointerdown', function (e) {
      if (!car.active || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (e.target.closest('.zoom-frame.is-zooming, model-viewer, video, iframe')) return;
      down = true; dragging = false;
      startX = e.clientX; startY = e.clientY; startPos = car.pos;
    });
    stack.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (!dragging) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
        P = params();
        dragging = true;
        stack.classList.add('is-dragging');
        try { stack.setPointerCapture(e.pointerId); } catch (err) {}
      }
      e.preventDefault();
      holdBg(600);
      car.pos = startPos - dx / Math.max(stack.clientWidth * .55, 1);
      renderSoon();
    });
    function release(e) {
      if (!down) return;
      down = false;
      if (!dragging) return;
      dragging = false;
      var dx = (e && e.clientX != null ? e.clientX : startX) - startX;
      var target = Math.round(car.pos);
      if (target === startPos && Math.abs(dx) > 40) target = startPos - (dx > 0 ? 1 : -1);
      car.pos = target;
      if (rq) { cancelAnimationFrame(rq); rq = 0; }
      holdBg(900);
      stack.classList.remove('is-dragging');
      render();
      onChange(items[current()].getAttribute('data-media-id'));
      suppress = true;
      setTimeout(function () { suppress = false; }, 60);
    }
    stack.addEventListener('pointerup', release);
    stack.addEventListener('pointercancel', release);
    stack.addEventListener('dragstart', function (e) { if (car.active) e.preventDefault(); });
    // Click on a blurred photo turns the ring to it; a click right after a swipe is ignored
    stack.addEventListener('click', function (e) {
      if (!car.active) return;
      if (suppress) { e.preventDefault(); e.stopPropagation(); return; }
      var m = e.target.closest('[data-media-id]');
      if (m && !m.classList.contains('is-current')) {
        e.preventDefault(); e.stopPropagation();
        car.go(items.indexOf(m));
      }
    }, true);

    window.addEventListener('resize', debounce(activate, 120));
    activate();
    initShadowBake(stack);
    return car;
  }

  /* ---------- Product shadow as a ready-made picture (phones, 3D photo carousel) ----------
     The shadow / glow around the garment (Productschaduw) is a stack of soft CSS shadows. While the ring turns, Safari
     works them out again for every photo on every frame, which makes swiping stutter (worst with the wide funky glow).
     Here the exact same shadow is worked out once, put behind the photo as a picture, and the live CSS shadow is
     switched off. Anything that changes it (mode, photo, size) makes a new one; if it cannot be made, the CSS one stays. */
  var psColorCache = {};
  function psColor(col) {
    if (psColorCache[col]) return psColorCache[col];
    var c = document.createElement('canvas'); c.width = c.height = 1;
    var x = c.getContext('2d'); x.fillStyle = col; x.fillRect(0, 0, 1, 1);
    var d = x.getImageData(0, 0, 1, 1).data;
    return (psColorCache[col] = [d[0] / 255, d[1] / 255, d[2] / 255, d[3] / 255]);
  }
  function psParse(f) {
    var out = [], re = /drop-shadow\(((?:[^()]|\([^()]*\))*)\)/g, m;
    while ((m = re.exec(f || ''))) {
      var body = m[1], cm = /(rgba?\([^)]*\)|hsla?\([^)]*\)|#[0-9a-f]{3,8}\b|transparent|white|black)/i.exec(body);
      var col = cm ? cm[0] : 'rgb(0, 0, 0)';
      var n = (cm ? body.replace(col, ' ') : body).match(/-?[\d.]+/g) || [];
      out.push({ c: col, x: +n[0] || 0, y: +n[1] || 0, b: Math.max(0, +n[2] || 0) });
    }
    return out;
  }
  /* one box blur pass: every pixel becomes the average of the pixels lo..hi around it (zero outside) */
  function psBox(src, dst, W, H, lo, hi, horiz) {
    var inv = 1 / (hi - lo + 1), n = horiz ? W : H, lines = horiz ? H : W, st = horiz ? 1 : W, ls = horiz ? W : 1;
    for (var l = 0; l < lines; l++) {
      var o = l * ls, acc = 0, i;
      for (i = lo; i <= hi; i++) if (i >= 0 && i < n) acc += src[o + i * st];
      for (i = 0; i < n; i++) {
        dst[o + i * st] = acc * inv;
        var a = i + hi + 1, b = i + lo;
        if (a >= 0 && a < n) acc += src[o + a * st];
        if (b >= 0 && b < n) acc -= src[o + b * st];
      }
    }
  }
  /* Gaussian blur as three box blurs, exactly as the Filter Effects spec describes it (what Safari does too) */
  function psGauss(a, W, H, sigma) {
    if (sigma < 0.4) return a;
    var d = Math.floor(sigma * 3 * Math.sqrt(2 * Math.PI) / 4 + 0.5);
    if (d < 1) return a;
    var passes = d % 2
      ? [[-(d - 1) / 2, (d - 1) / 2], [-(d - 1) / 2, (d - 1) / 2], [-(d - 1) / 2, (d - 1) / 2]]
      : [[-d / 2, d / 2 - 1], [-d / 2 + 1, d / 2], [-d / 2, d / 2]];
    var t = new Float32Array(a.length), u = new Float32Array(a.length), src = a, dst = t;
    [true, false].forEach(function (horiz) {
      passes.forEach(function (p) {
        psBox(src, dst, W, H, p[0], p[1], horiz);
        src = dst; dst = dst === t ? u : t;
      });
    });
    return src;
  }
  /* alpha of what the frame shows (w x h CSS px, the photo at box b, cut off at the frame's edge) * k,
     with `pad` CSS px of room around it */
  function psAlpha(img, b, w, h, k, pad) {
    var W = Math.ceil((w + 2 * pad) * k), H = Math.ceil((h + 2 * pad) * k);
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.save(); x.beginPath(); x.rect(pad * k, pad * k, w * k, h * k); x.clip();
    x.drawImage(img, (pad + b.x) * k, (pad + b.y) * k, b.w * k, b.h * k);
    x.restore();
    var d = x.getImageData(0, 0, W, H).data, a = new Float32Array(W * H);
    for (var i = 0; i < a.length; i++) a[i] = d[i * 4 + 3] / 255;
    return { a: a, W: W, H: H, c: c, x: x };
  }
  /* only the shadows: every shadow is cast by the photo plus the shadows before it (like the CSS chain) */
  function psRender(A, shadows, k) {
    var W = A.W, H = A.H, N = W * H, aR = A.a, S = new Float32Array(N * 4), i;
    shadows.forEach(function (s) {
      var col = psColor(s.c); if (!col[3]) return;
      var dx = Math.round(s.x * k), dy = Math.round(s.y * k), m = new Float32Array(N), xx, yy;
      for (yy = 0; yy < H; yy++) {
        var sy = yy - dy; if (sy < 0 || sy >= H) continue;
        for (xx = 0; xx < W; xx++) { var sx = xx - dx; if (sx >= 0 && sx < W) m[yy * W + xx] = aR[sy * W + sx]; }
      }
      m = psGauss(m, W, H, s.b * k);
      for (i = 0; i < N; i++) {
        var sa = col[3] * m[i]; if (!sa) continue;
        var keep = 1 - S[i * 4 + 3];
        S[i * 4] += col[0] * sa * keep; S[i * 4 + 1] += col[1] * sa * keep; S[i * 4 + 2] += col[2] * sa * keep; S[i * 4 + 3] += sa * keep;
        aR[i] += sa * (1 - aR[i]);
      }
    });
    var out = A.x.createImageData(W, H), d = out.data;
    for (i = 0; i < N; i++) {
      var al = S[i * 4 + 3];
      if (al > 0) { d[i * 4] = S[i * 4] / al * 255; d[i * 4 + 1] = S[i * 4 + 1] / al * 255; d[i * 4 + 2] = S[i * 4 + 2] / al * 255; d[i * 4 + 3] = al * 255; }
    }
    A.x.clearRect(0, 0, W, H); A.x.putImageData(out, 0, 0);
    return A.c;
  }
  function psUnbake(frame) {
    if (frame._psCv) { frame._psCv.remove(); frame._psCv = null; }
    frame.classList.remove('ps-baked');
    frame._psKey = '';
  }
  function psBake(frame) {
    var img = qs('img.product__img', frame), media = frame.parentNode;
    if (!img || !media) return true;
    var shadows = psParse(getComputedStyle(frame).getPropertyValue('--ps-cur'));
    if (!shadows.length) { psUnbake(frame); return true; }
    if (!img.complete || !img.naturalWidth) return false;
    /* the shadow is cast by what the frame shows: the photo, cut off at the frame's edge */
    /* exact (sub-pixel) positions, measured with the photo's 3D turn briefly lifted (nothing is drawn in between) */
    var mt = media.style.transform, mtr = media.style.transition;
    media.style.transition = 'none';
    media.style.transform = 'none';
    var mr = media.getBoundingClientRect(), fr = frame.getBoundingClientRect(), ir = img.getBoundingClientRect();
    media.style.transform = mt;
    void getComputedStyle(media).transform; /* settle the turn back before the transition returns, so nothing animates */
    media.style.transition = mtr;
    var w = fr.width, h = fr.height;
    var fx = fr.left - mr.left - media.clientLeft, fy = fr.top - mr.top - media.clientTop;
    var bx = { x: ir.left - fr.left, y: ir.top - fr.top, w: ir.width, h: ir.height };
    if (!w || !h || !bx.w || !bx.h) return false;
    /* where the picture really sits inside its box ('contain' / 'cover' leave or cut a margin) */
    var fit = getComputedStyle(img).objectFit, nr = img.naturalWidth / img.naturalHeight, br = bx.w / bx.h;
    if ((fit === 'contain' && nr > br) || (fit === 'cover' && nr < br)) { var nh = bx.w / nr; bx.y += (bx.h - nh) / 2; bx.h = nh; }
    else if (fit === 'contain' || fit === 'cover') { var nw = bx.h * nr; bx.x += (bx.w - nw) / 2; bx.w = nw; }
    var key = JSON.stringify(shadows) + '|' + (img.currentSrc || img.src) + '|' + [fx, fy, w, h, bx.x, bx.y, bx.w, bx.h].map(function (q) { return q.toFixed(1); }).join(',');
    if (frame._psKey === key && frame._psCv) return true;
    var minB = Infinity, reach = 0;
    shadows.forEach(function (s) { minB = Math.min(minB, s.b); reach = Math.max(reach, 3 * s.b + Math.max(Math.abs(s.x), Math.abs(s.y))); });
    /* soft glows are smooth, so they are worked out at a lower resolution; sharp outlines at full resolution */
    var k = minB < 2 ? Math.min(2, window.devicePixelRatio || 1) : minB >= 6 ? 0.5 : 1;
    var pad = Math.ceil(reach) + 2, cv, src = img.currentSrc || img.src;
    /* the photo is read through a CORS copy when the browser does not allow reading the page's own copy */
    var pic = frame._psCors && frame._psCors.src0 === src && frame._psCors.complete && frame._psCors.naturalWidth ? frame._psCors : img;
    try { cv = psRender(psAlpha(pic, bx, w, h, k, pad), shadows, k); }
    catch (err) {
      if (pic === img && !(frame._psCors && frame._psCors.src0 === src)) {
        var im = new Image(); im.crossOrigin = 'anonymous'; im.src0 = src;
        im.onload = function () { if (frame._psRetry) frame._psRetry(); };
        im.onerror = function () { frame._psFail = src; };
        im.src = src + (src.indexOf('?') < 0 ? '?' : '&') + 'cors=1';
        frame._psCors = im;
      } else frame._psFail = src;
      return true;
    }
    cv.className = 'ps-bake';
    cv.setAttribute('aria-hidden', 'true');
    cv.style.left = (fx - pad) + 'px';
    cv.style.top = (fy - pad) + 'px';
    cv.style.width = (cv.width / k) + 'px';
    cv.style.height = (cv.height / k) + 'px';
    if (frame._psCv) frame._psCv.replaceWith(cv); else media.insertBefore(cv, frame);
    frame._psCv = cv;
    frame._psKey = key;
    frame.classList.add('ps-baked');
    return true;
  }
  function initShadowBake(stack) {
    if (stack._psBake) { stack._psBake(); return; }
    var mq = window.matchMedia('(max-width: 989px)'), queue = [], timer = 0;
    function frames() { return qsa('.zoom-frame', stack); }
    function on() { return mq.matches && stack.classList.contains('is-carousel'); }
    function run() {
      timer = 0;
      if (!stack.isConnected) return;
      /* never in the middle of a swipe or a turn: it waits until the photos stand still */
      if (stack.classList.contains('is-dragging') || performance.now() < bgHoldUntil) { timer = setTimeout(run, 250); return; }
      var f = queue.shift();
      if (!f) return;
      if (!on()) { psUnbake(f); }
      else if (f._psFail !== ((qs('img.product__img', f) || {}).currentSrc || '') && !psBake(f)) {
        /* photo not loaded yet: it is done again once it has loaded */
      }
      if (queue.length) timer = setTimeout(run, 30);
    }
    function refresh() {
      /* the photo in front first */
      var list = frames().sort(function (a, b) {
        return (b.parentNode.classList.contains('is-current') ? 1 : 0) - (a.parentNode.classList.contains('is-current') ? 1 : 0);
      });
      list.forEach(function (f) { if (queue.indexOf(f) < 0) queue.push(f); });
      if (!timer) timer = setTimeout(run, 60);
    }
    stack._psBake = refresh;
    frames().forEach(function (f) {
      f._psRetry = refresh;
      var img = qs('img.product__img', f);
      if (img) img.addEventListener('load', refresh);
    });
    new MutationObserver(refresh).observe(root, { attributes: true, attributeFilter: ['data-mode', 'data-funky'] });
    /* carousel switched on / off (e.g. turning the phone) */
    var wasCar = stack.classList.contains('is-carousel');
    new MutationObserver(function () {
      var isCar = stack.classList.contains('is-carousel');
      if (isCar !== wasCar) { wasCar = isCar; refresh(); }
    }).observe(stack, { attributes: true, attributeFilter: ['class'] });
    if (window.ResizeObserver) new ResizeObserver(debounce(refresh, 150)).observe(stack);
    if (mq.addEventListener) mq.addEventListener('change', refresh);
    refresh();
  }

  /* ---------- Filtering + sorting ---------- */
  var openFacetsEl = null;
  function closeFacets() {
    if (!openFacetsEl) return;
    openFacetsEl.classList.remove('is-open');
    openFacetsEl.setAttribute('aria-hidden', 'true');
    openFacetsEl = null;
    if (!openDrawerEl) { scrim(false); root.classList.remove('is-locked'); }
  }
  function showPane(panel, name) {
    qsa('[data-facets-tab]', panel).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-facets-tab') === name); });
    qsa('[data-facets-pane]', panel).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-facets-pane') === name); });
    panel.classList.toggle('is-sort', name === 'sort');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-facets-open]');
    if (opener) {
      var panel = document.getElementById(opener.getAttribute('aria-controls'));
      if (!panel) return;
      var tab = opener.getAttribute('data-facets-open');
      if (openFacetsEl === panel && panel.classList.contains('is-sort') === (tab === 'sort')) { closeFacets(); return; }
      showPane(panel, tab);
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      openFacetsEl = panel;
      if (!isDesktop()) { scrim(true); root.classList.add('is-locked'); }
      return;
    }
    var tabBtn = e.target.closest('[data-facets-tab]');
    if (tabBtn) { showPane(tabBtn.closest('[data-facets]'), tabBtn.getAttribute('data-facets-tab')); return; }
    if (e.target.closest('[data-facets-close]')) { e.preventDefault(); closeFacets(); return; }
    var clear = e.target.closest('[data-facets-clear]');
    if (clear) {
      e.preventDefault();
      var p = clear.closest('[data-facets]');
      renderFacets(p, clear.getAttribute('href'), true);
      return;
    }
    if (openFacetsEl && isDesktop() && !e.target.closest('[data-facets]')) closeFacets();
  });

  function facetsUrl(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var base = form.getAttribute('action').split('?')[0];
    var q = params.toString();
    return base + (q ? '?' + q : '');
  }
  function renderFacets(panel, url, push) {
    if (!panel) return;
    var sectionId = panel.getAttribute('data-section-id');
    var feedRoot = panel.closest('[data-feed-root]');
    var results = feedRoot && qs('[data-results]', feedRoot);
    if (results) results.style.opacity = '.45';
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var newResults = qs('[data-results]', doc);
        if (results && newResults) {
          results.innerHTML = newResults.innerHTML;
          results.style.opacity = '';
        }
        var activeEl = qs('[data-facets-pane].is-active', panel);
        var activePane = activeEl ? activeEl.getAttribute('data-facets-pane') : 'filter';
        var newBody = qs('[data-facets-body]', doc);
        var body = qs('[data-facets-body]', panel);
        if (newBody && body) { body.innerHTML = newBody.innerHTML; showPane(panel, activePane); }
        var newCount = qs('[data-active-count]', doc);
        qsa('[data-active-count]', feedRoot).forEach(function (c) {
          if (newCount) { c.textContent = newCount.textContent; c.classList.toggle('is-empty', newCount.classList.contains('is-empty')); }
        });
        if (push) { history.pushState({ facets: true }, '', url); facetsPushed = true; }
        initFeeds(feedRoot);
        initCarousels(feedRoot);
        var first = qs('[data-slide]', feedRoot);
        if (first) updateCounter(feedRoot, 1);
        if (!root.classList.contains('view-grid')) window.scrollTo({ top: feedRoot.offsetTop, behavior: 'smooth' });
      })
      .catch(function () { if (results) results.style.opacity = ''; toast(strings.error); });
  }
  var facetChange = debounce(function (form) {
    renderFacets(form.closest('[data-facets]'), facetsUrl(form), true);
  }, 350);
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form) return;
    var chip = e.target.closest('.chip');
    if (chip) chip.classList.toggle('is-active', e.target.checked);
    if (e.target.name === 'sort_by') {
      qsa('.sort-list__item', form).forEach(function (i) { i.classList.toggle('is-active', qs('input', i).checked); });
      renderFacets(form.closest('[data-facets]'), facetsUrl(form), true);
      setTimeout(closeFacets, 150);
      return;
    }
    facetChange(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    renderFacets(form.closest('[data-facets]'), facetsUrl(form), true);
  });
  var facetsPushed = false;
  window.addEventListener('popstate', function (e) {
    var isFacetState = e.state && e.state.facets;
    if (!isFacetState && !facetsPushed) return;
    if (!qs('[data-facets]')) return;
    renderFacets(qs('[data-facets]'), location.pathname + location.search, false);
  });

  /* ---------- Predictive search ---------- */
  function initPredictive() {
    var input = qs('[data-predictive-input]');
    var out = qs('[data-predictive-results]');
    if (!input || !out || input._bound) return;
    input._bound = true;
    var run = debounce(function () {
      var q = input.value.trim();
      if (!q) { out.innerHTML = ''; return; }
      var url = routes.predictive + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var p = qs('[data-predictive]', doc);
          out.innerHTML = p ? p.outerHTML : '';
        })
        .catch(function () {});
    }, 260);
    input.addEventListener('input', run);
  }

  /* ---------- Enter page ---------- */
  function initEnterPage() {
    var enter = qs('[data-enter-page]');
    if (!enter || enter._bound) return;
    enter._bound = true;
    if (root.classList.contains('enter-skip')) { enter.remove(); return; }
    // Arriving on a section link (e.g. /#faq): skip the enter page and go straight there
    if (location.hash && location.hash.length > 1 && document.getElementById(location.hash.slice(1))) {
      enter.remove(); root.classList.remove('has-enter'); root.classList.add('enter-done');
      return;
    }
    function dismiss() {
      try { sessionStorage.setItem('borba-entered', '1'); } catch (e) {}
      root.classList.add('enter-done');
      root.classList.remove('has-enter');
      setTimeout(function () { if (!B.designMode) enter.remove(); }, 800);
      document.dispatchEvent(new CustomEvent('enter:done'));
    }
    qsa('[data-enter-dismiss]', enter).forEach(function (b) { b.addEventListener('click', dismiss); });
  }

  /* ---------- Email popup ---------- */
  function initPopup() {
    var popup = qs('[data-email-popup]');
    if (!popup || popup._bound) return;
    popup._bound = true;
    var key = 'borba-popup-hide';
    var days = parseInt(popup.getAttribute('data-days'), 10) || 14;
    var success = qs('[data-popup-success]', popup);
    function hideFor(d) { store(key, String(Date.now() + d * 864e5)); }
    popup.addEventListener('modal:close', function () { hideFor(days); });
    if (success && (!B.postedForm || B.postedForm === 'EmailPopupForm')) { hideFor(365); openModal(popup); return; }
    if (popup.getAttribute('data-preview') === 'true') { openModal(popup); return; }
    var until = parseInt(store(key) || '0', 10);
    if (until > Date.now()) return;
    var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 0) * 1000;
    function schedule() {
      setTimeout(function () {
        if (openDrawerEl || qs('.modal.is-open') || root.classList.contains('has-enter')) {
          setTimeout(schedule, 4000);
          return;
        }
        openModal(popup);
      }, delay);
    }
    if (root.classList.contains('has-enter')) document.addEventListener('enter:done', schedule, { once: true });
    else schedule();
  }

  /* ---------- Sign-up forms (customer form → Shopify Customers) ---------- */
  function initSignups() {
    var params = new URLSearchParams(location.search);
    var posted = null;
    try { posted = sessionStorage.getItem('borba-signup'); } catch (e) {}
    B.postedForm = params.get('customer_posted') === 'true' ? posted : null;
    qsa('form[data-signup]').forEach(function (form) {
      if (form._bound) return; form._bound = true;
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem('borba-signup', form.id); } catch (e) {}
      });
      var success = qs('[data-signup-success]', form);
      var fields = qs('[data-signup-fields]', form);
      // Shopify marks every customer form as "posted"; only keep the success view on the form that was used.
      if (success && posted && posted !== form.id) {
        success.hidden = true;
        if (fields) fields.hidden = false;
      }
      if (success && posted === form.id && params.get('customer_posted') === 'true') {
        setTimeout(function () { form.scrollIntoView({ block: 'center' }); }, 300);
      }
    });
    if (params.get('customer_posted') === 'true') {
      try { sessionStorage.removeItem('borba-signup'); } catch (e) {}
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    var code = btn.getAttribute('data-copy-code');
    var label = qs('[data-copy-label]', btn);
    var done = function () {
      if (label) { var old = label.textContent; label.textContent = label.getAttribute('data-copied'); setTimeout(function () { label.textContent = old; }, 1800); }
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
    else {
      var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {} t.remove(); done();
    }
  });

  /* ---------- Lookbook hotspots ---------- */
  function closeHotspots(except) {
    qsa('[data-hotspot].is-open').forEach(function (h) {
      if (h === except) return;
      h.classList.remove('is-open');
      var t = qs('[data-hotspot-toggle]', h); if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-hotspot-toggle]');
    if (toggle) {
      var spot = toggle.closest('[data-hotspot]');
      var open = !spot.classList.contains('is-open');
      closeHotspots(spot);
      spot.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (e.target.closest('[data-hotspot-close]')) { closeHotspots(); return; }
    if (!e.target.closest('.hotspot__card')) closeHotspots();
    var nav = e.target.closest('[data-lookbook-prev], [data-lookbook-next]');
    if (nav) {
      var track = qs('[data-lookbook-track]', nav.closest('[data-lookbook]'));
      var item = track && qs('.look', track);
      if (track) track.scrollBy({ left: (nav.hasAttribute('data-lookbook-next') ? 1 : -1) * (item ? item.getBoundingClientRect().width : track.clientWidth), behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeHotspots(); });

  /* ---------- Gallery lightbox ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-lightbox-src]');
    if (open) {
      var lb = qs('[data-lightbox]', open.closest('[data-gallery]'));
      if (!lb) return;
      qs('[data-lightbox-img]', lb).src = open.getAttribute('data-lightbox-src');
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      root.classList.add('is-locked');
      return;
    }
    var lbEl = e.target.closest('[data-lightbox]');
    if (lbEl && (e.target === lbEl || e.target.closest('[data-lightbox-close]'))) {
      lbEl.classList.remove('is-open');
      lbEl.setAttribute('aria-hidden', 'true');
      root.classList.remove('is-locked');
    }
  });

  /* ---------- Internal links to the homepage never show the Enter Page ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    var rootPath = (routes.root || '/').replace(/\/$/, '') || '/';
    var path = url.pathname.replace(/\/$/, '') || '/';
    if (url.host === location.host && path === rootPath) {
      try { sessionStorage.setItem('borba-skip-enter', '1'); } catch (err) {}
    }
  }, true);

  /* ---------- Small helpers ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-recover]');
    if (t) { e.preventDefault(); var r = qs('[data-recover-panel]'); if (r) r.classList.toggle('is-open'); }
  });

  /* ---------- Funky mode: liquid background ----------
     A small WebGL shader paints flowing colour (domain-warped noise) in the 5 funky colours.
     Scrolling moves the pattern along and stirs it like water; every page gets its own seed.
     Falls back to the CSS gradient layers when WebGL is not available. */
  var FUNKY_VERT = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  /* highp: Android GPUs (Mali/Adreno) really compute 'mediump' in 16-bit, which breaks this noise into
     blocks; full precision gives the same smooth flow on every phone. */
  var FUNKY_FRAG = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec2 uRes;uniform float uTime,uScroll,uVel,uSeed,uStrength;',
    'uniform vec3 c1,c2,c3,c4,c5;uniform float uDim;',
    'vec3 perm(vec3 x){return mod(((x*34.)+1.)*x,289.);}',
    'float snoise(vec2 v){const vec4 C=vec4(.211324865405187,.366025403784439,-.577350269189626,.024390243902439);',
    'vec2 i=floor(v+dot(v,C.yy));vec2 x0=v-i+dot(i,C.xx);vec2 i1=(x0.x>x0.y)?vec2(1.,0.):vec2(0.,1.);',
    'vec4 x12=x0.xyxy+C.xxzz;x12.xy-=i1;i=mod(i,289.);',
    'vec3 p=perm(perm(i.y+vec3(0.,i1.y,1.))+i.x+vec3(0.,i1.x,1.));',
    'vec3 m=max(.5-vec3(dot(x0,x0),dot(x12.xy,x12.xy),dot(x12.zw,x12.zw)),0.);m=m*m;m=m*m;',
    'vec3 x=2.*fract(p*C.www)-1.;vec3 h=abs(x)-.5;vec3 ox=floor(x+.5);vec3 a0=x-ox;',
    'm*=1.79284291400159-.85373472095314*(a0*a0+h*h);',
    'vec3 g;g.x=a0.x*x0.x+h.x*x0.y;g.yz=a0.yz*x12.xz+h.yz*x12.yw;return 130.*dot(m,g);}',
    'float fbm(vec2 p){float f=0.,a=.55;for(int i=0;i<3;i++){f+=a*snoise(p);p=p*1.9+vec2(1.7,9.2);a*=.45;}return .5+.5*f;}',
    'void main(){',
    ' vec2 uv=gl_FragCoord.xy/uRes.y;',
    ' uv.x+=sin(uv.y*2.6+uTime*.5)*.03*uVel*uStrength;',
    ' uv.y+=cos(uv.x*2.2-uTime*.4)*.02*uVel*uStrength;',
    ' float t=uTime*.03;',
    ' vec2 base=uv*.62+vec2(uSeed,uSeed*.61);',
    ' vec2 q=vec2(fbm(base+vec2(0.,t)),fbm(base+vec2(5.2,1.3)-t));',
    ' float w=1.5+uVel*uStrength*.25;',
    ' vec2 r=vec2(fbm(base+w*q+vec2(1.7,9.2)+t*.6),fbm(base+w*q+vec2(8.3,2.8)-t*.4));',
    ' float f=fbm(base*1.05+w*r);',
    ' float g=fbm(base*.7+r*1.1+vec2(3.1,7.7));',
    ' vec3 col=c1;',
    ' col=mix(col,c2,smoothstep(.37,.58,f));',
    ' col=mix(col,c3,smoothstep(.5,.72,f));',
    ' col=mix(col,c4,smoothstep(.64,.88,f)*.8);',
    ' col=mix(col,c5,smoothstep(.5,.76,g)*smoothstep(.32,.55,f)*.9);',
    ' gl_FragColor=vec4(col*(1.-uDim),1.);',
    '}'
  ].join('\n');

  /* While photos are being swiped sideways the flowing background holds still for a moment (and then simply
     continues where it was), so the phone can spend all its power on the photos. */
  var bgHoldUntil = 0;
  function holdBg(ms) { var t = performance.now() + ms; if (t > bgHoldUntil) bgHoldUntil = t; }
  var hLeft = new WeakMap();
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || el.nodeType !== 1) return;
    var x = el.scrollLeft, was = hLeft.get(el);
    hLeft.set(el, x);
    if (was != null && was !== x) holdBg(450);
  }, { capture: true, passive: true });

  function hexOrRgb(str) {
    var m = String(str).trim().split(/[\s,]+/).map(Number);
    return [m[0] / 255 || 0, m[1] / 255 || 0, m[2] / 255 || 0];
  }
  function initFunkyLiquid() {
    if (root.getAttribute('data-funky-liquid') !== 'on' || root._funkyLiquid) return;
    root._funkyLiquid = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tpl = (document.body.className.match(/template-[\w-]+/) || ['template-index'])[0];
    var seed = 0;
    for (var i = 0; i < tpl.length; i++) seed = (seed * 31 + tpl.charCodeAt(i)) % 997;
    seed = seed / 37;
    var strength = parseFloat(root.getAttribute('data-funky-liquid-strength') || '1') || 1;
    var views = [];

    qsa('.funky-bg').forEach(function (bg, idx) {
      var canvas = document.createElement('canvas');
      canvas.className = 'funky-bg__canvas';
      var gl = canvas.getContext('webgl', { alpha: false, antialias: false, depth: false, preserveDrawingBuffer: false, powerPreference: 'low-power' });
      if (!gl) return;
      /* a GPU without full precision would draw the flow in blocks: then keep the soft CSS gradient instead */
      var hp = gl.getShaderPrecisionFormat && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
      if (!hp || hp.precision < 16) return;
      function sh(type, src) { var o = gl.createShader(type); gl.shaderSource(o, src); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; }
      var vs = sh(gl.VERTEX_SHADER, FUNKY_VERT), fs = sh(gl.FRAGMENT_SHADER, FUNKY_FRAG);
      if (!vs || !fs) return;
      var prog = gl.createProgram(); gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
      gl.useProgram(prog);
      var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      var u = {};
      ['uRes', 'uTime', 'uScroll', 'uVel', 'uSeed', 'uStrength', 'uDim', 'c1', 'c2', 'c3', 'c4', 'c5'].forEach(function (n) { u[n] = gl.getUniformLocation(prog, n); });
      bg.insertBefore(canvas, bg.firstChild);
      bg.classList.add('funky-bg--gl');
      /* same seed everywhere: the Enter Page shows exactly the same flow as the homepage behind it */
      views.push({ bg: bg, canvas: canvas, gl: gl, u: u, local: bg.classList.contains('funky-bg--local'), seed: seed });
    });
    if (!views.length) return;

    var scale = 0.5, last = performance.now(), time = 0, active = 0, lastY = window.scrollY, lastScrollAt = 0, running = false;
    /* the flow is slow and soft-focused: ~30 new pictures a second look exactly the same as 60, and leave the phone
       twice as much room for smooth scrolling and swiping (every glass panel on top is redrawn with each picture) */
    var FRAME_MS = 1000 / 30 - 4, lastDraw = -1e9;
    function size(v) {
      var w = Math.max(1, Math.round(v.bg.clientWidth * scale)), h = Math.max(1, Math.round(v.bg.clientHeight * scale));
      if (v.canvas.width !== w || v.canvas.height !== h) { v.canvas.width = w; v.canvas.height = h; v.gl.viewport(0, 0, w, h); }
    }
    function colors(v) {
      var cs = getComputedStyle(root);
      ['c1', 'c2', 'c3', 'c4', 'c5'].forEach(function (n, k) {
        var c = hexOrRgb(cs.getPropertyValue('--f' + (k + 1)));
        v.gl.uniform3f(v.u[n], c[0], c[1], c[2]);
      });
      /* the darkening layer is drawn straight into the flow (same result, one full-screen layer less to blend) */
      var dim = qs('.funky-bg__dim', v.bg);
      v.gl.uniform1f(v.u.uDim, dim ? Math.max(0, Math.min(1, parseFloat(getComputedStyle(dim).opacity) || 0)) : 0);
    }
    views.forEach(function (v) { size(v); colors(v); });
    window.addEventListener('resize', debounce(function () { views.forEach(size); }, 150));

    function visible(v) {
      if (!v.local) return true;
      return !root.classList.contains('enter-done') && !root.classList.contains('enter-skip') && v.bg.offsetParent !== null;
    }
    function frame(now) {
      if (root.getAttribute('data-funky') !== 'on' || document.hidden) { running = false; return; }
      /* while a panel is sliding open/closed, hold the background still for a moment so the motion stays smooth */
      if (root.classList.contains('is-busy')) { last = now; requestAnimationFrame(frame); return; }
      if (now < bgHoldUntil) { last = now; requestAnimationFrame(frame); return; }
      if (now - lastDraw < FRAME_MS) { requestAnimationFrame(frame); return; }
      lastDraw = now;
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      var y = window.scrollY;
      if (y !== lastY) { lastScrollAt = now; lastY = y; }
      // Scrolling (any speed) eases the flow to ONE calm tempo; it never speeds up with fast swipes.
      var target = now - lastScrollAt < 180 ? 1 : 0;
      active += (target - active) * Math.min(1, dt * (target ? 2.2 : 1.1));
      var motion = root.getAttribute('data-funky-motion') === 'on' && !reduce;
      time += dt * ((motion ? 0.55 : 0) + active * 0.5 * Math.min(1.5, strength));
      views.forEach(function (v) {
        if (!visible(v)) return;
        var gl = v.gl, u = v.u;
        gl.uniform2f(u.uRes, v.canvas.width, v.canvas.height);
        gl.uniform1f(u.uTime, time);
        gl.uniform1f(u.uScroll, 0);
        gl.uniform1f(u.uVel, v.local ? 0 : (reduce ? active * 0.3 : active));
        gl.uniform1f(u.uSeed, v.seed);
        gl.uniform1f(u.uStrength, strength);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      });
      requestAnimationFrame(frame);
    }
    function start() {
      if (running || root.getAttribute('data-funky') !== 'on') return;
      running = true; last = performance.now(); lastY = window.scrollY; lastScrollAt = 0;
      views.forEach(function (v) { size(v); colors(v); });
      requestAnimationFrame(frame);
    }
    new MutationObserver(start).observe(root, { attributes: true, attributeFilter: ['data-funky', 'data-mode'] });
    document.addEventListener('visibilitychange', start);
    start();
  }

  /* ---------- Product recommendations ("You may also like") ---------- */
  function initRecommendations(ctx) {
    qsa('[data-product-recs]', ctx).forEach(function (sec) {
      if (sec._loaded) return; sec._loaded = true;
      var url = sec.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = parseHTML(html);
        var fresh = qs('[data-product-recs]', doc);
        if (!fresh) return;
        var inner = qs('[data-recs-inner]', fresh);
        if (!inner) { if (!B.designMode) sec.hidden = true; return; }
        sec.innerHTML = fresh.innerHTML;
        initRails(sec);
      }).catch(function () {});
    });
  }

  /* ---------- Trust line under "Add to cart": two points side by side. When a text has to wrap to two lines,
     its box is shrunk to the wrapped text so there is no empty space next to it and the pair stays neatly centred ---------- */
  function fitTrustRow(sp) {
    var r = document.createRange(); r.selectNodeContents(sp);
    var rs = r.getClientRects(); if (!rs.length) return;
    var top = rs[0].top, multi = false, l = Infinity, rr = -Infinity;
    for (var i = 0; i < rs.length; i++) { if (!rs[i].width) continue; if (Math.abs(rs[i].top - top) > 2) multi = true; l = Math.min(l, rs[i].left); rr = Math.max(rr, rs[i].right); }
    if (multi && rr > l) sp.style.width = Math.ceil(rr - l + 1) + 'px';
  }
  function fitTrust() {
    var sps = qsa('.trust__points--row .trust__point > span');
    if (!sps.length) return;
    sps.forEach(function (sp) { sp.style.width = ''; });
    for (var pass = 0; pass < 2; pass++) sps.forEach(function (sp) { if (pass) sp.style.width = ''; fitTrustRow(sp); });
  }
  var fitTrustOn = false;
  function initTrust() {
    fitTrust();
    if (fitTrustOn) return; fitTrustOn = true;
    window.addEventListener('resize', debounce(fitTrust, 120));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTrust);
  }

  /* ---------- Product cards: name · price on one row; only when the name does not fit next to the price
     the two go under each other (no cut-off names) ---------- */
  function fitCards(ctx) {
    liftCards(ctx);
    qsa('.pcard__info', ctx).forEach(function (info) {
      var t = qs('.slide__title', info); if (!t || !info.offsetParent) return;
      info.classList.remove('is-stack');
      if (t.scrollWidth > t.clientWidth + 1) info.classList.add('is-stack');
    });
  }
  /* Every product card (The Drop, You may also like, Recently viewed, cart), phone and desktop: the garment sits
     a small margin under the top (Productkaart → Ruimte boven kleding) with the sizes right under it — never on it,
     only made a little smaller if it would not fit. The garment fills about the middle of each product photo:
     roughly 12% empty above it and 13% below it inside the picture. */
  function picBox(img) {
    var w = img.offsetWidth, h = img.offsetHeight, nw = img.naturalWidth, nh = img.naturalHeight;
    if (!w || !h || !nw || !nh) return null;
    var cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0, pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var cw = w - pl - pr, ch = h - pt - pb; if (cw <= 0 || ch <= 0) return null;
    var k = Math.min(cw / nw, ch / nh), ph = nh * k;
    var r = img.getBoundingClientRect(), s = r.height / h, cy = r.top + r.height / 2;
    var top = cy + (pt + (ch - ph) / 2 - h / 2) * s;
    return { top: top, h: ph * s };
  }
  /* one card: where the garment can go (below the top margin and below a label like "Uitverkocht",
     above the sizes) and how much taller the photo box must be so it fits at its own size */
  function liftMeasure(u) {
    var p = picBox(u.img);
    if (!p) return null;
    var br = u.box.getBoundingClientRect();
    var pct = (parseFloat(root.getAttribute('data-card-top')) || 5) / 100, m = Math.max(6, br.width * pct);
    var top = br.top + m, bot;
    if (u.badge && u.badge.children.length) {
      var bb = u.badge.getBoundingClientRect();
      if (bb.height > 0) top = Math.max(top, bb.bottom + 6);
    }
    if (u.qa) {
      /* desktop: the sizes wait 4px lower until you point at the product; measure where they will be */
      var qy = 0; try { qy = new DOMMatrix(getComputedStyle(u.qa).transform).m42 || 0; } catch (e) {}
      bot = u.qa.getBoundingClientRect().top - qy - 6;
    } else bot = br.bottom - m;
    var sTop = p.top + p.h * 0.12, sH = p.h * 0.75;
    return { top: top, bot: bot, sTop: sTop, sH: sH, extra: Math.max(0, sH - (bot - top)), bh: br.height };
  }
  /* a row of cards: the garment never gets smaller; when it doesn't fit, every photo box in the row gets a
     little taller (all the same, so the row stays even), then each garment is centred in its room */
  function liftGroup(units, boxes) {
    units.forEach(function (u) { u.holder.style.removeProperty('--lift-y'); u.holder.style.removeProperty('--fit'); });
    boxes.forEach(function (b) { b.style.height = ''; });
    var ms = [], extra = 0, waiting = false;
    units.forEach(function (u) {
      var m = liftMeasure(u);
      if (!m) { waiting = true; if (!u.img._liftWait) { u.img._liftWait = true; u.img.addEventListener('load', function () { u.img._liftWait = false; liftCardsSoon(); }, { once: true }); } }
      ms.push(m); if (m) extra = Math.max(extra, m.extra);
    });
    if (extra > 0.5) {
      var bh = 0; ms.forEach(function (m) { if (m) bh = Math.max(bh, m.bh); });
      boxes.forEach(function (b) { b.style.height = Math.ceil(bh + extra + 1) + 'px'; });
      ms = units.map(liftMeasure);
    }
    units.forEach(function (u, i) {
      var m = ms[i]; if (!m) return;
      var ty = (m.top + m.bot) / 2 - (m.sTop + m.sH / 2);
      if (Math.abs(ty) > 0.5) u.holder.style.setProperty('--lift-y', ty.toFixed(1) + 'px');
    });
    return waiting;
  }
  function liftUnitCard(c) {
    var fr = qs('.pcard__frame', c), media = qs('.pcard__media', c), qa = qs('.quick-add', c);
    if (!fr || !media) return null;
    if (qa && getComputedStyle(qa).display === 'none') qa = null;
    return { img: qs('.pcard__img:not(.pcard__img--swap)', fr), qa: qa, box: media, holder: fr, badge: qs('.pcard__badges', media) };
  }
  function liftCards(ctx) {
    initFeather(ctx);
    /* product cards, grouped per row (rail / grid) */
    var groups = [];
    qsa('.pcard', ctx).forEach(function (c) {
      if (!c.offsetParent) return;
      var g = c.closest('.rail, .tile-grid') || c.parentElement;
      var f = groups.filter(function (x) { return x.el === g; })[0];
      if (!f) { f = { el: g, cards: [] }; groups.push(f); }
      f.cards.push(c);
    });
    groups.forEach(function (g) {
      var units = g.cards.map(liftUnitCard).filter(function (u) { return u && u.img; });
      liftGroup(units, units.map(function (u) { return u.box; }));
    });
    /* cart: the front card is measured, every photo box in the carousel gets the same height */
    qsa('.upsell--3d', ctx).forEach(function (up) {
      var cur = qs('.upsell__item.is-current', up) || qs('.upsell__item', up);
      if (!cur) return;
      var qa = qs('.quick-add', cur); if (qa && getComputedStyle(qa).display === 'none') qa = null;
      var u = { img: qs('.upsell__img img', cur), qa: qa, box: qs('.upsell__img', cur), holder: up, badge: null };
      if (!u.img || !u.box) return;
      liftGroup([u], qsa('.upsell__img', up));
    });
  }
  var liftCardsSoon = debounce(function () { liftCards(); }, 60);
  var fitCardsOn = false;
  function initCardFit() {
    fitCards();
    if (fitCardsOn) return; fitCardsOn = true;
    window.addEventListener('resize', debounce(function () { fitCards(); }, 120));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitCards(); });
  }

  /* ---------- "Recent bekeken": products this visitor viewed before (kept in this browser only) ---------- */
  var RV_KEY = 'borba-rv';
  function rvRead() { try { var a = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); return Array.isArray(a) ? a.filter(function (h) { return typeof h === 'string' && h; }) : []; } catch (e) { return []; } }
  function rvWrite(a) { try { localStorage.setItem(RV_KEY, JSON.stringify(a.slice(0, 24))); } catch (e) {} }
  function initRecentlyViewed(ctx) {
    qsa('[data-rv]', ctx).forEach(function (sec) {
      if (sec._rv) return; sec._rv = true;
      var cur = sec.getAttribute('data-rv-current') || '';
      var limit = parseInt(sec.getAttribute('data-rv-limit'), 10) || 6;
      var seen = rvRead().filter(function (h) { return h !== cur; });
      if (cur && !B.designMode) rvWrite([cur].concat(seen));
      var want = seen.slice(0, limit), track = qs('[data-rv-track]', sec);
      if (!want.length || !track) { if (!B.designMode) sec.hidden = true; return; }
      var base = String(routes.root || '/');
      if (base.charAt(base.length - 1) !== '/') base += '/';
      Promise.all(want.map(function (h) {
        return fetch(base + 'products/' + encodeURIComponent(h) + '?section_id=rv-card', { credentials: 'same-origin' })
          .then(function (r) { return r.status === 404 ? '' : (r.ok ? r.text() : null); }).catch(function () { return null; });
      })).then(function (htmls) {
        var items = [], gone = [];
        htmls.forEach(function (html, i) {
          var it = html && qs('.rail__item', parseHTML(html));
          if (it) items.push(it); else if (html === '') gone.push(want[i]);
        });
        /* products that no longer exist are forgotten */
        if (gone.length) rvWrite(rvRead().filter(function (h) { return gone.indexOf(h) < 0; }));
        if (!items.length) { if (!B.designMode) sec.hidden = true; return; }
        items.forEach(function (it) { track.appendChild(document.importNode(it, true)); });
        var note = qs('[data-rv-note]', sec); if (note) note.remove();
        sec.hidden = false;
        initRails(sec);
      });
    });
  }

  /* ---------- Country / language dropdown: dark glass list instead of the browser's white list ---------- */
  var openLoc = null;
  function closeLoc() {
    if (!openLoc) return;
    openLoc.list.classList.remove('is-open');
    openLoc.btn.setAttribute('aria-expanded', 'false');
    openLoc = null;
  }
  function placeLoc(o) {
    var vv = window.visualViewport, r = o.btn.getBoundingClientRect(), gap = 8;
    /* the part of the screen not covered by an on-screen keyboard */
    var vh = vv ? Math.min(window.innerHeight, vv.height + vv.offsetTop) : window.innerHeight;
    var below = vh - r.bottom - gap - 12, above = r.top - gap - 12;
    var up = below < 260 && above > below;
    var maxH = Math.max(160, Math.min(380, up ? above : below));
    /* side-by-side pills: the list spans the whole row, not just the tapped pill */
    var row = o.btn.closest('.localization--duo'), ra = row ? row.getBoundingClientRect() : r;
    var lw = Math.min(Math.max(ra.width, 260), window.innerWidth - 24);
    o.list.style.left = Math.max(12, Math.min(ra.left, window.innerWidth - lw - 12)) + 'px';
    o.list.style.width = lw + 'px';
    o.list.style.maxHeight = maxH + 'px';
    if (up) { o.list.style.top = 'auto'; o.list.style.bottom = (window.innerHeight - r.top + gap) + 'px'; }
    else { o.list.style.bottom = 'auto'; o.list.style.top = (r.bottom + gap) + 'px'; }
    o.list.classList.toggle('is-up', up);
  }
  function initLocalization(ctx) {
    qsa('.localization select', ctx).forEach(function (sel) {
      if (sel._custom) return; sel._custom = true;
      var wrap = sel.closest('.select-wrap');
      if (!wrap) return;
      wrap.classList.add('is-custom');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'loc-select';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      var label = document.createElement('span'); label.className = 'loc-select__label';
      btn.appendChild(label);
      var chev = qs('.icon', wrap); if (chev) btn.appendChild(chev);
      wrap.appendChild(btn);
      sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');

      var list = document.createElement('div');
      list.className = 'loc-list';
      list.setAttribute('role', 'listbox');
      var many = sel.options.length > 8;
      if (many) {
        var search = document.createElement('input');
        search.type = 'search'; search.className = 'loc-list__search';
        search.placeholder = (B.strings && B.strings.search) || 'Search';
        search.setAttribute('aria-label', search.placeholder);
        list.appendChild(search);
      }
      var opts = document.createElement('div'); opts.className = 'loc-list__opts'; list.appendChild(opts);
      Array.prototype.forEach.call(sel.options, function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'loc-list__opt'; b.setAttribute('role', 'option');
        b.setAttribute('data-value', o.value);
        b.innerHTML = '<span>' + o.textContent.trim() + '</span><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener('click', function () {
          sel.value = o.value;
          sync();
          closeLoc();
          if (sel.form) { if (sel.form.requestSubmit) sel.form.requestSubmit(); else sel.form.submit(); }
        });
        opts.appendChild(b);
      });
      document.body.appendChild(list);
      function sync() {
        var cur = sel.options[sel.selectedIndex];
        var short = cur && wrap.closest('.localization--duo') && cur.getAttribute('data-short');
        label.textContent = short || (cur ? cur.textContent.trim() : '');
        qsa('.loc-list__opt', list).forEach(function (b) {
          var on = b.getAttribute('data-value') === sel.value;
          b.classList.toggle('is-selected', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      sync();
      var o = { btn: btn, list: list };
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (openLoc && openLoc.list === list) { closeLoc(); return; }
        closeLoc();
        placeLoc(o);
        list.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        openLoc = o;
        var cur = qs('.is-selected', list);
        if (cur) opts.scrollTop = cur.offsetTop - opts.clientHeight / 2 + cur.offsetHeight / 2;
        /* type-to-search straight away with a mouse; on phones the keyboard only comes up when the search field is tapped */
        if (search) { search.value = ''; filter(''); if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) setTimeout(function () { search.focus({ preventScroll: true }); }, 30); }
      });
      function filter(q) {
        q = q.toLowerCase();
        qsa('.loc-list__opt', list).forEach(function (b) { b.hidden = q && b.textContent.toLowerCase().indexOf(q) === -1; });
      }
      if (search) search.addEventListener('input', function () { filter(search.value); });
      list.addEventListener('click', function (e) { e.stopPropagation(); });
      list.addEventListener('keydown', function (e) {
        var items = qsa('.loc-list__opt:not([hidden])', list), i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
        if (e.key === 'Escape') { closeLoc(); btn.focus(); }
      });
    });
    if (!root._locBound) {
      root._locBound = true;
      document.addEventListener('click', closeLoc);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLoc(); });
      /* Android (e.g. Samsung) shrinks the screen when the keyboard opens: keep the list open and re-place it.
         Only a real width change (rotating, folding open) closes it. */
      var locW = window.innerWidth;
      function locResize() {
        if (!openLoc) { locW = window.innerWidth; return; }
        if (Math.abs(window.innerWidth - locW) > 2) { locW = window.innerWidth; closeLoc(); return; }
        placeLoc(openLoc);
      }
      window.addEventListener('resize', locResize);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', locResize);
      document.addEventListener('scroll', function (e) {
        if (!openLoc || openLoc.list.contains(e.target)) return;
        /* the browser scrolling the focused search field into view is not the shopper scrolling away */
        if (document.activeElement && openLoc.list.contains(document.activeElement)) { placeLoc(openLoc); return; }
        closeLoc();
      }, true);
    }
  }

  /* ---------- Cart reservation timer ---------- */
  var TIMER_KEY = 'borba-cart-exp';
  function timerTick() {
    var els = qsa('[data-cart-timer]');
    if (!els.length) return;
    var hasItems = els.some(function (el) { return parseInt(el.getAttribute('data-items') || '0', 10) > 0; });
    var exp = parseInt(store(TIMER_KEY) || '0', 10);
    if (!hasItems) { if (exp) store(TIMER_KEY, null); root.classList.remove('cart-urgent', 'cart-expired', 'cart-timing'); stopPulse(); return; }
    var mins = parseInt(els[0].getAttribute('data-minutes') || '10', 10);
    var now = Date.now();
    if (!exp) { exp = now + mins * 60000; store(TIMER_KEY, String(exp)); }
    var left = exp - now;
    if (left <= 0 && els[0].getAttribute('data-end') === 'restart') { exp = now + mins * 60000; store(TIMER_KEY, String(exp)); left = exp - now; }
    var secs = Math.max(0, Math.ceil(left / 1000));
    var txt = pad(Math.floor(secs / 60)) + ':' + pad(secs % 60);
    var urgentAt = parseInt(els[0].getAttribute('data-urgent') || '60', 10) || 60;
    els.forEach(function (el) {
      el.style.setProperty('--t-left', Math.min(1, secs / (mins * 60)).toFixed(4));
      el.hidden = false;
      qsa('[data-cart-timer-time]', el).forEach(function (t) { t.textContent = txt; });
      var done = secs === 0;
      var run = qs('[data-cart-timer-running]', el), end = qs('[data-cart-timer-expired]', el);
      if (run) run.hidden = done;
      if (end) end.hidden = !done;
      el.classList.toggle('is-urgent', !done && secs <= urgentAt);
      el.classList.toggle('is-expired', done);
    });
    // header cart icon follows the timer: chosen effect while it runs (or only in the red phase), red when time is up
    var iconOn = els[0].getAttribute('data-icon-red') !== 'off';
    var when = els[0].getAttribute('data-icon-when') || 'minutes';
    root.classList.toggle('cart-urgent', iconOn && when !== 'minutes' && secs > 0 && secs <= urgentAt);
    root.classList.toggle('cart-expired', iconOn && secs === 0);
    root.classList.toggle('cart-timing', iconOn && secs > 0 && when === 'always');
    /* "minutes": one short red glow on the bag each time a minute passes (5:00, 4:00 ... 1:00) */
    var curMin = Math.ceil(secs / 60);
    if (iconOn && when === 'minutes' && secs > 0 && timerLastMin != null && curMin < timerLastMin &&
        curMin <= (parseInt(els[0].getAttribute('data-icon-from') || '5', 10) || 5)) {
      flashBag(parseFloat(els[0].getAttribute('data-icon-flash') || '1.5') || 1.5);
    }
    timerLastMin = secs > 0 ? curMin : null;
    root.setAttribute('data-bag-fx', els[0].getAttribute('data-icon-fx') || 'glow');
    root.style.setProperty('--bag-s', els[0].getAttribute('data-icon-s') || '.6');
    if (secs > 0 && secs <= urgentAt) startPulse(); else stopPulse();
  }
  var timerLastMin = null;
  function flashBag(dur) {
    root.style.setProperty('--bag-flash', dur + 's');
    root.classList.remove('bag-flash'); void root.offsetWidth; root.classList.add('bag-flash');
    clearTimeout(root._bagFlash);
    root._bagFlash = setTimeout(function () { root.classList.remove('bag-flash'); }, dur * 1000 + 80);
  }
  /* Smooth red pulse for the last minute. Calm (one breath per 2.8s) until 15s are left, then it
     speeds up little by little until 0. The phase is integrated so the speed-up never jumps. */
  var pulse = { raf: 0, phase: 0, last: 0 };
  function pulseFrame(t) {
    var exp = parseInt(store(TIMER_KEY) || '0', 10);
    var left = (exp - Date.now()) / 1000;
    if (!root.classList.contains('cart-urgent') && !qs('.cart-timer.is-urgent')) { stopPulse(); return; }
    var dt = pulse.last ? Math.min(0.1, (t - pulse.last) / 1000) : 0;
    pulse.last = t;
    var calm = 1 / 2.8, fast = 2.4;
    var f = calm;
    if (left <= 15) { var k = Math.min(1, Math.max(0, (15 - left) / 15)); f = calm + (fast - calm) * Math.pow(k, 1.7); }
    pulse.phase = (pulse.phase + dt * f) % 1;
    var v = reduceMotion ? 1 : (1 - Math.cos(pulse.phase * Math.PI * 2)) / 2;
    root.style.setProperty('--pulse', v.toFixed(3));
    pulse.raf = requestAnimationFrame(pulseFrame);
  }
  function startPulse() { if (!pulse.raf) { pulse.last = 0; pulse.raf = requestAnimationFrame(pulseFrame); } }
  function stopPulse() { if (pulse.raf) cancelAnimationFrame(pulse.raf); pulse.raf = 0; pulse.phase = 0; root.style.removeProperty('--pulse'); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCartTimer() {
    if (root._cartTimer) return;
    root._cartTimer = setInterval(timerTick, 1000);
    timerTick();
  }

  /* ---------- Cart "You may also like": auto recommendations, arrows, collapse ---------- */
  function initUpsell() {
    qsa('[data-upsell]').forEach(function (box) {
      if (box._bound) return; box._bound = true;
      var list = qs('[data-upsell-list]', box);
      var prev = qs('[data-upsell-prev]', box), next = qs('[data-upsell-next]', box);
      var is3d = box.classList.contains('upsell--3d');
      function arrows() {
        if (!list || !prev) return;
        if (is3d) { prev.disabled = next.disabled = false; qs('.upsell__nav', box).hidden = list.children.length < 2; if (box._car) box._car.measure(); return; }
        var max = list.scrollWidth - list.clientWidth - 2;
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= max;
        qs('.upsell__nav', box).hidden = max <= 0;
      }
      function step(dir) {
        if (is3d && box._car) { box._car.by(dir); return; }
        list.scrollBy({ left: dir * (list.clientWidth * 0.66), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if (list) list.addEventListener('scroll', debounce(arrows, 60), { passive: true });
      var togs = qsa('[data-upsell-toggle]', box);
      var remember = box.hasAttribute('data-upsell-remember');
      function setClosed(closed) {
        box.classList.toggle('is-closed', closed);
        togs.forEach(function (t) { if (t.classList.contains('upsell__chev')) t.setAttribute('aria-expanded', closed ? 'false' : 'true'); });
        if (!closed) setTimeout(arrows, 60);
      }
      if (!remember) { try { sessionStorage.removeItem('borba-upsell'); } catch (e) {} }
      if (togs.length && remember) {
        var saved = null;
        try { saved = sessionStorage.getItem('borba-upsell'); } catch (e) {}
        if (saved === 'closed' || saved === 'open') setClosed(saved === 'closed');
      }
      togs.forEach(function (t) {
        t.addEventListener('click', function () {
          var closed = !box.classList.contains('is-closed');
          setClosed(closed);
          if (remember) { try { sessionStorage.setItem('borba-upsell', closed ? 'closed' : 'open'); } catch (e) {} }
        });
      });
      if (box.hasAttribute('data-upsell-auto')) {
        fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
          var doc = parseHTML(html);
          var ul = qs('[data-cart-recs]', doc);
          if (!ul || !ul.children.length) return;
          list.innerHTML = ul.innerHTML;
          box.hidden = false;
          if (is3d) upsell3d(box, list);
          arrows();
        }).catch(function () {});
      }
      if (is3d) upsell3d(box, list);
      setTimeout(arrows, 50);
    });
  }

  /* ---------- About → Citaten: the same 3D turning carousel as the cart upsell ---------- */
  /* About signature on phones: bottom right, next to the last line of the text when there is room for it there,
     otherwise it simply stays under the text (right). Recalculated when the width or the text changes. */
  function initStorySig(ctx) {
    qsa('[data-story-sig]', ctx).forEach(function (sig) {
      if (sig._bound) return; sig._bound = true;
      var col = sig.parentElement, body = sig.previousElementSibling;
      /* the boxes of the text lines only (no paragraph boxes) */
      function lineRects() {
        var out = [], w = document.createTreeWalker(body, NodeFilter.SHOW_TEXT), n, r = document.createRange();
        while ((n = w.nextNode())) {
          if (!n.nodeValue.replace(/\s|\u00a0/g, '')) continue;
          r.selectNodeContents(n);
          var rs = r.getClientRects();
          for (var i = 0; i < rs.length; i++) if (rs[i].width > 0) out.push(rs[i]);
        }
        return out;
      }
      function place() {
        sig.style.marginTop = '';
        if (!body || !body.classList.contains('story__body') || !sig.offsetParent) return;
        var rects = lineRects(), line = null, i;
        for (i = 0; i < rects.length; i++) { var q = rects[i]; if (!line || q.bottom > line.bottom + 1 || (Math.abs(q.bottom - line.bottom) <= 1 && q.right > line.right)) line = q; }
        if (!line) return;
        var cr = col.getBoundingClientRect(), sr = sig.getBoundingClientRect();
        /* every line of text that would sit next to the signature must end before it starts */
        var top = line.bottom - sr.height, right = line.right;
        for (i = 0; i < rects.length; i++) { var a = rects[i]; if (a.bottom > top + 1 && a.top < line.bottom - 1) right = Math.max(right, a.right); }
        if (cr.right - right < sr.width + 14) return;
        /* bottom of the signature on the bottom of the last line */
        var mt = parseFloat(getComputedStyle(sig).marginTop) || 0;
        sig.style.marginTop = (mt + (line.bottom - sr.height) - sr.top).toFixed(1) + 'px';
      }
      place();
      if (window.ResizeObserver) new ResizeObserver(debounce(place, 60)).observe(col);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    });
  }

  function initQuotesCar(ctx) {
    qsa('[data-quotes-car]', ctx).forEach(function (box) {
      if (box._bound) return; box._bound = true;
      var list = qs('[data-upsell-list]', box);
      if (!list) return;
      var few = list.children.length < 2;
      var nav = qs('.upsell__nav', box);
      if (nav) nav.hidden = few;
      qsa('.quotes-car__arrow', box).forEach(function (a) { a.hidden = few; });
      qsa('[data-upsell-prev]', box).forEach(function (b) { b.addEventListener('click', function () { if (box._car) box._car.by(-1); }); });
      qsa('[data-upsell-next]', box).forEach(function (b) { b.addEventListener('click', function () { if (box._car) box._car.by(1); }); });
      upsell3d(box, list);
      /* the arrows left and right sit at the height of the middle of the photo (or of the quotes without photos) */
      function placeArrows() {
        var cur = qs('.upsell__item.is-current', list) || list.children[0];
        if (!cur) return;
        var media = qs('.quote-card__media', cur);
        var top = list.getBoundingClientRect().top - box.getBoundingClientRect().top;
        var y = media ? top + media.offsetTop + media.offsetHeight / 2 : top + list.offsetHeight / 2;
        box.style.setProperty('--qa-y', y.toFixed(1) + 'px');
      }
      placeArrows();
      qsa('img', list).forEach(function (im) { if (!im.complete) im.addEventListener('load', placeArrows, { once: true }); });
      if (window.ResizeObserver) new ResizeObserver(function () { requestAnimationFrame(placeArrows); }).observe(box);
      /* the quotes behind sit partly behind the list's plane: a click on their visible strip turns to that side */
      list.addEventListener('click', function (e) {
        if (!box._car || e.target.closest('.upsell__item.is-current') || list.children.length < 2) return;
        var r = list.getBoundingClientRect();
        box._car.by(e.clientX < r.left + r.width / 2 ? -1 : 1);
      });
    });
  }

  /* ---------- Cart "You may also like" as a 3D turning carousel ----------
     The front product is big and sharp, the others turn away behind it (blurred). It turns on its own and you
     can swipe / use the arrows at any moment; the timer simply restarts after you touch it. */
  function upsell3d(box, list) {
    if (box._car) box._car.stop();
    var items = qsa(':scope > .upsell__item', list);
    var n = items.length;
    if (!n) return;
    var car = { pos: 0 };
    box._car = car;
    function num(name, fb) { var v = parseFloat(getComputedStyle(box).getPropertyValue(name)); return isNaN(v) ? fb : v; }
    function wrapD(d) { d = ((d % n) + n) % n; if (d > n / 2) d -= n; return d; }
    /* fan layout (about-page quotes): N cards visible on each side, always the same number left and right */
    var fanN = parseInt(box.getAttribute('data-up-visible'), 10) || 0;
    function renderFan() {
      var step = num('--up-step', 58), depth = num('--up-depth', 160), tilt = num('--up-tilt', 24);
      var blur = num('--up-blur', 4), side = num('--up-side', .6);
      var vis = Math.max(0, Math.min(fanN, Math.floor((n - 1) / 2)));
      items.forEach(function (m, i) {
        var d = n > 1 ? wrapD(i - car.pos) : 0, a = Math.abs(d), sg = d < 0 ? -1 : 1;
        if (m._d != null && Math.abs(d - m._d) > n / 2) {
          m.style.transition = 'none';
          requestAnimationFrame(function () { requestAnimationFrame(function () { m.style.transition = ''; }); });
        }
        m._d = d;
        /* each step further back: a bit further out, smaller (depth), more blurred and lighter */
        var o = a <= 1 ? 1 - (1 - side) * a : side * Math.max(.3, 1 - .2 * (a - 1));
        if (a > vis) o *= Math.max(0, 1 - (a - vis) / .6);
        m.style.setProperty('--x', (d * step).toFixed(2));
        m.style.setProperty('--z', (-a * depth).toFixed(1));
        m.style.setProperty('--ry', (sg * Math.min(1, a) * -tilt).toFixed(2));
        m.style.setProperty('--b', (blur * (a <= 1 ? a : 1 + .5 * (Math.min(a, vis + 1) - 1))).toFixed(2) + 'px');
        m.style.setProperty('--o', o.toFixed(3));
        m.style.zIndex = String(100 - Math.round(a * 10));
        var cur = a < .5;
        m.classList.toggle('is-current', cur);
        m.setAttribute('aria-hidden', cur ? 'false' : 'true');
        qsa('a, button', m).forEach(function (el) { el.tabIndex = cur ? 0 : -1; });
      });
    }
    function render() {
      if (fanN) { renderFan(); return; }
      var spread = num('--up-spread', 56), depth = num('--up-depth', 160), tilt = num('--up-tilt', 24);
      var blur = num('--up-blur', 4), side = num('--up-side', .6);
      var stepA = 2 * Math.PI / Math.max(n, 3), ref = Math.min(stepA, Math.PI / 2);
      var sx = 1 / Math.sin(ref), sz = 1 / (1 - Math.cos(ref));
      items.forEach(function (m, i) {
        var d = n > 1 ? wrapD(i - car.pos) : 0, th = d * stepA, near = Math.min(1, Math.abs(d));
        var far = Math.abs(d) > 1.6;
        /* an item that wraps around from one side to the other jumps there invisibly instead of sweeping across the front */
        if (m._d != null && Math.abs(d - m._d) > n / 2) {
          m.style.transition = 'none';
          requestAnimationFrame(function () { requestAnimationFrame(function () { m.style.transition = ''; }); });
        }
        m._d = d;
        m.style.setProperty('--x', (Math.sin(th) * sx * spread).toFixed(2));
        m.style.setProperty('--z', ((Math.cos(th) - 1) * sz * depth).toFixed(1));
        m.style.setProperty('--ry', (Math.max(-1.5, Math.min(1.5, Math.sin(th) * sx)) * -tilt).toFixed(2));
        m.style.setProperty('--b', (blur * near).toFixed(2) + 'px');
        m.style.setProperty('--o', far ? '0' : (1 - (1 - side) * near).toFixed(3));
        m.style.zIndex = String(Math.round((Math.cos(th) + 1) * 50));
        var cur = Math.abs(d) < .5;
        m.classList.toggle('is-current', cur);
        m.setAttribute('aria-hidden', cur ? 'false' : 'true');
        qsa('a, button', m).forEach(function (el) { el.tabIndex = cur ? 0 : -1; });
      });
    }
    car.measure = function () {
      var h = 0;
      items.forEach(function (m) { h = Math.max(h, m.offsetHeight); });
      if (h) list.style.setProperty('--up-h', h + 'px');
    };
    var timer = null, speed = (parseFloat(box.getAttribute('data-up-speed')) || 3.5) * 1000;
    var auto = box.hasAttribute('data-up-auto') && n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hover = false, down = false;
    function tick() {
      if (hover || down || box.classList.contains('is-closed') || !box.offsetParent || document.hidden) return;
      car.pos += 1; render();
    }
    car.start = function () { clearInterval(timer); if (auto) timer = setInterval(tick, speed); };
    car.stop = function () { clearInterval(timer); };
    car.by = function (dir) { car.pos = Math.round(car.pos) + dir; render(); car.start(); };
    car.to = function (i) { car.pos = Math.round(car.pos) + wrapD(i - car.pos); render(); car.start(); };

    box.classList.add('is-3d-ready');
    render();
    car.measure();
    qsa('img', list).forEach(function (im) { if (!im.complete) im.addEventListener('load', car.measure, { once: true }); });
    if (window.ResizeObserver) { var ro = new ResizeObserver(function () { car.measure(); }); items.forEach(function (m) { ro.observe(m); }); }
    car.start();

    box.addEventListener('mouseenter', function () { hover = true; });
    box.addEventListener('mouseleave', function () { hover = false; });

    /* swipe / drag (finger or mouse) */
    var sx0 = 0, sy0 = 0, p0 = 0, dragging = false, suppress = false;
    list.addEventListener('pointerdown', function (e) {
      if (n < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      down = true; dragging = false; sx0 = e.clientX; sy0 = e.clientY; p0 = car.pos;
    });
    list.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx0, dy = e.clientY - sy0;
      if (!dragging) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
        dragging = true; box.classList.add('is-dragging');
        try { list.setPointerCapture(e.pointerId); } catch (err) {}
      }
      e.preventDefault();
      car.pos = p0 - dx / Math.max(list.clientWidth * .45, 1);
      render();
    });
    function release(e) {
      if (!down) return;
      down = false;
      if (!dragging) return;
      dragging = false;
      box.classList.remove('is-dragging');
      var dx = (e && e.clientX != null ? e.clientX : sx0) - sx0;
      var target = Math.round(car.pos);
      if (target === Math.round(p0) && Math.abs(dx) > 30) target = Math.round(p0) - (dx > 0 ? 1 : -1);
      car.pos = target; render(); car.start();
      suppress = true; setTimeout(function () { suppress = false; }, 60);
    }
    list.addEventListener('pointerup', release);
    list.addEventListener('pointercancel', release);
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); return; }
      var it = e.target.closest('.upsell__item');
      if (it && !it.classList.contains('is-current')) { e.preventDefault(); e.stopPropagation(); car.to(items.indexOf(it)); }
    }, true);
  }

  /* ---------- Product marquee: moves on its own, can be grabbed and dragged ---------- */
  function initProductMarquee(ctx) {
    qsa('[data-pmarq]', ctx).forEach(function (wrap) {
      if (wrap._bound) return; wrap._bound = true;
      var track = qs('[data-pmarq-track]', wrap);
      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;
      // Repeat the products until one "set" is wider than the screen, then double that set: the row loops
      // seamlessly. Rebuilt when the screen gets wider, so there is never an empty gap at the end.
      var filled = false, half = 0, setCount = 0;
      function fill() {
        var w = wrap.clientWidth;
        if (!w) return;
        qsa('[data-pmarq-clone]', track).forEach(function (c) { c.remove(); });
        var set = originals.slice();
        var guard = 0;
        // one set = originals repeated until it is at least 1.3x the visible width
        while (guard++ < 30) {
          var first = set[0].getBoundingClientRect(), lastR = set[set.length - 1].getBoundingClientRect();
          if (lastR.right - first.left >= w * 1.3) break;
          originals.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-pmarq-clone', ''); c.tabIndex = -1; track.appendChild(c); set.push(c); });
        }
        setCount = set.length;
        set.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-pmarq-clone', ''); c.tabIndex = -1; track.appendChild(c); });
        var kids = track.children;
        half = kids[setCount].offsetLeft - kids[0].offsetLeft; // exact loop length, gaps included
        filled = half > 1;
        wrap._fillW = w;
      }
      fill();
      var speed = parseFloat(wrap.getAttribute('data-speed') || '40');
      var dir = wrap.getAttribute('data-dir') === 'right' ? 1 : -1;
      var pauseHover = wrap.getAttribute('data-pause') === 'true';
      var canDrag = wrap.getAttribute('data-drag') !== 'false';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var pos = 0, last = performance.now(), hover = false, drag = null, moved = 0, visible = true;
      // keep the position inside one loop length. No while-loops: if the row has no width yet
      // (hidden, still loading, or just added in the theme editor) this must never hang the page.
      function wrapPos() {
        if (!(half > 1)) { pos = 0; return; }
        var r = pos % half;
        if (r > 0) r -= half;
        if (r <= -half) r += half;
        pos = r;
      }
      function frame(now) {
        if (!wrap.isConnected) return; // section was re-rendered in the editor: stop this loop
        if (!filled) fill();
        var dt = Math.min(0.05, (now - last) / 1000); last = now;
        if (visible && !drag && !(hover && pauseHover) && !reduce) pos += dir * speed * dt;
        wrapPos();
        track.style.transform = 'translate3d(' + pos.toFixed(2) + 'px,0,0)';
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(wrap);
      wrap.addEventListener('mouseenter', function () { hover = true; });
      wrap.addEventListener('mouseleave', function () { hover = false; });
      window.addEventListener('resize', debounce(function () { if (wrap.clientWidth !== wrap._fillW) fill(); }, 200));
      qsa('img', track).forEach(function (im) { if (!im.complete) im.addEventListener('load', debounce(function () { fill(); }, 100), { once: true }); });
      if (!canDrag) return;
      wrap.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        drag = { x: e.clientX, y: e.clientY, start: pos, active: false }; moved = 0;
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;
          drag.active = true; wrap.classList.add('is-dragging');
          try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
        }
        moved = Math.abs(dx);
        pos = drag.start + dx; wrapPos();
      });
      function end() { if (!drag) return; drag = null; wrap.classList.remove('is-dragging'); last = performance.now(); }
      wrap.addEventListener('pointerup', end);
      wrap.addEventListener('pointercancel', end);
      wrap.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
      wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshows(ctx) {
    qsa('[data-slideshow]', ctx).forEach(function (ss) {
      if (ss._bound) return; ss._bound = true;
      var slides = qsa('[data-slide-item]', ss), dots = qsa('[data-ss-dots] .dots__dot', ss);
      if (slides.length < 2) return;
      var i = 0, timer = null;
      var auto = ss.getAttribute('data-autoplay') === 'true';
      var wait = parseInt(ss.getAttribute('data-interval') || '6', 10) * 1000;
      function go(n) {
        var prev = i;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          s.classList.toggle('is-prev', k === prev && k !== i);
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        restart();
      }
      function restart() { clearInterval(timer); if (auto && !B.designMode) timer = setInterval(function () { go(i + 1); }, wait); }
      var p = qs('[data-ss-prev]', ss), n = qs('[data-ss-next]', ss);
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (n) n.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var sx = null;
      ss.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      ss.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      });
      ss.addEventListener('mouseenter', function () { clearInterval(timer); });
      ss.addEventListener('mouseleave', restart);
      ss.addEventListener('shopify:block:select', function (e) {
        var k = slides.indexOf(e.target.closest('[data-slide-item]'));
        if (k > -1) { auto = false; go(k); }
      });
      restart();
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(ctx) {
    qsa('[data-countdown]', ctx).forEach(function (el) {
      if (el._bound) return; el._bound = true;
      var end = new Date(el.getAttribute('data-end')).getTime();
      var clock = qs('[data-countdown-clock]', el), done = qs('[data-countdown-done]', el);
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (isNaN(end) || left === 0) {
          if (clock) clock.hidden = true;
          if (done) done.hidden = false;
          return;
        }
        var s = Math.floor(left / 1000);
        var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        qsa('[data-cd]', el).forEach(function (n) { n.textContent = pad(v[n.getAttribute('data-cd')]); });
        setTimeout(tick, 1000 - (Date.now() % 1000));
      }
      tick();
    });
  }

  function snapCenter(el) { return (getComputedStyle(el).scrollSnapAlign || '').indexOf('center') > -1; }

  /* ---------- Snap only inside the feed / product photos; free scrolling below ---------- */
  function initSnapZone() {
    if (root._snapZone) { root._snapCheck(); return; }
    root._snapZone = true;
    var free = false, ticking = false;
    function check() {
      ticking = false;
      /* looked up every time: after a page swap (music player keeps playing) the zone is a new element */
      var isProduct = root.classList.contains('page-product');
      var zone = isProduct ? qs('[data-product-section]') : root.classList.contains('page-feed') ? qs('.feed-section') : null;
      if (!zone) { if (free) { free = false; root.classList.remove('snap-free'); } return; }
      var r = zone.getBoundingClientRect(), h = window.innerHeight;
      /* products that rest in the middle of the screen (phones) sit `off` px lower than the top */
      var first = !isProduct && qs('.slide', zone), off = 0;
      if (first && first.offsetParent !== null && snapCenter(first)) off = Math.max(0, (h - first.offsetHeight) / 2);
      /* free scrolling below the products (footer etc.) and also while the banner above the feed is still
         mostly in view: the snap to the first product only kicks in late, when the banner is nearly gone */
      var aboveFree = !isProduct && r.top > h * 0.18 + off;
      var want = r.bottom < h - 2 - off || aboveFree;
      if (want !== free) { free = want; root.classList.toggle('snap-free', free); }
    }
    root._snapCheck = check;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', debounce(check, 120));
    check();
  }

  /* ---------- iPhone-style feed swiping on Android & other touch phones ----------
     iOS glides softly into each product; Chrome/Samsung Internet use a harder snap of their own.
     On those phones the feed is moved by the theme itself: the finger drags 1:1, and on release it glides
     (with the speed of the swipe) into the right product, exactly like on iPhone. Outside the products
     (banner above, footer below) it simply coasts on, like normal scrolling. iPhone/iPad keep native scrolling. */
  function initTouchSnap() {
    if (root._touchSnap) { root.classList.toggle('touch-snap', !!feedZone()); return; }
    var ua = navigator.userAgent || '';
    var isIOS = /iP(hone|ad|od)/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    if (isIOS || !window.matchMedia('(pointer: coarse)').matches) return;
    /* the feed is looked up every time: after a page swap (music player keeps playing) it is a new element */
    function feedZone() { return root.classList.contains('page-feed') ? qs('.feed-section') : null; }
    root._touchSnap = true;
    root.classList.toggle('touch-snap', !!feedZone());

    var TAU = 0.33;   /* how far a swipe coasts (seconds of momentum), iOS-like */
    var W = 12;       /* glide stiffness into a product: soft, no bounce */
    var anim = 0, drag = null, idle = 0, lastProgY = -1;

    function on() { return !!feedZone() && !root.classList.contains('view-grid') && !root.classList.contains('is-locked'); }
    function maxY() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }
    function setY(y) { y = Math.max(0, Math.min(maxY(), y)); lastProgY = Math.round(y); window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
    function points() {
      var pad = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      return qsa('.slide', feedZone()).filter(function (s) { return s.offsetParent !== null; }).map(function (s) {
        var top = s.getBoundingClientRect().top + window.scrollY;
        /* phones: the product rests in the middle of the screen */
        if (snapCenter(s)) return top - (window.innerHeight - s.offsetHeight) / 2;
        return top - pad;
      });
    }
    function region(pts) {
      var h = window.innerHeight;
      if (!pts.length) return null;
      var last = pts[pts.length - 1], slideH = qsa('.slide', feedZone()).slice(-1)[0].offsetHeight;
      return { from: pts[0] - h * 0.18, to: last + slideH * 0.5 };
    }
    function nearest(pts, y) {
      var best = 0;
      for (var i = 1; i < pts.length; i++) if (Math.abs(pts[i] - y) < Math.abs(pts[best] - y)) best = i;
      return best;
    }
    function stop() { if (anim) { cancelAnimationFrame(anim); anim = 0; } }
    /* critically damped spring: starts with the finger's speed, settles without overshoot */
    function glide(y0, v0, target) {
      stop();
      var d = y0 - target;
      if (Math.abs(d) < 0.5 && Math.abs(v0) < 20) { setY(target); return; }
      var maxV = W * Math.abs(d);
      if (v0 * -d > 0) v0 = Math.sign(v0) * Math.min(Math.abs(v0), maxV); else v0 = Math.sign(v0) * Math.min(Math.abs(v0), 600);
      var t0 = performance.now();
      (function step(now) {
        var t = (now - t0) / 1000, e = Math.exp(-W * t);
        var y = target + (d + (v0 + W * d) * t) * e;
        setY(y);
        if (Math.abs(y - target) < 0.4 && t > 0.1) { setY(target); anim = 0; return; }
        anim = requestAnimationFrame(step);
      })(t0);
    }
    /* free momentum (outside the products), decelerates like a normal swipe */
    function coast(y0, v0) {
      stop();
      if (Math.abs(v0) < 30) return;
      var t0 = performance.now();
      (function step(now) {
        var t = (now - t0) / 1000;
        var y = y0 + v0 * TAU * (1 - Math.exp(-t / TAU));
        setY(y);
        if (Math.abs(v0) * Math.exp(-t / TAU) < 12 || y <= 0 || y >= maxY()) { anim = 0; return; }
        anim = requestAnimationFrame(step);
      })(t0);
    }
    function release(y, v, startIdx, startY) {
      var pts = points(), r = region(pts);
      if (!r) return coast(y, v);
      var proj = y + v * TAU;
      if (proj < r.from || proj > r.to) {
        /* leaving the products: coast, but never stop half-way inside the feed */
        if (proj < r.from && startIdx === 0 && startY >= pts[0] - 2 && proj > pts[0] - window.innerHeight * 0.45) return glide(y, v, pts[0]);
        return coast(y, v);
      }
      var i = nearest(pts, proj);
      if (startIdx != null && i === startIdx && Math.abs(v) > 350) i = Math.max(0, Math.min(pts.length - 1, i + (v > 0 ? 1 : -1)));
      glide(y, v, pts[i]);
    }

    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest || !e.target.closest('.feed-section')) { drag = null; return; }
      if (!on() || e.touches.length !== 1) { drag = null; return; }
      stop();
      var t = e.touches[0], pts = points();
      drag = { x: t.clientX, y: t.clientY, sy: window.scrollY, axis: null, hist: [{ y: window.scrollY, t: e.timeStamp }], start: pts.length ? nearest(pts, window.scrollY) : null };
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!drag || e.touches.length !== 1) return;
      var t = e.touches[0], dx = t.clientX - drag.x, dy = t.clientY - drag.y;
      if (!drag.axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (drag.axis !== 'y') return;
      var y = drag.sy - dy;
      setY(y);
      drag.hist.push({ y: window.scrollY, t: e.timeStamp });
      if (drag.hist.length > 8) drag.hist.shift();
    }, { passive: true });
    function end(e) {
      if (!drag) return;
      var d = drag; drag = null;
      if (d.axis !== 'y') { if (!d.axis) settle(); return; }
      /* the lift-off point counts too, so the speed is right even when touch events arrive sparsely */
      var ct = e.changedTouches && e.changedTouches[0];
      if (ct) { setY(d.sy - (ct.clientY - d.y)); d.hist.push({ y: window.scrollY, t: e.timeStamp }); }
      /* release speed from the last ~100 ms of the drag (a finger that rested before lifting gives ~0) */
      var h = d.hist, a = h[h.length - 1], b = a;
      for (var i = h.length - 1; i >= 0; i--) { if (a.t - h[i].t > 100) break; b = h[i]; }
      if (b === a && h.length > 1 && a.t - h[h.length - 2].t < 160) b = h[h.length - 2];
      var dt = (a.t - b.t) / 1000, v = dt > 0.004 ? (a.y - b.y) / dt : 0;
      v = Math.max(-6000, Math.min(6000, v));
      release(window.scrollY, v, d.start, d.sy);
    }
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchcancel', end, { passive: true });

    /* scrolls that don't start on the products (header, banner, keyboard): settle into the nearest product
       once they come to rest inside the feed, just like the native snap did */
    function settle() {
      if (!on() || drag || anim) return;
      var pts = points(), r = region(pts), y = window.scrollY;
      if (!r || y < r.from || y > r.to) return;
      var i = nearest(pts, y);
      if (Math.abs(pts[i] - y) > 1.5) glide(y, 0, pts[i]);
    }
    window.addEventListener('scroll', function () {
      if (anim || drag) return;
      if (Math.abs(window.scrollY - lastProgY) <= 1) return;
      clearTimeout(idle); idle = setTimeout(settle, 140);
    }, { passive: true });
  }

  /* ---------- Grid view: an unfinished last row sits in the middle ----------
     Automatic on every page with the product grid (only in grid view, never in the swipe feed).
     The products of that row keep the normal spacing; the whole row is shifted to the centre. */
  var gridQueued = false;
  function centerGridRows() {
    gridQueued = false;
    var on = root.classList.contains('view-grid');
    qsa('[data-feed]').forEach(function (feed) {
      var items = qsa(':scope > .slide', feed);
      var vis = [];
      items.forEach(function (s) { if (s.style.getPropertyValue('--row-shift')) s.style.removeProperty('--row-shift'); if (on && s.offsetParent !== null) vis.push(s); });
      if (!on || !vis.length) return;
      var cs = getComputedStyle(feed);
      var tracks = cs.gridTemplateColumns.split(' ').filter(function (t) { return t && t !== 'none'; });
      var cols = tracks.length, r = vis.length % cols;
      if (cols < 2 || !r) return;
      var step = parseFloat(tracks[0]) + (parseFloat(cs.columnGap) || 0);
      var shift = ((cols - r) * step / 2).toFixed(2) + 'px';
      vis.slice(vis.length - r).forEach(function (s) { s.style.setProperty('--row-shift', shift); });
    });
  }
  function queueGrid() { if (!gridQueued) { gridQueued = true; requestAnimationFrame(centerGridRows); } }
  function initGridCenter() {
    if (root._gridCenter) { queueGrid(); return; }
    root._gridCenter = true;
    new MutationObserver(queueGrid).observe(root, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.nodeType === 1 && (t.hasAttribute('data-feed') || t.querySelector && t.querySelector('[data-feed]'))) { queueGrid(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', debounce(queueGrid, 120));
    queueGrid();
  }

  /* ---------- Day mode background: grain tile ----------
     One small tile of random light/dark specks, made once; CSS moves it around for the "TV static" effect. */
  function initDayBg() {
    var els = qsa('[data-day-bg]').filter(function (e) { return !e._noise; });
    if (!els.length) return;
    els.forEach(function (e) { e._noise = true; });
    var dpr = Math.min(2, window.devicePixelRatio || 1), n = Math.round(160 * dpr);
    var c = document.createElement('canvas'); c.width = c.height = n;
    var x = c.getContext('2d'), img = x.createImageData(n, n), d = img.data;
    for (var i = 0; i < d.length; i += 4) {
      var v = Math.random(), white = v > .5;
      d[i] = d[i + 1] = d[i + 2] = white ? 255 : 0;
      d[i + 3] = Math.round(Math.abs(v - .5) * 2 * 230);
    }
    x.putImageData(img, 0, 0);
    try { var url = 'url("' + c.toDataURL('image/png') + '")'; els.forEach(function (e) { e.style.setProperty('--dbg-noise', url); }); } catch (err) {}
  }

  /* ---------- Day mode: logo for on top of a light background ----------
     Over the banner photo the normal (white) logo shows. Below it the logo follows what is behind it:
     dark-text version on the light page, the white version again as soon as something dark (e.g. a black
     garment) passes behind the logo. It reads the actual colours of the product photo under the logo. */
  var lumCache = {};
  /* small copy of a product photo with its pixels read once, so brightness lookups are plain array reads */
  function imgCanvas(img) {
    var src = img.currentSrc || img.src;
    if (lumCache[src] !== undefined) return lumCache[src];
    if (!img.complete || !img.naturalWidth) return null;
    var k = Math.min(1, 256 / Math.max(img.naturalWidth, img.naturalHeight));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(img.naturalWidth * k)); c.height = Math.max(1, Math.round(img.naturalHeight * k));
    var x = c.getContext('2d', { willReadFrequently: true });
    try {
      x.drawImage(img, 0, 0, c.width, c.height);
      var d = x.getImageData(0, 0, c.width, c.height).data, v = new Float32Array(c.width * c.height);
      /* brightness per pixel, with see-through parts counting as the light page */
      for (var i = 0, j = 0; i < d.length; i += 4, j++) {
        var a = d[i + 3] / 255;
        v[j] = ((0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255) * a + 0.88 * (1 - a);
      }
      lumCache[src] = { w: c.width, h: c.height, v: v };
    } catch (e) { lumCache[src] = false; }
    return lumCache[src];
  }
  /* smooth (bilinear) brightness inside a photo copy at fractions px, py */
  function lumSample(cv, px, py) {
    var fx = Math.max(0, Math.min(cv.w - 1, px * cv.w - .5)), fy = Math.max(0, Math.min(cv.h - 1, py * cv.h - .5));
    var x0 = Math.floor(fx), y0 = Math.floor(fy), x1 = Math.min(cv.w - 1, x0 + 1), y1 = Math.min(cv.h - 1, y0 + 1), tx = fx - x0, ty = fy - y0, v = cv.v;
    var a = v[y0 * cv.w + x0] + (v[y0 * cv.w + x1] - v[y0 * cv.w + x0]) * tx;
    var b = v[y1 * cv.w + x0] + (v[y1 * cv.w + x1] - v[y1 * cv.w + x0]) * tx;
    return a + (b - a) * ty;
  }
  function effOpacity(el) {
    var o = 1;
    for (var i = 0; el && el !== document.body && i < 8; i++, el = el.parentElement) o *= parseFloat(getComputedStyle(el).opacity) || 0;
    return o;
  }
  /* the photos behind the logo area: found with a handful of hit tests, then measured once per frame */
  var lumCands = [];
  function findCands(r) {
    var seen = [], list = [];
    for (var j = 0; j < 3; j++) {
      for (var i = 0; i < 6; i++) {
        var stack = document.elementsFromPoint(r.left + 1 + i / 5 * (r.width - 2), r.top + 1 + j / 2 * (r.height - 2));
        for (var k = 0; k < stack.length; k++) {
          var el = stack[k];
          if (el.tagName !== 'IMG' || seen.indexOf(el) > -1 || el.closest('.site-header, .announcement, .day-bg, .hero, .video-hero__frame, .slideshow, .banner')) continue;
          seen.push(el);
          var rr = el.getBoundingClientRect(), nw = el.naturalWidth, nh = el.naturalHeight;
          if (!nw || !nh || !rr.width) continue;
          var cv = imgCanvas(el);
          if (!cv) continue;
          var fit = getComputedStyle(el).objectFit;
          list.push({ r: rr, nw: nw, nh: nh, cv: cv, op: effOpacity(el), src: el.currentSrc || el.src,
            sc: fit === 'cover' ? Math.max(rr.width / nw, rr.height / nh) : fit === 'contain' ? Math.min(rr.width / nw, rr.height / nh) : null });
        }
      }
    }
    lumCands = list;
  }
  /* brightness 0..1 of what is under screen point (x, y); null = only the light page background */
  function lumAt(x, y) {
    for (var i = 0; i < lumCands.length; i++) {
      var c = lumCands[i], r = c.r, px, py;
      if (x < r.left || x > r.right || y < r.top || y > r.bottom) continue;
      if (c.sc) { px = (x - r.left - (r.width - c.nw * c.sc) / 2) / (c.nw * c.sc); py = (y - r.top - (r.height - c.nh * c.sc) / 2) / (c.nh * c.sc); }
      else { px = (x - r.left) / r.width; py = (y - r.top) / r.height; }
      if (px < 0 || px > 1 || py < 0 || py > 1) continue;
      var l = lumSample(c.cv, px, py);
      return l * c.op + 0.88 * (1 - c.op);
    }
    return null;
  }
  /* how "dark" the banner is at point y: 1 on the photo, fading to 0 through the soft melt at its bottom */
  var heroList = null;
  /* the banner at point (x, y): how much of it is visible there (v: 1 on the photo, fading to 0 through the
     soft melt at its bottom) and how bright it actually looks there (l: its photo under its dark overlay).
     A banner whose photo cannot be read (video) counts as dark, as before. */
  var heroHit = { v: 0, l: 0 };
  function heroAt(x, y) {
    heroHit.v = 0; heroHit.l = 0;
    (heroList || []).forEach(function (h) {
      var r = h.r;
      if (heroHit.v === 1 || x < r.left || x > r.right || y < r.top || y > r.bottom) return;
      var op = h.op === undefined ? 1 : h.op, v;
      if (!h.bh || y <= r.bottom - h.bh) v = op;
      else { var t = (y - (r.bottom - h.bh)) / h.bh; t = t * t * (3 - 2 * t); v = (1 - t) * op; }
      if (v <= heroHit.v) return;
      /* the banner photo itself always counts as dark: the logo stays clean white on it, no colour play */
      var l = 0;
      /* the banner's own soft fade at its bottom ('Vervaging'), in the colour of the mode */
      if (h.fr && y >= h.fr.top && y <= h.fr.bottom && h.fr.height) {
        var ft = (y - h.fr.top) / h.fr.height * 4, fk = Math.min(3, Math.floor(ft)), fa = h.fa[fk] + (h.fa[fk + 1] - h.fa[fk]) * (ft - fk);
        fa *= h.fo;
        l = l * (1 - fa) + h.fl * fa;
      }
      heroHit.v = v; heroHit.l = l;
    });
    return heroHit;
  }
  /* box blur (twice = soft, round edge) over a w x h grid of values, radius in grid cells */
  function blurGrid(a, w, h, rad) {
    if (rad < .5) return a;
    var r = Math.round(rad), tmp = new Float32Array(a.length), out = a;
    for (var pass = 0; pass < 2; pass++) {
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var s = 0, n = 0;
          for (var k = -r; k <= r; k++) { var xx = x + k; if (xx >= 0 && xx < w) { s += out[y * w + xx]; n++; } }
          tmp[y * w + x] = s / n;
        }
      }
      var res = new Float32Array(a.length);
      for (y = 0; y < h; y++) {
        for (x = 0; x < w; x++) {
          var s2 = 0, n2 = 0;
          for (var k2 = -r; k2 <= r; k2++) { var yy = y + k2; if (yy >= 0 && yy < h) { s2 += tmp[yy * w + x]; n2++; } }
          res[y * w + x] = s2 / n2;
        }
      }
      out = res;
    }
    return out;
  }
  function initLogoOnLight() {
    if (root._logoOnLight || !qs('.logo--has-onlight')) return;
    root._logoOnLight = true;
    var gw = document.createElement('canvas'), gb = document.createElement('canvas');
    var xw = gw.getContext('2d'), xb = gb.getContext('2d'), queued = false;
    var cur = null, curW = 0, curH = 0, lastSig = '', lastScroll = -1, lastT = 0, animating = false, drawnKey = '';
    var mqMob = window.matchMedia('(max-width: 749px)'), lastLogo = null, shK = null, shLastT = 0;
    /* a shadow colour with its strength multiplied by k (0 = invisible) */
    function fadeColor(c, k) {
      var m = /rgba?\(([^)]*)\)/i.exec(c), p;
      if (m) { p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat); }
      else if (/^#/.test(c)) {
        var h = c.slice(1); if (h.length < 6) h = h.split('').map(function (q) { return q + q; }).join('');
        p = [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16), h.length >= 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1];
      } else return c;
      var a = p.length > 3 ? p[3] : 1;
      return 'rgba(' + p[0] + ',' + p[1] + ',' + p[2] + ',' + (a * k) + ')';
    }
    function num(attr, d) { var v = parseFloat(root.getAttribute(attr)); return isNaN(v) ? d : v; }
    function day() { return root.getAttribute('data-mode') === 'light' && root.getAttribute('data-funky') !== 'on'; }
    function layerCanvas(layer) {
      var cv = qs(':scope > .logo__cv', layer);
      if (!cv) { cv = document.createElement('canvas'); cv.className = 'logo__cv'; cv.setAttribute('aria-hidden', 'true'); layer.appendChild(cv); }
      return cv;
    }
    /* the logo picture with its almost-invisible pixels wiped: a faint haze around a logo would otherwise
       cast a square shadow. Also remembers where the actual artwork sits inside the picture. Made once. */
    var cleanCache = {};
    function cleanLogo(img) {
      var src = img.currentSrc || img.src;
      if (cleanCache[src]) return cleanCache[src];
      var k = Math.min(1, 900 / img.naturalWidth), c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.naturalWidth * k)); c.height = Math.max(1, Math.round(img.naturalHeight * k));
      var x = c.getContext('2d', { willReadFrequently: true }), bb = { x0: 0, y0: 0, x1: 1, y1: 1 };
      try {
        x.drawImage(img, 0, 0, c.width, c.height);
        var id = x.getImageData(0, 0, c.width, c.height), d = id.data, W = c.width, H = c.height, edge = [];
        /* a see-through layer over the whole picture (same opacity all along its border) is lifted off */
        for (var e = 0; e < W; e++) edge.push(d[e * 4 + 3], d[((H - 1) * W + e) * 4 + 3]);
        for (e = 0; e < H; e++) edge.push(d[e * W * 4 + 3], d[(e * W + W - 1) * 4 + 3]);
        edge.sort(function (p, q) { return p - q; });
        var haze = edge[edge.length >> 1]; if (haze > 160) haze = 0;
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var i = 3, p = 0; i < d.length; i += 4, p++) {
          var a = haze ? Math.max(0, (d[i] - haze) * 255 / (255 - haze)) : d[i];
          if (a < 14) a = 0;
          d[i] = a;
          if (a) { var px = p % W, py = (p / W) | 0; if (px < minX) minX = px; if (px > maxX) maxX = px; if (py < minY) minY = py; if (py > maxY) maxY = py; }
        }
        x.putImageData(id, 0, 0);
        if (maxX >= 0) bb = { x0: minX / W, y0: minY / H, x1: (maxX + 1) / W, y1: (maxY + 1) / H };
      } catch (err) { c = img; }
      return (cleanCache[src] = { c: c, bb: bb });
    }
    /* the shadow settings as the browser resolved them: "drop-shadow(0 4px 10px rgba(0, 0, 0, 0.5))" */
    function shadowOf(el) {
      var cs = getComputedStyle(el), v = (el.classList.contains('logo__layer--onlight') && cs.getPropertyValue('--lso').trim()) || cs.getPropertyValue('--ls') || '';
      var m = /drop-shadow\((.*)\)/.exec(v.trim());
      if (!m) return null;
      var body = m[1], col = (/(rgba?\([^)]*\)|#[0-9a-f]{3,8}|transparent)/i.exec(body) || [''])[0];
      var n = body.replace(col, ' ').match(/-?[\d.]+(?=px|\s|$)/g) || [];
      if (!col || col === 'transparent') return null;
      return { c: col, x: parseFloat(n[0]) || 0, y: parseFloat(n[1]) || 0, b: parseFloat(n[2]) || 0 };
    }
    var work = document.createElement('canvas');
    /* one version of the logo, cut to the parts where the mask says it belongs, with its shadow drawn
       inside the canvas itself (no CSS filter: iPhone Safari draws those as a square) */
    function drawLayer(cv, img, U, grid, layer) {
      var w = img.offsetWidth, h = img.offsetHeight, R = img.getBoundingClientRect();
      if (!w || !h || !R.width || !R.height) return false;
      var sh = shadowOf(layer), pad = sh ? Math.ceil(Math.min(80, sh.b * 3 + Math.max(Math.abs(sh.x), Math.abs(sh.y)) + 2)) : 0;
      var dpr = Math.min(3, window.devicePixelRatio || 1), bw = Math.round(w * dpr), bh = Math.round(h * dpr), pd = Math.round(pad * dpr);
      if (cv.width !== bw + 2 * pd || cv.height !== bh + 2 * pd) {
        cv.width = bw + 2 * pd; cv.height = bh + 2 * pd;
        cv.style.width = (w + 2 * pad) + 'px'; cv.style.height = (h + 2 * pad) + 'px'; cv.style.margin = (-pad) + 'px';
      }
      if (work.width !== bw || work.height !== bh) { work.width = bw; work.height = bh; }
      var wx = work.getContext('2d');
      wx.globalCompositeOperation = 'source-over';
      wx.clearRect(0, 0, bw, bh);
      /* vector logo: drawn straight from the SVG at this exact size (crisp edges); pictures: the cleaned copy */
      var isVec = /\.svg(\?|#|$)/i.test(img.currentSrc || img.src);
      try { wx.drawImage(isVec ? img : cleanLogo(img).c, 0, 0, bw, bh); } catch (e) { return false; }
      wx.globalCompositeOperation = 'destination-in';
      wx.imageSmoothingEnabled = true;
      var sx = bw / R.width, sy = bh / R.height;
      wx.drawImage(grid, (U.left - R.left) * sx, (U.top - R.top) * sy, U.width * sx, U.height * sy);
      wx.globalCompositeOperation = 'source-over';
      var x = cv.getContext('2d');
      x.clearRect(0, 0, cv.width, cv.height);
      x.save();
      /* same softness as the CSS drop-shadow in night mode: there the blur is the Gaussian's standard deviation,
         a canvas shadowBlur is twice the standard deviation */
      var shk = shK === null ? 1 : shK;
      if (sh && shk > .005) { x.shadowColor = shk < 1 ? fadeColor(sh.c, shk) : sh.c; x.shadowBlur = sh.b * 2 * dpr; x.shadowOffsetX = sh.x * dpr; x.shadowOffsetY = sh.y * dpr; }
      x.drawImage(work, pd, pd);
      x.restore();
      return true;
    }
    function off() { root.classList.remove('logo-adapt'); cur = null; lastSig = ''; drawnKey = ''; animating = false; shK = null; }
    function paint(now) {
      queued = false;
      now = now || performance.now();
      var logo = qs('.site-header__logo .logo--has-onlight');
      if (!logo || !day()) { off(); return; }
      var baseL = qs('.logo__layer--base', logo), onL = qs('.logo__layer--onlight', logo);
      var bImg = baseL && (qs('.logo__img--day', baseL) || qs('.logo__img--night', baseL)), oImg = onL && qs('.logo__img--onlight', onL);
      if (logo !== lastLogo) {
        /* a new logo (the theme editor re-draws the header on every setting change): draw it from scratch,
           again once its pictures are fully decoded, so it never stays invisible */
        lastLogo = logo; lastSig = ''; cur = null;
        [bImg, oImg].forEach(function (im) {
          if (im && im.decode) im.decode().then(function () { lastSig = ''; queue(); }, function () {});
        });
      }
      if (!bImg || !oImg || !bImg.complete || !oImg.complete || !bImg.naturalWidth || !oImg.naturalWidth) return;
      var b = bImg.getBoundingClientRect(), o = oImg.getBoundingClientRect();
      if (!b.width || !o.width) return;
      /* only the part of the pictures where the artwork actually is gets measured */
      var bb1 = cleanLogo(bImg).bb, bb2 = cleanLogo(oImg).bb;
      var L = Math.min(b.left + bb1.x0 * b.width, o.left + bb2.x0 * o.width) - 1, T = Math.min(b.top + bb1.y0 * b.height, o.top + bb2.y0 * o.height) - 1;
      var Rr = Math.max(b.left + bb1.x1 * b.width, o.left + bb2.x1 * o.width) + 1, B = Math.max(b.top + bb1.y1 * b.height, o.top + bb2.y1 * o.height) + 1;
      var U = { left: L, top: T, width: Rr - L, height: B - T };
      /* phones: the banner fades out while scrolling there; the logo follows that gradually */
      var mob = mqMob.matches;
      /* banners near the logo (photo = dark; its soft melt fades to the page) */
      heroList = [];
      qsa('.hero, .video-hero__frame, .slideshow, .banner').forEach(function (m) {
        if (!m.offsetParent) return;
        /* banner faded out above the first product (phones): the logo sits on the plain background there */
        var med = m.classList.contains('is-past') && qs('.hero__media', m), mo = med ? parseFloat(getComputedStyle(med).opacity) : 1;
        if (isNaN(mo)) mo = 1;
        /* desktop: a half-faded banner no longer counts; phones: it counts as much as it is still visible */
        if (!mob && mo < 0.5) return;
        if (mob && mo < 0.02) return;
        var mr = m.getBoundingClientRect();
        if (mr.bottom < U.top || mr.top > U.top + U.height) return;
        var hcs = getComputedStyle(m);
        /* the soft fade at the banner's bottom: where it is, its strength at 0/25/50/75/100 % and its colour */
        var hfe = qs('.hero__fade', m), hfr = null, hfa = null, hfl = 0, hfo = 0;
        if (hfe && hfe.offsetHeight && getComputedStyle(hfe).display !== 'none') {
          var fcs = getComputedStyle(hfe), frgb = (fcs.getPropertyValue('--fade-rgb') || '0,0,0').split(',').map(parseFloat);
          hfr = hfe.getBoundingClientRect(); hfo = parseFloat(fcs.opacity) || 0; /* the banner's own fading is already in 'op' */
          hfa = [0, 1, 2, 3, 4].map(function (k) { return k ? (parseFloat(fcs.getPropertyValue('--fade-a' + k)) || 0) : 0; });
          hfl = (0.2126 * (frgb[0] || 0) + 0.7152 * (frgb[1] || 0) + 0.0722 * (frgb[2] || 0)) / 255;
        }
        heroList.push({ r: mr, op: mob ? mo : 1, bh: mr.height * (parseFloat(hcs.getPropertyValue('--hero-blend')) || 0) / 100,
          fr: hfr, fa: hfa, fl: hfl, fo: hfo });
      });
      findCands(U);
      var soft = num('data-la-soft', 1), point = num('data-la-point', 50) / 100, fade = num('data-la-fade', 150);
      /* nothing moved behind the logo and no fade running: nothing to do */
      var sig = [Math.round(U.left * 2), Math.round(U.top * 2), Math.round(U.width * 2), Math.round(U.height * 2), soft, point,
        bImg.currentSrc || bImg.src, oImg.currentSrc || oImg.src, window.devicePixelRatio,
        getComputedStyle(baseL).getPropertyValue('--ls'), getComputedStyle(onL).getPropertyValue('--lso')].join(',');
      lumCands.forEach(function (c) { sig += '|' + Math.round(c.r.left * 2) + ',' + Math.round(c.r.top * 2) + ',' + Math.round(c.r.width) + ',' + c.op.toFixed(3) + ',' + c.src; });
      heroList.forEach(function (h) { sig += '|h' + Math.round(h.r.top * 2) + ',' + Math.round(h.r.bottom * 2) + ',' + h.op.toFixed(2); });
      if (sig === lastSig && !animating && root.classList.contains('logo-adapt')) { lumCands = []; return; }
      lastSig = sig;
      /* about one measurement per screen pixel of the logo */
      var MW = Math.max(8, Math.min(220, Math.round(U.width))), MH = Math.max(4, Math.min(110, Math.round(U.height)));
      var tgt = new Float32Array(MW * MH), lo = point - .07, i, j, onTile = 0;
      for (j = 0; j < MH; j++) {
        var y = U.top + (j + .5) / MH * U.height;
        for (i = 0; i < MW; i++) {
          var x = U.left + (i + .5) / MW * U.width, hh = heroAt(x, y), hd = hh.v, w;
          var l0 = lumAt(x, y);
          if (l0 !== null && hd < .5) onTile++; /* a product photo behind this part of the logo */
          if (l0 === null) l0 = .88;
          /* the banner as bright as it really looks (photo + overlay), melting into what is behind it */
          var l = l0 * (1 - hd) + hh.l * hd;
          /* light text on dark, dark text on light */
          var t = Math.min(1, Math.max(0, (l - lo) / .14)); t = t * t * (3 - 2 * t);
          w = 1 - t;
          tgt[j * MW + i] = w;
        }
      }
      /* shadow: gone while the logo is over a product photo, back (softly) everywhere else */
      var shT = 1 - Math.min(1, (onTile / (MW * MH)) / .25);
      lumCands = [];
      tgt = blurGrid(tgt, MW, MH, soft * MW / U.width);
      /* scrolling: the edge simply follows the page. Something changing in place (a swipe): soft fade.
         Phones work exactly like desktop (same settings, same flowing edge). */
      var sy = window.scrollY, scrolled = sy !== lastScroll, dt = animating ? Math.min(100, now - (lastT || now)) : 16;
      lastScroll = sy; lastT = now;
      animating = false;
      if (!cur || curW !== MW || curH !== MH || scrolled || fade <= 0 || !root.classList.contains('logo-adapt')) { cur = tgt; curW = MW; curH = MH; }
      else {
        var kf = 1 - Math.exp(-dt / Math.max(1, fade / 3)), maxd = 0;
        for (i = 0; i < cur.length; i++) { var dd = tgt[i] - cur[i]; cur[i] += dd * kf; if (Math.abs(dd) > maxd) maxd = Math.abs(dd); }
        if (maxd > .01) animating = true; else cur = tgt;
      }
      /* shadow fades out over a product photo and back in after it (about 0.3 s) */
      var sdt = Math.min(100, Math.max(0, now - (shLastT || now))) || 16;
      shLastT = now;
      if (shK === null || !root.classList.contains('logo-adapt')) shK = shT;
      else shK += (shT - shK) * (1 - Math.exp(-sdt / 100));
      if (Math.abs(shT - shK) > .01) animating = true; else shK = shT;
      if (gw.width !== MW || gw.height !== MH) { gw.width = gb.width = MW; gw.height = gb.height = MH; }
      var iw = xw.createImageData(MW, MH), ib = xb.createImageData(MW, MH);
      for (i = 0; i < cur.length; i++) { var a = Math.round(cur[i] * 255); iw.data[i * 4 + 3] = a; ib.data[i * 4 + 3] = 255 - a; }
      xw.putImageData(iw, 0, 0); xb.putImageData(ib, 0, 0);
      if (!drawLayer(layerCanvas(baseL), bImg, U, gw, baseL) || !drawLayer(layerCanvas(onL), oImg, U, gb, onL)) { off(); return; }
      root.classList.add('logo-adapt');
      if (animating) queue();
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', debounce(queue, 60));
    document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') { lastSig = ''; queue(); } }, true);
    new MutationObserver(queue).observe(root, { attributes: true, attributeFilter: ['data-mode', 'data-funky'] });
    document.addEventListener('shopify:section:load', function () { lastSig = ''; queue(); });
    /* carousels, feed transitions and swipes move things behind the logo without scrolling */
    setInterval(function () { if (!document.hidden && day()) queue(); }, 100);
    paint();
  }

  /* ---------- Focus ring only while navigating with the keyboard (Tab) ---------- */
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') root.classList.add('kbd-nav'); }, true);
  document.addEventListener('pointerdown', function () { root.classList.remove('kbd-nav'); }, true);

  /* ---------- Init ---------- */
  function init(ctx) {
    initMode();
    initViewToggle();
    initBack();
    initAnnouncement();
    initCarousels(ctx);
    initRails(ctx);
    initFeeds(ctx);
    initProducts(ctx);
    initRecommendations(ctx);
    initRecentlyViewed(ctx);
    initTrust();
    initCardFit();
    initLocalization(ctx);
    initCartTimer();
    initUpsell();
    liftCards();
    initQuotesCar(ctx);
    initStorySig(ctx);
    initProductMarquee(ctx);
    initSlideshows(ctx);
    initCountdowns(ctx);
    initSizeCharts(ctx);
    initPredictive();
    initEnterPage();
    initSignups();
    initPopup();
    initFunkyLiquid();
    initSnapZone();
    initTouchSnap();
    initGridCenter();
    initDayBg();
    initLogoOnLight();
    qsa('img.logo__img', ctx).forEach(dehazeLogo);
    initAutoFit(ctx);
    initModeHint();
    initPanelGrow(ctx);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor: the preview follows the slider you move (feed sliders -> feed view, grid sliders -> grid view) */
  var FEED_VARS = ['feed-img-h','feed-top','feed-bottom','feed-side','feed-info-gap','feed-title-size','feed-price-size','feed-img-h-m','feed-img-w-m','feed-title-size-m','feed-price-size-m','feed-slide-h'];
  var GRID_VARS = ['grid-top','grid-bottom','grid-side','grid-side-m','grid-gap-x','grid-gap-y','grid-img','grid-title-size','grid-price-size','grid-title-size-m','grid-price-size-m','grid-cols','grid-cols-m','grid-ratio','grid-img-pos','after-hero-gap'];
  function parseVars(str) {
    var out = {};
    (str || '').split(';').forEach(function (p) { var i = p.indexOf(':'); if (i > 0) out[p.slice(0, i).trim().replace(/^--/, '')] = p.slice(i + 1).trim(); });
    return out;
  }
  function changedKind(a, b) {
    var feed = false, grid = false;
    FEED_VARS.forEach(function (k) { if ((a[k] || '') !== (b[k] || '')) feed = true; });
    GRID_VARS.forEach(function (k) { if ((a[k] || '') !== (b[k] || '')) grid = true; });
    if (feed && !grid) return 'feed';
    if (grid && !feed) return 'grid';
    return null;
  }
  function editorShowView(kind, feedRoot) {
    if (!kind) return;
    var wantGrid = kind === 'grid';
    if (root.classList.contains('view-grid') !== wantGrid) {
      root.classList.toggle('view-grid', wantGrid);
      store('borba-view', wantGrid ? 'grid' : 'feed');
    }
    feedRoot = feedRoot || qs('[data-feed-root]');
    if (!feedRoot) return;
    requestAnimationFrame(function () {
      var r = feedRoot.getBoundingClientRect();
      if (r.bottom < 80 || r.top > window.innerHeight * 0.6) {
        var target = wantGrid ? feedRoot : (qs('.slide', feedRoot) || feedRoot);
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY, behavior: 'auto' });
        measureFeedInfo(feedRoot);
      }
    });
  }
  if (B.designMode) {
    var editorStyles = {};
    document.addEventListener('shopify:section:unload', function (e) {
      var fr = e.target && qs('[data-feed-root]', e.target);
      if (fr) editorStyles[e.detail.sectionId] = fr.getAttribute('style') || '';
    });
    document.addEventListener('shopify:section:load', function (e) {
      var fr = e.target && qs('[data-feed-root]', e.target);
      var before = editorStyles[e.detail.sectionId];
      if (!fr || before == null) return;
      editorShowView(changedKind(parseVars(before), parseVars(fr.getAttribute('style') || '')), fr);
    });
    /* theme settings (Feed en grid) reload the whole preview: compare with the previous values */
    (function () {
      var cs = getComputedStyle(root), now = {};
      FEED_VARS.concat(GRID_VARS).forEach(function (k) { now[k] = cs.getPropertyValue('--' + k).trim(); });
      var prev = null;
      try { prev = JSON.parse(sessionStorage.getItem('borba-editor-vars') || 'null'); } catch (e) {}
      try { sessionStorage.setItem('borba-editor-vars', JSON.stringify(now)); } catch (e) {}
      if (prev) {
        var kind = changedKind(prev, now);
        if (kind) {
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { editorShowView(kind); });
          else editorShowView(kind);
        }
      }
    })();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var popup = qs('[data-email-popup]', e.target);
    if (popup) openModal(popup);
    var enter = qs('[data-enter-page]', e.target);
    if (enter) { root.classList.remove('enter-done', 'enter-skip'); root.classList.add('has-enter'); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var popup = qs('[data-email-popup]', e.target);
    if (popup) closeModal(popup);
  });

  window.BORBA.addToCart = addToCart;
  window.BORBA.formatMoney = formatMoney;
  /* the music player loads pages "silently" (so the music keeps playing): it calls this on the new content */
  window.BORBA.init = init;
})();

/* Add to cart-knop, effect "Golf": split the button text into letters (again whenever the text changes, e.g. "Added") */
(function () {
  function split(el) {
    if (!el || el.querySelector('.atc-ch')) return;
    var txt = el.textContent.replace(/\s+/g, ' ').trim();
    if (!txt) return;
    el.setAttribute('aria-label', txt);
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(txt, function (ch, i) {
      var s = document.createElement('span');
      s.className = 'atc-ch'; s.setAttribute('aria-hidden', 'true');
      s.style.setProperty('--i', i); s.textContent = ch;
      frag.appendChild(s);
    });
    el.textContent = ''; el.appendChild(frag);
  }
  function init() {
    document.querySelectorAll('.btn--atc.fx-t-wave').forEach(function (btn) {
      if (btn.dataset.waveInit) return; btn.dataset.waveInit = '1';
      var parts = btn.querySelectorAll('[data-atc-label], .btn__price');
      parts.forEach(split);
      var mo = new MutationObserver(function () {
        mo.disconnect();
        parts.forEach(function (el) { if (!el.querySelector('.atc-ch')) { el.removeAttribute('aria-label'); split(el); } });
        parts.forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
      });
      parts.forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
